import { Component } from "react";
import { createPortal } from "react-dom";
import { formatChapterName } from '../../../utils/formatChapterName';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import VisitorHeader from "../../../common_components/visitor_module_header";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action'
import { attendeeTypeActionId, cityActionId, countryActionId, countryIWithCodeActionId, exhibitorBadgeDaysActionId, pincodeActionId, visitorTypeListActionId, stateActionId, toastError, GSTvalidationActionId, visitPurposeActionId, seminarInterestActionId, companyTurnOverActionId, exhibitionStatusActionId, toastSuccess, industryChaptersActionId, genderActionId, BASE_URL, AccountTypeActionId, primaryChapterListActionId, B2BTimeslotActionID, visitorInterestActionId } from "../../../utils/constants";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import { data } from "jquery";
import { getVistiorRegistarionDetails_action, visitorRegistrationNext_action, verifyVisitorEmail_action, visitorRegistrationGroupNext_action, delVisaDoc_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import Resizer from "react-image-file-resizer";
import Modal from 'react-bootstrap/Modal';
import { emailValidator, gstNoValidator, panNoValidator } from "../../../utils/Validator";
import DatePicker from "react-datepicker";
import { Tab, Nav, ToggleButton, ButtonGroup, ListGroup, Container, Row, Stack, Dropdown, Form } from "react-bootstrap";
import { delegateRegistrationGroupNext_action, getDelegateFirldList_action, getDelegateDetails_action, getDelegateDetailsUUID_action, deleteDelegate_action, delegateRegistrationNext_action, deleteVisaDoc_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action"
import moment from "moment";
import { getExhibitionProgramMaster_action } from "../../../actions/admin_module_action/delegate_master_action/delegate_program_action"

export class DelegateRegistration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            isOpen2: false,
            isOpen3: false,
            isOpen4: false,
            showFieldList: [],
            DelegateRegistrationID: '',
            modalID: '',
            AccountTypeID: '',
            AccountID: '',
            DelegateRegistrationNo: '',
            DelegateRegistrationIDModal: '',
            AccountTypeIDModal: '',
            AccountIDModal: '',
            DelegateRegistrationNoModal: '',
            onCrossClickFlagCoordinator: true,
            isExhbitionClosed: false,
            isDataLoad: false,
            isOtherPreName: false,
            otherName: '',
            firstName: '',
            firstNameErr: '',
            prename: 'Mr',
            lastName: '',
            lastNameErr: '',
            countryIdErr: '',
            countryId: '',
            countryList: [],
            genderErr: '',
            preMobNo: '+91',
            preWhatsAppMobNo: '+91',
            stateList: [],
            tempStateList: [],
            cityList: [],
            tempCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            genderList: [],
            gender: '',
            designation: '',
            designationErr: '',
            institute: '',
            instituteErr: '',
            IECCode: '',
            IECCodeErr: '',
            Address1: '',
            Address2: '',
            Address3: '',
            Address1Err: '',
            pincode: '',
            isDisplayPincodeList: false,
            pincodeErr: '',
            regState: '',
            regStateErr: '',
            isDisplayStateList: false,
            city: '',
            cityErr: '',
            isDisplayCityList: false,
            email: '',
            emailErr: '',
            mobNo: '',
            mobNoErr: '',
            whatsAppMobNo: '',
            whatsAppMobNoErr: '',
            isSameAsMobNo: false,
            website: '',
            telNo: '',
            preTelNo: '',
            tel1No: '',
            preTel1No: '',
            compInfoGstNo: '',
            compInfoGstNoErr: '',
            stateName: '',
            stateId: '',
            compInfoPanNoErr: '',
            compInfoPanNo: '',
            gstValidtionList: [],
            chapterList: [],
            visitorTypeList: [],
            visitorTypeErr: '',
            VisitorTypeID: '',
            chapterErr: '',
            other: '',
            isOtherOpen: false,
            visitPurposeErr: '',
            visitPurposeList: [],
            interestList: [],
            isInterestTwo: false,
            isInterstOne: false,
            daysList: [],
            isExhibitionFree: false,
            arrivalDate: '',
            arrivalDateErr: '',
            departureDate: '',
            departureDateErr: '',
            IsCoordinator: false,
            isCoordinatorAsDelegate: false,
            companyProfile: '',
            PersonPhoto: '',
            PersonPhotoPreview: '',
            PersonPhotoName: '',
            PersonPhotoData: '',
            PersonPhotoType: '',
            PersonProfile: '',
            companywebsite: '',
            totalYears: '',
            turnOverList: [],
            turnOverId: '',
            turnOverErr: '',
            totalYearsErr: '',
            companyProfileErr: '',
            PersonPhotoErr: '',
            PersonProfileErr: '',
            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],
            ChapterHallErr: '',
            B2bMeetingList: [],
            b2bErr: '',
            needVisaAssistance: false,
            passName: '',
            passNameErr: '',
            applicantMobNo: '',
            applicantMobNoErr: '',
            preApplicantMobNo: '',
            applicantEmail: '',
            applicantEmailErr: '',
            passNo: '',
            passNoErr: '',
            passDate: '',
            passDateErr: '',
            passExipryDate: '',
            passExipryDateErr: '',
            passCountryErr: '',
            passCountry: '',
            isPassportFilePresent: false,
            isVisaApplied: false,
            passportFileErr: '',
            passportFile: '',
            passPortFileName: '',
            passportFilePath: '',
            passportFileType: '',
            SeminarErr: '',
            Address2Err: '',
            Address3Err: '',
            websiteErr: '',
            telephoneErr: '',
            telephone1Err: '',
            companyWebsiteErr: '',
            Address2ErrModal: '',
            Address3ErrModal: '',
            websiteErrModal: '',
            telephoneErrModal: '',
            telephone1ErrModal: '',
            companyWebsiteErrModal: '',
            deleteID: '',
            visaErr: '',
            visaErrModal: '',
            seminarInterestList: [],
            interestListModal: [],
            isInterestTwoModal: false,
            isInterstOneModal: false,
            daysListModal: [],
            isModalEdit: false,
            GroupDetailsList: [],
            isOtherPreNameModal: false,
            otherNameModal: '',
            firstNameModal: '',
            firstNameErrModal: '',
            prenameModal: 'Mr',
            lastNameModal: '',
            lastNameErrModal: '',
            countryIdErrModal: '',
            countryIdModal: '',
            countryListModal: [],
            genderErrModal: '',
            preMobNoModal: '+91',
            preWhatsAppMobNoModal: '+91',
            stateListModal: [],
            tempStateListModal: [],
            cityListModal: [],
            tempCityListModal: [],
            pincodeListModal: [],
            tempPincodeListModal: [],
            seminarInterestListModal: [],
            genderListModal: [],
            genderModal: '',
            designationModal: '',
            designationErrModal: '',
            instituteModal: '',
            instituteErrModal: '',
            IECCodeModal: '',
            IECCodeErrModal: '',
            Address1Modal: '',
            Address2Modal: '',
            Address3Modal: '',
            Address1ErrModal: '',
            pincodeModal: '',
            isDisplayPincodeListModal: false,
            pincodeErrModal: '',
            regStateModal: '',
            regStateErrModal: '',
            isDisplayStateListModal: false,
            cityModal: '',
            cityErrModal: '',
            isDisplayCityListModal: false,
            emailModal: '',
            emailErrModal: '',
            mobNoModal: '',
            mobNoErrModal: '',
            whatsAppMobNoModal: '',
            whatsAppMobNoErrModal: '',
            isSameAsMobNoModal: false,
            websiteModal: '',
            telNoModal: '',
            preTelNoModal: '',
            tel1NoModal: '',
            preTel1NoModal: '',
            compInfoGstNoModal: '',
            compInfoGstNoErrModal: '',
            stateIdModal: '',
            stateNameModal: '',
            compInfoPanNoErrModal: '',
            visitPurposeErrModal: '',
            compInfoPanNoModal: '',
            chapterErrModal: '',
            chapterListModal: [],
            isOtherOpenModal: false,
            otherModal: '',
            seminarInterestListModal: [],
            companyProfileModal: '',
            companywebsiteModal: '',
            totalYearsModal: '',
            turnOverListModal: [],
            visitPurposeListModal: [],
            turnOverIdModal: '',
            turnOverErrModal: '',
            totalYearsErrModal: '',
            companyProfileErrModal: '',
            isFirst: true,
            arrivalDateModal: '',
            arrivalDateErrModal: '',
            departureDateModal: '',
            departureDateErrModal: '',
            daysErr: '',
            daysErrModal: '',
            ChapterHallErrModal: '',
            primaryChapterListDataModal: [],
            level0Modal: [],
            level2Modal: [],
            level3Modal: [],
            level4Modal: [],
            primaryChapterListLevel3Modal: [],
            primaryChapterListLevel4Modal: [],
            B2bMeetingListmodal: [],
            b2bErrModal: '',
            SeminarErrModal: '',
            needVisaAssistanceModal: false,
            passNameModal: '',
            passNameErrModal: '',
            applicantMobNoModal: '',
            applicantMobNoErrModal: '',
            preApplicantMobNoModal: '',
            applicantEmailModal: '',
            applicantEmailErrModal: '',
            passNoModal: '',
            passNoErrModal: '',
            passDateModal: '',
            passDateErrModal: '',
            passExipryDateModal: '',
            passExipryDateErrModal: '',
            passCountryErrModal: '',
            passCountryModal: '',
            isPassportFilePresentModal: false,
            isVisaAppliedModal: false,
            passportFileErrModal: '',
            passportFileModal: '',
            passPortFileNameModal: '',
            passportFilePathModal: '',
            passportFileTypeModal: '',
            PersonProfileModal: '',
            PersonProfileModalErr: '',
            PersonPhotoModal: '',
            PersonPhotoModalErr: '',
            PersonPhotoDataModal: '',
            PersonPhotoNameModal: '',
            PersonPhotoTypeModal: '',
            PersonPhotoPreviewModal: '',

            tempGroupPincodeList: [],
            tempGroupCityList: [],
            tempGroupStateList: [],
            delegateUUID: '',
            accountTypeList: [],
            AccountTypeIDErr: '',
            isLinkOpen: true,
            onJustSubmit: false,

            isOpenDropDownState: false,
            focusedIndexState: -1,
            isOpenDropDownStateModal: false,
            focusedIndexStateModal: -1,

            isOpenDropDownCity: false,
            focusedIndexCity: -1,
            isOpenDropDownCityModal: false,
            focusedIndexCityModal: -1,

            isOpenDropDownPin: false,
            focusedIndexPin: -1,
            isOpenDropDownPinModal: false,
            focusedIndexPinModal: -1,

            agreeTerms: '',
            agreeTermsErr: '',
            delegateIndex: '',
            HTMLEDITOR: '',
            HtmlContent: '',
            programList: [],
            Source: '',
        }

        this.onPreviousClick = this.onPreviousClick.bind(this)
        this.onCountrySelect = this.onCountrySelect.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.verifyEmail = this.verifyEmail.bind(this)
        this.onSameAsMobNoClick = this.onSameAsMobNoClick.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.onSelectPrimaryChapter = this.onSelectPrimaryChapter.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.onSelectPurpose = this.onSelectPurpose.bind(this)
        this.toggleModel = this.toggleModel.bind(this)
        this.otherDetailChange = this.otherDetailChange.bind(this)
        this.renderGroupList = this.renderGroupList.bind(this)
        this.renderGroupPincodeList = this.renderGroupPincodeList.bind(this)
        this.renderGroupStateList = this.renderGroupStateList.bind(this)
        this.callStateListModal = this.callStateListModal.bind(this)
        this.renderGroupCityList = this.renderGroupCityList.bind(this)
        this.callStateList = this.callStateList.bind(this)
        this.onCheckedSeminar = this.onCheckedSeminar.bind(this)
        this.onSelectInterest = this.onSelectInterest.bind(this)
        this.toggleModel1 = this.toggleModel1.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.recordTwo = this.recordTwo.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordThree = this.recordThree.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleDeleteAdded = this.handleDeleteAdded.bind(this)
        this.handleEditGroupDetail = this.handleEditGroupDetail.bind(this)
        this.getRegistrationDetails = this.getRegistrationDetails.bind(this)
        this.handleSubmitIndividual = this.handleSubmitIndividual.bind(this)
        this.handleCancelModel = this.handleCancelModel.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleDeleteDelegate = this.handleDeleteDelegate.bind(this)
        this.getFieldList = this.getFieldList.bind(this)
        this.onAccountTypeChange = this.onAccountTypeChange.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.showMandatoryFields = this.showMandatoryFields.bind(this)

    }

    async componentDidMount() {
        window.scrollTo(0, 0);

        const isLinkOpen = JSON.parse(sessionStorage.getItem('isLinkOpen')) || false;
        this.setState({ isLinkOpen });

        const sessionExhibitionID = sessionStorage.getItem('sessionExhibitionID');
        const delegateDataSS = JSON.parse(sessionStorage.getItem("DelegateDataSS"));
        let exhCode = '';
        let delegateUUID = '';
        if (sessionStorage.getItem('sessionExhibitionID')) {

            console.log(sessionStorage.getItem('sessionExhibitionID'), 'sessionStorage.getItem()')
            this.getExhibitionProgramMaster(sessionStorage.getItem('sessionExhibitionID'))
        }
        if (this.props.location) {
            const { pathname, state } = this.props.location;

            console.log(sessionStorage.getItem('AccountTypeID'))
            if (state?.is_previous) {
                await this.loadCommonLists(sessionExhibitionID);
                await this.getFieldList(sessionStorage.getItem('DelegateTypeID') || 10);
                await this.getRegistrationDetails();
            } else {
                const pathSegments = pathname?.split("/") || [];
                exhCode = pathSegments.length === 3 ? pathSegments[2] : '';

                if (pathname.includes('&')) {
                    const parts = pathname.split('&');
                    delegateUUID = parts[1];
                    if (sessionStorage.getItem('sessionExhibitionID')) {
                        this.getFieldList(10)
                    }
                    if (delegateUUID) {
                        await this.getRegistrationDetailsUUID(delegateUUID);
                        setTimeout(async () => {
                            await this.getFieldList(sessionStorage.getItem('DelegateTypeID'));
                            await this.getRegistrationDetails();
                        }, 50);
                        this.setState({
                            AccountTypeID: sessionStorage.getItem('DelegateTypeID'),
                            AccountTypeIDModal: sessionStorage.getItem('DelegateTypeID'),
                            VisitorTypeID: '',
                            isLinkOpen: true,
                            delegateUUID: delegateUUID
                        });
                        // sessionStorage.setItem('AccountTypeID', 10)
                        sessionStorage.setItem("isLinkOpen", true);
                    }
                } else if (exhCode !== '') {
                    console.log(exhCode.split('%C2%A7'))
                    if (!delegateDataSS) {
                        this.setState({
                            AccountTypeID: exhCode.split('%C2%A7').length > 1 ? exhCode.split('%C2%A7')[1] : 10,
                            AccountTypeIDModal: exhCode.split('%C2%A7').length > 1 ? exhCode.split('%C2%A7')[1] : 10,
                            VisitorTypeID: '',
                            isLinkOpen: true
                        });
                        sessionStorage.setItem('AccountTypeID', exhCode.split('%C2%A7').length > 1 ? exhCode.split('%C2%A7')[1] : 10)
                        sessionStorage.setItem("isLinkOpen", true);
                    }

                    await this.getFillList(countryIWithCodeActionId, '', '', '', exhCode.split('%C2%A7')[0], '').then(async () => {
                        await this.getFillList(exhibitionStatusActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
                        await this.loadCommonLists(sessionStorage.getItem("sessionExhibitionID"));
                        await this.getFieldList(exhCode.split('%C2%A7').length > 1 ? exhCode.split('%C2%A7')[1] : 10);
                    })
                } else {
                    if (!delegateDataSS) {
                        this.setState({
                            AccountTypeID: '',
                            AccountTypeIDModal: '',
                            VisitorTypeID: '',
                            isLinkOpen: false
                        });
                        sessionStorage.setItem('AccountTypeID', null)
                        sessionStorage.setItem("isLinkOpen", false);
                        console.log(11111)
                    }
                    sessionStorage.removeItem('AccountTypeID')
                    sessionStorage.removeItem('DelegateDataSS')
                    sessionStorage.removeItem('DelegateTypeID')
                    sessionStorage.removeItem('delegateShowName')
                    // sessionStorage.setItem('AccountTypeID', null)

                    console.log(2222222)
                    const statusRes = await this.getFillList(exhibitionStatusActionId, sessionExhibitionID, '', '', '', '');
                    await this.getFillList(countryIWithCodeActionId, '', '', '', statusRes, '').then(async () => {
                        await this.loadCommonLists(sessionExhibitionID);
                    })
                }
            }
        }

    }


    async loadCommonLists(sessionExhibitionID) {
        await this.getFillList(countryActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(AccountTypeActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(visitorInterestActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(primaryChapterListActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(B2BTimeslotActionID, sessionExhibitionID, '', '', '', '');
        await this.getFillList(exhibitorBadgeDaysActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(genderActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(seminarInterestActionId, sessionExhibitionID, '', 3, '', '');
        await this.getFillList(companyTurnOverActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(visitPurposeActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(GSTvalidationActionId, sessionExhibitionID, '', '', '', '');
        await this.getFillList(industryChaptersActionId, sessionExhibitionID, "", "", "", "");
        await this.getFillList(visitorTypeListActionId, sessionExhibitionID, "", "", "", "");
    }

    getExhibitionProgramMaster(exhCode) {
        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            console.log(exhCode, 'chapterIDArr')
            this.props
                .getExhibitionProgramMaster_action(exhCode)
                .then((data) => {
                    console.log(exhCode, 'chapterIDArr2')
                    if (data.error != 1 && data.data != null && data.data.length > 0) {
                        const [programs, dates, categories] = data.data;
                        programs.map((program, index) => {
                            var temppath = program.InvitationCard
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            program.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            // data.data[0][0].DocumentType = ''
                            // data.data[0][0].DocumentFile = ''
                            program.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            // setTimeout(() => {

                        })
                        setTimeout(() => {
                            const result = dates.map((date, index) => {
                                const program = programs.find(
                                    program => program.ExhProgramID === date.ExhProgramID
                                );

                                const firstIndex = dates.findIndex(
                                    item => item.ExhProgramID === date.ExhProgramID
                                );

                                const rowspan = dates.filter(
                                    item => item.ExhProgramID === date.ExhProgramID
                                ).length;

                                const dateCategories = categories
                                    .filter(
                                        category =>
                                            category.ExhProgramDateID === date.ExhProgramDateID
                                    )
                                    .map(category => ({
                                        ...category,
                                        isSelect: false
                                    }));
                                console.log(program, 'programprogram')
                                return {
                                    ExhProgramID: program.ExhProgramID,
                                    ExhibitionID: program.ExhibitionID,
                                    ProgramName: program.ProgramName,
                                    Location: program.Location,
                                    IsActive: program.IsActive,
                                    DocumentName: program.DocumentName,
                                    DocumentPath: program.DocumentPath,
                                    isSelect: false,
                                    toShow: index === firstIndex,
                                    rowspan,

                                    ExhProgramDateID: date.ExhProgramDateID,

                                    // Date → 17/08/2026
                                    Date: moment(date.Date).format("DD/MM/YYYY"),

                                    Days: date.Days,

                                    // Time → 10:00
                                    StartTime: moment(date.StartTime).format("HH:mm"),
                                    EndTime: moment(date.EndTime).format("HH:mm"),

                                    catogary: dateCategories
                                };
                            });

                            console.log('resultresultresult', result)
                            this.setState({ programList: result });
                        }, 100);

                        resolve(true)
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getRegistrationDetails() {
        const { GroupDetailsList, programList, primaryChapterListData, primaryChapterListDataModal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal,
            chapterList, chapterListModal, visitPurposeList, visitPurposeListModal,
            daysList, daysListModal, B2bMeetingListmodal, B2bMeetingList, PersonPhoto, PersonProfile } = this.state
        this.setState({ isLoading: true })
        this.props.getDelegateDetails_action(sessionStorage.getItem('DelegateTypeID'))
            .then((data) => {
                if (data && data.error != 1) {
                    if (data.data[0].length > 1) {
                        data.data[0].map((item) => {

                            var daysArr = []
                            var selectedDaysList = data.data[1] != null ? data.data[1] : []
                            daysListModal.length > 0 && daysListModal.map((element) => {
                                selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                            element.visitDay = element.VisitDate
                                            daysArr.push(element)
                                        }
                                    }
                                })
                            })

                            var chapterListSelected = []
                            var selectedChapters = data.data[2] != null ? data.data[2] : []
                            chapterListModal.length > 0 && chapterListModal.map((element) => {
                                selectedChapters.length > 0 && selectedChapters.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                            element.ChapterID = element.IndustrySegmentID
                                            element.ChapterName = element['Industrial Segment']
                                            chapterListSelected.push(element)
                                        }
                                    }
                                })
                            })

                            var purposeOfVisit = []
                            var selectedPurposeOfVisit = data.data[4] != null ? data.data[4] : []
                            visitPurposeListModal.length > 0 && visitPurposeListModal.map((element) => {
                                selectedPurposeOfVisit.length > 0 && selectedPurposeOfVisit.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                            if (element2.PurposeofVisitID == 10) {
                                                element.otherDetail = element2.OtherNames
                                            }
                                            purposeOfVisit.push(element)
                                        }
                                    }
                                })
                            })

                            var hallList = []
                            var SelectedHallChapters = data.data[3] != null ? data.data[3] : []
                            primaryChapterListDataModal.length > 0 && primaryChapterListDataModal.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level2Modal.length > 0 && level2Modal.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level3Modal.length > 0 && level3Modal.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level4Modal.length > 0 && level4Modal.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })


                            var seminarListSelected = []
                            var selectedseminarList = data.data[5] != null ? data.data[5] : []

                            seminarInterestListModal.length > 0 && seminarInterestListModal.map((element) => {
                                selectedseminarList.length > 0 && selectedseminarList.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.SeminarID == element.SeminarID) {
                                            seminarListSelected.push(element)
                                        }
                                    }
                                })
                            })

                            var B2bListSelected = []
                            if (!item.IsCoordinator) {

                                var selectedB2bList = data.data[6] != null ? data.data[6] : []
                                B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map((element) => {
                                    element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                                        selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                                            if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                                    inElement.isSelect = true
                                                    inElement.IsBooked = false
                                                    B2bListSelected.push({ B2BTimeSlotID: inElement.B2BTimeSlotID })
                                                }
                                            }
                                        })
                                    })
                                })
                            }


                            var mob1 = item['MobileNo']
                            const parts = mob1 != null ? mob1.split("-") : ''
                            const Mob1Code = parts.length == 2 ? parts[0] : '+91'
                            const Mob1No = parts.length == 2 ? parts[1] : mob1
                            var mob2 = item['WhatsappMobileNo']
                            const parts2 = mob2 != null ? mob2.split("-") : ''
                            const Mob2Code = parts2.length == 2 ? parts2[0] : '+91'
                            const Mob2No = parts2.length == 2 ? parts2[1] : mob2
                            var mob5 = item['ApplicantMobileNo']
                            const parts5 = mob5 != null ? mob5.split("-") : ''
                            const Mob5Code = parts5.length == 2 ? parts5[0] : ''
                            const Mob5No = parts5.length == 2 ? parts5[1] : mob5
                            var tel = item['Telephone']
                            const parts3 = tel != null ? tel.split("-") : ''
                            const telCode = parts3.length == 2 ? parts3[0] : ''
                            const telNumber = parts3.length == 2 ? parts3[1] : tel
                            var tel1 = item['Telephone1']
                            const parts4 = tel1 != null ? tel1.split("-") : ''
                            const tel1Code = parts4.length == 2 ? parts4[0] : ''
                            const tel1Number = parts4.length == 2 ? parts4[1] : tel1
                            var filePath = item.PassportFilePath != null ? item['PassportFilePath'] : ''
                            var array = item['PassportFilePath'] != null && item['PassportFilePath'] != "" && filePath.split("/")
                            const FileName = array[array.length - 1]
                            var obj = {
                                'DelegateRegistrationID': item.DelegateRegistrationID ? item.DelegateRegistrationID : '',
                                'AccountTypeID': item.AccountTypeID ? item.AccountTypeID : '',
                                'AccountID': item.AccountID ? item.AccountID : '',
                                'DelegateRegistrationNo': item.DelegateRegistrationNo ? item.DelegateRegistrationNo : '',
                                'Title': item.PersonIncharge_Title ? item.PersonIncharge_Title : '',
                                'firstName': item.PersonIncharge_FirstName ? item.PersonIncharge_FirstName : '',
                                'lastName': item.PersonIncharge_LastName ? item.PersonIncharge_LastName : '',
                                'gender': item.PersonIncharge_GenderID ? item.PersonIncharge_GenderID : '',
                                'designation': item.PersonIncharge_Designation ? item.PersonIncharge_Designation : '',
                                'CompanyName': item.CompanyName ? item.CompanyName : '',
                                'GSTNo': item.GSTNo ? item.GSTNo : '',
                                'PanNo': item.PanNo ? item.PanNo : '',
                                'IECCode': item.IECCode ? item.IECCode : '',
                                'Address1': item.Address1 ? item.Address1 : '',
                                'Address2': item.Address2 ? item.Address2 : '',
                                'Address3': item.Address3 ? item.Address3 : '',
                                'City': item.City ? item.City : '',
                                'State': item.State ? item.State : '',
                                'Pin': item.Pin ? item.Pin : '',
                                'PrimaryEmail': item.PrimaryEmail ? item.PrimaryEmail : '',
                                'Website': item.Website ? item.Website : '',
                                'Telephone': telNumber ? telCode ? `${telCode}-${telNumber}` : telNumber : '',
                                'Telephone1': tel1Number ? tel1Code ? `${tel1Code}-${tel1Number}` : tel1Number : '',
                                'CountryID': item.CountryID ? item.CountryID : '',
                                'CountryName': item.CountryNmae ? item.CountryNmae : '',
                                'mobNo': Mob1No ? Mob1Code ? `${Mob1Code}-${Mob1No}` : Mob1No : '',
                                'whatsAppMobNo': Mob2No ? Mob2Code ? `${Mob2Code}-${Mob2No}` : Mob2No : '',
                                'IsIntrestedForB2B': item.IsIntrestedForB2B ? item.IsIntrestedForB2B : '',
                                'CompanyProfile': item.CompanyProfile ? item.CompanyProfile : '',
                                'CompanyWebsite': item.CompanyWebsite ? item.CompanyWebsite : '',
                                'TotalOperationalYears': item.TotalOperationalYears ? item.TotalOperationalYears : '',
                                'CompanyTurnOverID': item.CompanyTurnOverID ? item.CompanyTurnOverID : '',
                                'ArrivalDate': item.ArrivalDate ? new Date(item.ArrivalDate) : '',
                                'DepartureDate': item.DepartureDate ? new Date(item.DepartureDate) : '',
                                'IsCoordinator': item.IsCoordinator ? item.IsCoordinator : '',
                                'isCoordinatorAsDelegate': item.isCoordinatorAsDelegate ? item.isCoordinatorAsDelegate : '',

                                'chaptersList': hallList,
                                'seminarList': seminarListSelected,
                                'visitdays': daysArr,
                                'purposeOfVisitList': purposeOfVisit,
                                'industrySegmentList': chapterListSelected,
                                'B2BmappingList': B2bListSelected,

                                'ApplicantEmailID': item.ApplicantEmailID ? item.ApplicantEmailID : '',
                                'ApplicantMobileNo': Mob5No ? Mob5Code ? `${Mob5Code}-${Mob5No}` : Mob5No : '',
                                'NameOnPassport': item.NameOnPassport ? item.NameOnPassport : '',
                                'PassportExpiryDate': item.PassportExpiryDate ? new Date(item.PassportExpiryDate) : '',
                                'PassportFile': item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                'PassportFileName': item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                'passportFilePath': item.PassportFilePath ? item.PassportFilePath : '',
                                'PassportFileType': '',
                                'PassportIssueDate': item.PassportIssueDate ? new Date(item.PassportIssueDate) : '',
                                'PassportIssuingCountryID': item.PassportIssuingCountryID ? item.PassportIssuingCountryID : '',
                                'PassportNo': item.PassportNo ? item.PassportNo : '',
                                'isVisaAssistance': item.isVisaAssistance ? item.isVisaAssistance : '',
                                'isSameAsMobNo': item.IsSameMobileNo ? item.IsSameMobileNo : '',
                                'isPassportFilePresent': item.PassportFilePath != null && item.PassportFilePath != '' ? true : false,
                                'isVisaApplied': item.PassportFilePath != null && item.PassportFilePath != '' ? true : false,
                                'PersonProfile': item.PersonProfile ?? '',
                                'PersonPhoto': item.PersonPhoto ? item.PersonPhoto : (item.PassportFilePath ? item.PassportFilePath : '')
                            }
                            this.state.GroupDetailsList.push(obj)
                            if (item.IsCoordinator) {
                                var daysArr = []
                                var selectedDaysList = data.data[1] != null ? data.data[1] : []
                                daysList.length > 0 && daysList.map((element) => {
                                    selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                                element.isSelect = true
                                                daysArr.push(element)
                                            }
                                        }
                                    })
                                })

                                var chapterListSelected = []
                                var selectedChapters = data.data[2] != null ? data.data[2] : []
                                chapterList.length > 0 && chapterList.map((element) => {
                                    selectedChapters.length > 0 && selectedChapters.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                                element.isSelect = true
                                                chapterListSelected.push(element)
                                            }
                                        }
                                    })
                                })

                                var purposeOfVisit = []
                                var selectedPurposeOfVisit = data.data[4] != null ? data.data[4] : []
                                visitPurposeList.length > 0 && visitPurposeList.map((element) => {
                                    selectedPurposeOfVisit.length > 0 && selectedPurposeOfVisit.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                                if (element2.PurposeofVisitID == 10) {
                                                    element.otherDetail = element2.OtherNames
                                                }
                                                element.isSelect = true
                                                purposeOfVisit.push(element)
                                            }
                                        }
                                    })
                                })

                                var hallList = []
                                var SelectedHallChapters = data.data[3] != null ? data.data[3] : []
                                primaryChapterListData.length > 0 && primaryChapterListData.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                element.isSelect = true
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })
                                level2.length > 0 && level2.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                element.isSelect = true
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })
                                level3.length > 0 && level3.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                element.isSelect = true
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })
                                level4.length > 0 && level4.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                element.isSelect = true
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })


                                var seminarListSelected = []
                                var selectedseminarList = data.data[5] != null ? data.data[5] : []

                                seminarInterestList.length > 0 && seminarInterestList.map((element) => {
                                    selectedseminarList.length > 0 && selectedseminarList.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.SeminarID == element.SeminarID) {
                                                element.isSelect = true
                                                seminarListSelected.push(element)
                                            }
                                        }
                                    })
                                })


                                var B2bListSelected = []
                                var selectedB2bList = data.data[6] != null ? data.data[6] : []

                                B2bMeetingList.length > 0 && B2bMeetingList.map((element) => {
                                    element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                                        selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                                            if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                                    inElement.isSelect = true
                                                    inElement.IsBooked = false
                                                    B2bListSelected.push(element)
                                                }
                                            }
                                        })
                                    })
                                })

                                sessionStorage.setItem('AccountTypeID', item.AccountTypeID)
                                this.setState({
                                    DelegateRegistrationID: item.DelegateRegistrationID ? item.DelegateRegistrationID : '',
                                    AccountTypeID: item.AccountTypeID ? item.AccountTypeID : '',
                                    AccountID: item.AccountID ? item.AccountID : '',
                                    DelegateRegistrationNo: item.DelegateRegistrationNo ? item.DelegateRegistrationNo : '',
                                    isOtherPreName: item.PersonIncharge_Title != 'Mr' && item.PersonIncharge_Title != 'Ms' && item.PersonIncharge_Title != 'DR' && item.PersonIncharge_Title != 'Prof' ? 'Other' : '',
                                    prename: item.PersonIncharge_Title ? item.PersonIncharge_Title : '',
                                    firstName: item.PersonIncharge_FirstName ? item.PersonIncharge_FirstName : '',
                                    lastName: item.PersonIncharge_LastName ? item.PersonIncharge_LastName : '',
                                    gender: item.PersonIncharge_GenderID ? item.PersonIncharge_GenderID : '',
                                    designation: item.PersonIncharge_Designation ? item.PersonIncharge_Designation : '',
                                    institute: item.CompanyName ? item.CompanyName : '',
                                    compInfoGstNo: item.GSTNo ? item.GSTNo : '',
                                    compInfoPanNo: item.PanNo ? item.PanNo : '',
                                    IECCode: item.IECCode ? item.IECCode : '',
                                    Address1: item.Address1 ? item.Address1 : '',
                                    Address2: item.Address2 ? item.Address2 : '',
                                    Address3: item.Address3 ? item.Address3 : '',
                                    city: item.City ? item.City : '',
                                    regState: item.State ? item.State : '',
                                    pincode: item.Pin ? item.Pin : '',
                                    email: item.PrimaryEmail ? item.PrimaryEmail : '',
                                    website: item.Website ? item.Website : '',
                                    preTelNo: telCode,
                                    telNo: telNumber,
                                    preTel1No: tel1Code,
                                    tel1No: tel1Number,
                                    countryId: item.CountryID ? item.CountryID : '',
                                    CountryName: item.CountryNmae ? item.CountryNmae : '',
                                    preMobNo: Mob1Code,
                                    mobNo: Mob1No,
                                    preWhatsAppMobNo: Mob2Code,
                                    whatsAppMobNo: Mob2No,
                                    IsIntrestedForB2B: item.IsIntrestedForB2B ? item.IsIntrestedForB2B : '',
                                    companyProfile: item.CompanyProfile ? item.CompanyProfile : '',
                                    companywebsite: item.CompanyWebsite ? item.CompanyWebsite : '',
                                    totalYears: item.TotalOperationalYears ? item.TotalOperationalYears : '',
                                    turnOverId: item.CompanyTurnOverID ? item.CompanyTurnOverID : '',
                                    arrivalDate: item.ArrivalDate ? new Date(item.ArrivalDate) : '',
                                    departureDate: item.DepartureDate ? new Date(item.DepartureDate) : '',
                                    IsCoordinator: item.IsCoordinator ? item.IsCoordinator : '',
                                    isCoordinatorAsDelegate: item.isCoordinatorAsDelegate ? item.isCoordinatorAsDelegate : '',

                                    seminarInterestList: seminarInterestList,
                                    daysList: daysList,
                                    visitPurposeList: visitPurposeList,
                                    industrySegmentList: chapterList,
                                    level2: level2,
                                    level3: level3,
                                    level4: level4,
                                    B2bMeetingList: B2bMeetingList,
                                    primaryChapterListData: primaryChapterListData,
                                    isInterestTwo: item.IsIntrestedForB2B ? item.IsIntrestedForB2B : '',

                                    applicantEmail: item.ApplicantEmailID ? item.ApplicantEmailID : '',
                                    preApplicantMobNo: Mob5Code,
                                    applicantMobNo: Mob5No,
                                    passName: item.NameOnPassport ? item.NameOnPassport : '',
                                    passExipryDate: item.PassportExpiryDate ? new Date(item.PassportExpiryDate) : '',
                                    passportFile: item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                    passPortFileName: item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                    passportFilePath: item.PassportFilePath ? item.PassportFilePath : '',
                                    passportFileType: '',
                                    passDate: item.PassportIssueDate ? new Date(item.PassportIssueDate) : '',
                                    passCountry: item.PassportIssuingCountryID ? item.PassportIssuingCountryID : '',
                                    passNo: item.PassportNo ? item.PassportNo : '',
                                    needVisaAssistance: item.isVisaAssistance ? item.isVisaAssistance : '',
                                    isSameAsMobNo: item.IsSameMobileNo ? item.IsSameMobileNo : '',
                                    isPassportFilePresent: item.PassportFilePath != null && item.PassportFilePath != '' ? true : false,
                                    isVisaApplied: item.PassportFilePath != null && item.PassportFilePath != '' ? true : false,
                                    isDataLoad: true,
                                    PersonProfile: item.PersonProfile,
                                    PersonPhoto: item.PersonPhoto ? item.PersonPhoto : (item.PassportFilePath ? item.PassportFilePath : '')
                                })
                                if (item.CountryID == 91) {
                                    this.getFillList(pincodeActionId, '', '', item.CountryID, '', '')
                                    this.getFillList(stateActionId, '', '', item.CountryID, '', '')
                                    this.getFillList(cityActionId, '', '', item.CountryID, '', '')

                                    setTimeout(() => {

                                        this.setState({
                                            isOpenDropDownState: false,
                                            focusedIndexState: -1,
                                            isOpenDropDownStateModal: false,
                                            focusedIndexStateModal: -1,

                                            isOpenDropDownCity: false,
                                            focusedIndexCity: -1,
                                            isOpenDropDownCityModal: false,
                                            focusedIndexCityModal: -1,

                                            isOpenDropDownPin: false,
                                            focusedIndexPin: -1,
                                            isOpenDropDownPinModal: false,
                                            focusedIndexPinModal: -1,
                                        })
                                    }, 100);
                                }
                            }
                        })
                        var CoordinatorIndex = 0
                        for (var i = 0; i < GroupDetailsList.length; i++) {
                            if (GroupDetailsList[i].IsCoordinator) {
                                CoordinatorIndex = i
                            }
                        }
                        GroupDetailsList.splice(CoordinatorIndex, 1)
                        for (var i = 0; i < GroupDetailsList.length; i++) {
                            GroupDetailsList[i].id = i + 1
                        }
                        this.setState({
                            GroupDetailsList: GroupDetailsList,
                            agreeTerms: data.data[0][0].IsAgree,
                            isLoading: false,
                        })
                    } else {
                        var mob1 = data.data[0][0]['MobileNo']
                        const parts = mob1 != null ? mob1.split("-") : ''
                        const Mob1Code = parts.length == 2 ? parts[0] : '+91'
                        const Mob1No = parts.length == 2 ? parts[1] : mob1
                        var mob2 = data.data[0][0]['WhatsappMobileNo']
                        const parts2 = mob2 != null ? mob2.split("-") : ''
                        const Mob2Code = parts2.length == 2 ? parts2[0] : '+91'
                        const Mob2No = parts2.length == 2 ? parts2[1] : mob2
                        var mob5 = data.data[0][0]['ApplicantMobileNo']
                        const parts5 = mob5 != null ? mob5.split("-") : ''
                        var tel = data.data[0][0]['Telephone']
                        const parts3 = tel != null ? tel.split("-") : ''
                        const telCode = parts3.length == 2 ? parts3[0] : ''
                        const telNumber = parts3.length == 2 ? parts3[1] : tel
                        var tel1 = data.data[0][0]['Telephone1']
                        const parts4 = tel1 != null ? tel1.split("-") : ''
                        const tel1Code = parts4.length == 2 ? parts4[0] : ''
                        const tel1Number = parts4.length == 2 ? parts4[1] : tel1
                        sessionStorage.setItem('AccountTypeID', data.data[0][0].AccountTypeID ?? null)
                        if (programList.length > 0) {
                            var ExhProgramArr = []
                            var ExhProgramDateArr = []
                            var ExhProgramCategoryArr = []
                            programList.map(main => {
                                data.data[8].map(item => {
                                    if (main.ExhProgramDateID == item.ExhProgramDateID) {
                                        main.isSelect = true
                                    }
                                })
                                main.catogary.map(main2 => {
                                    data.data[9].map(item => {
                                        if (main2.ExhProgramCategoryID == item.ExhProgramCategoryID) {
                                            main2.isSelect = true
                                        }
                                    })
                                })
                            })
                        }
                        this.setState({
                            programList: programList,
                            DelegateRegistrationID: data.data[0][0].DelegateRegistrationID ?? '',
                            AccountTypeID: data.data[0][0].AccountTypeID ?? '',
                            AccountID: data.data[0][0].AccountID ?? '',
                            DelegateRegistrationNo: data.data[0][0].DelegateRegistrationNo ?? '',
                            isOtherPreName: data.data[0][0].PersonIncharge_Title != 'Mr' && data.data[0][0].PersonIncharge_Title != 'Ms' && data.data[0][0].PersonIncharge_Title != 'DR' && data.data[0][0].PersonIncharge_Title != 'Prof' ? 'Other' : '',
                            otherName: data.data[0][0].PersonIncharge_Title != 'Mr' && data.data[0][0].PersonIncharge_Title != 'Ms' && data.data[0][0].PersonIncharge_Title != 'DR' && data.data[0][0].PersonIncharge_Title != 'Prof' ? data.data[0][0].PersonIncharge_Title : '',
                            prename: data.data[0][0].PersonIncharge_Title ?? '',
                            firstName: data.data[0][0].PersonIncharge_FirstName ?? '',
                            lastName: data.data[0][0].PersonIncharge_LastName ?? '',
                            gender: data.data[0][0].PersonIncharge_GenderID ?? '',
                            designation: data.data[0][0].PersonIncharge_Designation ?? '',
                            institute: data.data[0][0].CompanyName ?? '',
                            compInfoGstNo: data.data[0][0].GSTNo ?? '',
                            compInfoPanNo: data.data[0][0].PanNo ?? '',
                            IECCode: data.data[0][0].IECCode ?? '',
                            Address1: data.data[0][0].Address1 ?? '',
                            Address2: data.data[0][0].Address2 ?? '',
                            Address3: data.data[0][0].Address3 ?? '',
                            city: data.data[0][0].City ?? '',
                            regState: data.data[0][0].State ?? '',
                            pincode: data.data[0][0].Pin ?? '',
                            email: data.data[0][0].PrimaryEmail ?? '',
                            website: data.data[0][0].Website ?? '',
                            preTelNo: telCode,
                            telNo: telNumber,
                            preTel1No: tel1Code,
                            tel1No: tel1Number,
                            countryId: data.data[0][0].CountryID ?? '',
                            CountryName: data.data[0][0].CountryNmae ?? '',
                            preMobNo: Mob1Code,
                            mobNo: Mob1No,
                            preWhatsAppMobNo: Mob2Code,
                            whatsAppMobNo: Mob2No,
                            companyProfile: data.data[0][0].CompanyProfile ?? '',
                            companyWebsite: data.data[0][0].CompanyWebsite ?? '',
                            totalYears: data.data[0][0].TotalOperationalYears ?? '',
                            turnOverId: data.data[0][0].CompanyTurnOverID ?? '',
                            arrivalDate: new Date(data.data[0][0].ArrivalDate) ?? '',
                            departureDate: new Date(data.data[0][0].DepartureDate) ?? '',
                            IsCoordinator: data.data[0][0].IsCoordinator ?? '',
                            isCoordinatorAsDelegate: data.data[0][0].isCoordinatorAsDelegate ?? '',
                            isSameAsMobNo: data.data[0][0].IsSameMobileNo ?? '',
                            PersonProfile: data.data[0][0].PersonProfile ?? '',
                            PersonPhoto: data.data[0][0].PersonPhoto ? data.data[0][0].PersonPhoto : (data.data[0][0].PassportFilePath ? data.data[0][0].PassportFilePath : ''),
                            isLoading: false,
                            isDataLoad: true
                        })
                        if (data.data[0][0].CountryID == 91) {
                            this.getFillList(pincodeActionId, '', '', data.data[0][0].CountryID, '', '')
                            this.getFillList(stateActionId, '', '', data.data[0][0].CountryID, '', '')
                            this.getFillList(cityActionId, '', '', data.data[0][0].CountryID, '', '')

                            setTimeout(() => {

                                this.setState({
                                    isOpenDropDownState: false,
                                    focusedIndexState: -1,
                                    isOpenDropDownStateModal: false,
                                    focusedIndexStateModal: -1,

                                    isOpenDropDownCity: false,
                                    focusedIndexCity: -1,
                                    isOpenDropDownCityModal: false,
                                    focusedIndexCityModal: -1,

                                    isOpenDropDownPin: false,
                                    focusedIndexPin: -1,
                                    isOpenDropDownPinModal: false,
                                    focusedIndexPinModal: -1,
                                })
                            }, 30);
                        }
                    }
                }
            })
    }

    getRegistrationDetailsUUID(UUID) {
        const { GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal,
            chapterList, chapterListModal, visitPurposeList, visitPurposeListModal,
            daysList, daysListModal, B2bMeetingListmodal, B2bMeetingList, PersonPhoto, PersonProfile } = this.state
        this.setState({ isLoading: true })
        this.props.getDelegateDetailsUUID_action(UUID)
            .then(async (data) => {
                if (data && data.error != 1) {
                    if (!sessionStorage.getItem("sessionExhibitionID")) {
                        sessionStorage.setItem('sessionExhibitionID', data.data?.[0]?.[0]?.ExhibitionID)
                        setTimeout(() => {
                            this.getFieldList(data.data?.[0]?.[0]?.AccountTypeID);
                        }, 200);
                    }
                    sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data?.[0][0]))
                    sessionStorage.setItem('DelegateTypeID', data.data?.[0]?.[0]?.AccountTypeID)
                    sessionStorage.setItem('sessionExhibitionID', data.data?.[0]?.[0]?.ExhibitionID)
                    sessionStorage.setItem("isLinkOpen", true);
                    this.setState({ isLinkOpen: true })
                    const statusRes = await this.getFillList(exhibitionStatusActionId, data.data?.[0]?.[0]?.ExhibitionID, '', '', '', '');
                    this.getFillList(countryIWithCodeActionId, '', '', '', statusRes, '').then(async () => {
                        await this.loadCommonLists(data.data?.[0]?.[0]?.ExhibitionID);
                        if (data.data[0].length > 1) {
                            data.data[0].map((item) => {
                                var daysArr = []
                                var selectedDaysList = data.data[1] != null ? data.data[1] : []
                                daysListModal.length > 0 && daysListModal.map((element) => {
                                    selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                                element.visitDay = element.VisitDate
                                                daysArr.push(element)
                                            }
                                        }
                                    })
                                })

                                var chapterListSelected = []
                                var selectedChapters = data.data[2] != null ? data.data[2] : []
                                chapterListModal.length > 0 && chapterListModal.map((element) => {
                                    selectedChapters.length > 0 && selectedChapters.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                                element.ChapterID = element.IndustrySegmentID
                                                element.ChapterName = element['IndustrySegmentName']
                                                chapterListSelected.push(element)
                                            }
                                        }
                                    })
                                })

                                var purposeOfVisit = []
                                var selectedPurposeOfVisit = data.data[4] != null ? data.data[4] : []
                                visitPurposeListModal.length > 0 && visitPurposeListModal.map((element) => {
                                    selectedPurposeOfVisit.length > 0 && selectedPurposeOfVisit.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                                if (element2.PurposeofVisitID == 10) {
                                                    element.otherDetail = element2.OtherNames
                                                }
                                                purposeOfVisit.push(element)
                                            }
                                        }
                                    })
                                })

                                var hallList = []
                                var SelectedHallChapters = data.data[3] != null ? data.data[3] : []
                                primaryChapterListDataModal.length > 0 && primaryChapterListDataModal.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })
                                level2Modal.length > 0 && level2Modal.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })
                                level3Modal.length > 0 && level3Modal.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })
                                level4Modal.length > 0 && level4Modal.map((element) => {
                                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                        if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.MappingChapterID == element.ChapterID) {
                                                hallList.push(element)
                                            }
                                        }
                                    })
                                })


                                var seminarListSelected = []
                                var selectedseminarList = data.data[5] != null ? data.data[5] : []

                                seminarInterestListModal.length > 0 && seminarInterestListModal.map((element) => {
                                    selectedseminarList.length > 0 && selectedseminarList.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.SeminarID == element.SeminarID) {
                                                seminarListSelected.push(element)
                                            }
                                        }
                                    })
                                })

                                var B2bListSelected = []
                                if (!item.IsCoordinator) {

                                    var selectedB2bList = data.data[6] != null ? data.data[6] : []
                                    B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map((element) => {
                                        element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                                            selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                                                if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                    if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                                        inElement.isSelect = true
                                                        inElement.IsBooked = false
                                                        B2bListSelected.push({ B2BTimeSlotID: inElement.B2BTimeSlotID })
                                                    }
                                                }
                                            })
                                        })
                                    })
                                }


                                var mob1 = item['MobileNo']
                                const parts = mob1 != null ? mob1.split("-") : ''
                                const Mob1Code = parts.length == 2 ? parts[0] : '+91'
                                const Mob1No = parts.length == 2 ? parts[1] : mob1
                                var mob2 = item['WhatsappMobileNo']
                                const parts2 = mob2 != null ? mob2.split("-") : ''
                                const Mob2Code = parts2.length == 2 ? parts2[0] : '+91'
                                const Mob2No = parts2.length == 2 ? parts2[1] : mob2
                                var mob5 = item['ApplicantMobileNo']
                                const parts5 = mob5 != null ? mob5.split("-") : ''
                                const Mob5Code = parts5.length == 2 ? parts5[0] : ''
                                const Mob5No = parts5.length == 2 ? parts5[1] : mob5
                                var tel = item['Telephone']
                                const parts3 = tel != null ? tel.split("-") : ''
                                const telCode = parts3.length == 2 ? parts3[0] : ''
                                const telNumber = parts3.length == 2 ? parts3[1] : tel
                                var tel1 = item['Telephone1']
                                const parts4 = tel1 != null ? tel1.split("-") : ''
                                const tel1Code = parts4.length == 2 ? parts4[0] : ''
                                const tel1Number = parts4.length == 2 ? parts4[1] : tel1
                                var filePath = item.PassportFilePath != null ? item['PassportFilePath'] : ''
                                var array = item['PassportFilePath'] != null && item['PassportFilePath'] != "" && filePath.split("/")
                                const FileName = array[array.length - 1]
                                var obj = {
                                    'DelegateRegistrationID': item.DelegateRegistrationID ? item.DelegateRegistrationID : '',
                                    'AccountTypeID': item.AccountTypeID ? item.AccountTypeID : '',
                                    'AccountID': item.AccountID ? item.AccountID : '',
                                    'DelegateRegistrationNo': item.DelegateRegistrationNo ? item.DelegateRegistrationNo : '',
                                    'Title': item.PersonIncharge_Title ? item.PersonIncharge_Title : '',
                                    'firstName': item.PersonIncharge_FirstName ? item.PersonIncharge_FirstName : '',
                                    'lastName': item.PersonIncharge_LastName ? item.PersonIncharge_LastName : '',
                                    'gender': item.PersonIncharge_GenderID ? item.PersonIncharge_GenderID : '',
                                    'designation': item.PersonIncharge_Designation ? item.PersonIncharge_Designation : '',
                                    'CompanyName': item.CompanyName ? item.CompanyName : '',
                                    'GSTNo': item.GSTNo ? item.GSTNo : '',
                                    'PanNo': item.PanNo ? item.PanNo : '',
                                    'IECCode': item.IECCode ? item.IECCode : '',
                                    'Address1': item.Address1 ? item.Address1 : '',
                                    'Address2': item.Address2 ? item.Address2 : '',
                                    'Address3': item.Address3 ? item.Address3 : '',
                                    'City': item.City ? item.City : '',
                                    'State': item.State ? item.State : '',
                                    'Pin': item.Pin ? item.Pin : '',
                                    'PrimaryEmail': item.PrimaryEmail ? item.PrimaryEmail : '',
                                    'Website': item.Website ? item.Website : '',
                                    'Telephone': telNumber ? telCode ? `${telCode}-${telNumber}` : telNumber : '',
                                    'Telephone1': tel1Number ? tel1Code ? `${tel1Code}-${tel1Number}` : tel1Number : '',
                                    'CountryID': item.CountryID ? item.CountryID : '',
                                    'CountryName': item.CountryNmae ? item.CountryNmae : '',
                                    'mobNo': Mob1No ? Mob1Code ? `${Mob1Code}-${Mob1No}` : Mob1No : '',
                                    'whatsAppMobNo': Mob2No ? Mob2Code ? `${Mob2Code}-${Mob2No}` : Mob2No : '',
                                    'IsIntrestedForB2B': item.IsIntrestedForB2B ? item.IsIntrestedForB2B : '',
                                    'CompanyProfile': item.CompanyProfile ? item.CompanyProfile : '',
                                    'CompanyWebsite': item.CompanyWebsite ? item.CompanyWebsite : '',
                                    'TotalOperationalYears': item.TotalOperationalYears ? item.TotalOperationalYears : '',
                                    'CompanyTurnOverID': item.CompanyTurnOverID ? item.CompanyTurnOverID : '',
                                    'ArrivalDate': item.ArrivalDate ? new Date(item.ArrivalDate) : '',
                                    'DepartureDate': item.DepartureDate ? new Date(item.DepartureDate) : '',
                                    'IsCoordinator': item.IsCoordinator ? item.IsCoordinator : '',
                                    'isCoordinatorAsDelegate': item.isCoordinatorAsDelegate ? item.isCoordinatorAsDelegate : '',

                                    'chaptersList': hallList,
                                    'seminarList': seminarListSelected,
                                    'visitdays': daysArr,
                                    'purposeOfVisitList': purposeOfVisit,
                                    'industrySegmentList': chapterListSelected,
                                    'B2BmappingList': B2bListSelected,

                                    'ApplicantEmailID': item.ApplicantEmailID ? item.ApplicantEmailID : '',
                                    'ApplicantMobileNo': Mob5No ? Mob5Code ? `${Mob5Code}-${Mob5No}` : Mob5No : '',
                                    'NameOnPassport': item.NameOnPassport ? item.NameOnPassport : '',
                                    'PassportExpiryDate': item.PassportExpiryDate ? new Date(item.PassportExpiryDate) : '',
                                    'PassportFile': item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                    'PassportFileName': item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                    'passportFilePath': item.PassportFilePath ? item.PassportFilePath : '',
                                    'PassportFileType': '',
                                    'PassportIssueDate': item.PassportIssueDate ? new Date(item.PassportIssueDate) : '',
                                    'PassportIssuingCountryID': item.PassportIssuingCountryID ? item.PassportIssuingCountryID : '',
                                    'PassportNo': item.PassportNo ? item.PassportNo : '',
                                    'isVisaAssistance': item.isVisaAssistance ? item.isVisaAssistance : '',
                                    'isSameAsMobNo': item.IsSameMobileNo ? item.IsSameMobileNo : '',
                                    'PersonProfile': item.PersonProfile ? item.PersonProfile : '',
                                    'PersonPhoto': item.PersonPhoto ? item.PersonPhoto : (item.PassportFilePath ? item.PassportFilePath : ''),
                                    'isPassportFilePresent': item.PassportFilePath != null && item.PassportFilePath != '' ? true : false,
                                    'isVisaApplied': item.PassportFilePath != null && item.PassportFilePath != '' ? true : false
                                }
                                this.state.GroupDetailsList.push(obj)
                                if (item.IsCoordinator) {
                                    var daysArr = []
                                    var selectedDaysList = data.data[1] != null ? data.data[1] : []
                                    daysList.length > 0 && daysList.map((element) => {
                                        selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                                            if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                                    element.isSelect = true
                                                    daysArr.push(element)
                                                }
                                            }
                                        })
                                    })

                                    var chapterListSelected = []
                                    var selectedChapters = data.data[2] != null ? data.data[2] : []
                                    chapterList.length > 0 && chapterList.map((element) => {
                                        selectedChapters.length > 0 && selectedChapters.map((element2) => {
                                            if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                                    element.isSelect = true
                                                    chapterListSelected.push(element)
                                                }
                                            }
                                        })
                                    })

                                    var purposeOfVisit = []
                                    var selectedPurposeOfVisit = data.data[4] != null ? data.data[4] : []
                                    visitPurposeList.length > 0 && visitPurposeList.map((element) => {
                                        selectedPurposeOfVisit.length > 0 && selectedPurposeOfVisit.map((element2) => {
                                            if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                                    if (element2.PurposeofVisitID == 10) {
                                                        element.otherDetail = element2.OtherNames
                                                    }
                                                    element.isSelect = true
                                                    purposeOfVisit.push(element)
                                                }
                                            }
                                        })
                                    })

                                    var hallList = []
                                    var SelectedHallChapters = data.data[3] != null ? data.data[3] : []
                                    primaryChapterListData.length > 0 && primaryChapterListData.map((element) => {
                                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                            if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.MappingChapterID == element.ChapterID) {
                                                    element.isSelect = true
                                                    hallList.push(element)
                                                }
                                            }
                                        })
                                    })
                                    level2.length > 0 && level2.map((element) => {
                                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                            if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.MappingChapterID == element.ChapterID) {
                                                    element.isSelect = true
                                                    hallList.push(element)
                                                }
                                            }
                                        })
                                    })
                                    level3.length > 0 && level3.map((element) => {
                                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                            if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.MappingChapterID == element.ChapterID) {
                                                    element.isSelect = true
                                                    hallList.push(element)
                                                }
                                            }
                                        })
                                    })
                                    level4.length > 0 && level4.map((element) => {
                                        SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                            if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.MappingChapterID == element.ChapterID) {
                                                    element.isSelect = true
                                                    hallList.push(element)
                                                }
                                            }
                                        })
                                    })
                                    var seminarListSelected = []
                                    var selectedseminarList = data.data[5] != null ? data.data[5] : []

                                    seminarInterestList.length > 0 && seminarInterestList.map((element) => {
                                        selectedseminarList.length > 0 && selectedseminarList.map((element2) => {
                                            if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                if (element2.SeminarID == element.SeminarID) {
                                                    element.isSelect = true
                                                    seminarListSelected.push(element)
                                                }
                                            }
                                        })
                                    })
                                    var B2bListSelected = []
                                    var selectedB2bList = data.data[6] != null ? data.data[6] : []

                                    B2bMeetingList.length > 0 && B2bMeetingList.map((element) => {
                                        element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                                            selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                                                if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                                    if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                                        inElement.isSelect = true
                                                        inElement.IsBooked = false
                                                        B2bListSelected.push(element)
                                                    }
                                                }
                                            })
                                        })
                                    })

                                    sessionStorage.setItem('AccountTypeID', item.AccountTypeID)
                                    this.setState({
                                        DelegateRegistrationID: item.DelegateRegistrationID ? item.DelegateRegistrationID : '',
                                        AccountTypeID: item.AccountTypeID ? item.AccountTypeID : '',
                                        AccountID: item.AccountID ? item.AccountID : '',
                                        DelegateRegistrationNo: item.DelegateRegistrationNo ? item.DelegateRegistrationNo : '',
                                        isDataLoad: true
                                    })
                                    if (item.CountryID == 91) {
                                        this.getFillList(pincodeActionId, '', '', item.CountryID, '', '')
                                        this.getFillList(stateActionId, '', '', item.CountryID, '', '')
                                        this.getFillList(cityActionId, '', '', item.CountryID, '', '')

                                        setTimeout(() => {

                                            this.setState({
                                                isOpenDropDownState: false,
                                                focusedIndexState: -1,
                                                isOpenDropDownStateModal: false,
                                                focusedIndexStateModal: -1,

                                                isOpenDropDownCity: false,
                                                focusedIndexCity: -1,
                                                isOpenDropDownCityModal: false,
                                                focusedIndexCityModal: -1,

                                                isOpenDropDownPin: false,
                                                focusedIndexPin: -1,
                                                isOpenDropDownPinModal: false,
                                                focusedIndexPinModal: -1,
                                            })
                                        }, 100);
                                    }
                                }
                            })
                            var CoordinatorIndex = 0
                            for (var i = 0; i < GroupDetailsList.length; i++) {
                                if (GroupDetailsList[i].IsCoordinator) {
                                    CoordinatorIndex = i
                                }
                            }
                            GroupDetailsList.splice(CoordinatorIndex, 1)
                            for (var i = 0; i < GroupDetailsList.length; i++) {
                                GroupDetailsList[i].id = i + 1
                            }
                            this.setState({
                                GroupDetailsList: GroupDetailsList,
                                agreeTerms: data.data[0][0].IsAgree,
                            })
                            setTimeout(() => {
                            }, 2000);
                        } else {
                            sessionStorage.setItem('AccountTypeID', data.data[0][0].DelegateRegistrationID)
                            this.setState({
                                DelegateRegistrationID: data.data[0][0].DelegateRegistrationID ?? '',
                                AccountTypeID: data.data[0][0].AccountTypeID ?? '',
                                AccountID: data.data[0][0].AccountID ?? '',
                                DelegateRegistrationNo: data.data[0][0].DelegateRegistrationNo ?? '',
                                isLoading: false,
                                isDataLoad: true
                            })
                            if (data.data[0][0].CountryID == 91) {
                                this.getFillList(pincodeActionId, '', '', data.data[0][0].CountryID, '', '')
                                this.getFillList(stateActionId, '', '', data.data[0][0].CountryID, '', '')
                                this.getFillList(cityActionId, '', '', data.data[0][0].CountryID, '', '')

                                setTimeout(() => {

                                    this.setState({
                                        isOpenDropDownState: false,
                                        focusedIndexState: -1,
                                        isOpenDropDownStateModal: false,
                                        focusedIndexStateModal: -1,

                                        isOpenDropDownCity: false,
                                        focusedIndexCity: -1,
                                        isOpenDropDownCityModal: false,
                                        focusedIndexCityModal: -1,

                                        isOpenDropDownPin: false,
                                        focusedIndexPin: -1,
                                        isOpenDropDownPinModal: false,
                                        focusedIndexPinModal: -1,
                                    })
                                }, 30);
                            }
                        }
                    })
                }
            })
    }

    getFieldList(typeId) {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList,
            daysList, daysListModal, B2bMeetingListmodal,
            B2bMeetingList } = this.state
        this.props.getDelegateFirldList_action(typeId)
            .then((data) => {
                if (data && data.error != 1) {
                    var showFieldListArr = []
                    if (data.data[1] != null) {
                        if (data.data[1].length > 0) {
                            for (var i = 0; i < data.data[1].length; i++) {
                                var obj = {
                                    'id': data.data[1][i].FieldID, 'mandatory': data.data[1][i].IsMandatory, 'name': data.data[1][i].FieldName
                                }
                                showFieldListArr.push(obj)
                            }
                        }
                    }
                    sessionStorage.setItem('showFieldList', JSON.stringify(showFieldListArr))
                    this.setState({ showFieldList: showFieldListArr })
                }
            })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data && data.error != 1) {
                        if (actionID === primaryChapterListActionId) {
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    break
                                                }
                                            }
                                        } else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                    }
                                }
                                return
                            }

                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                if (data.data['primaryChapter'][i].ChapterID == 2046) {
                                    data.data['primaryChapter'][i].ChapterName = 'TECHNICAL TEXTILE PRODUCTS & HOME TEXTILE PRODUCT'
                                }
                                if (data.data['primaryChapter'][i].ChapterID == 2033) {
                                    data.data['primaryChapter'].splice(i, 1)
                                }
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                }
                            }
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2'].length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level3'].length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2'].length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            const level0list = data.data['level0'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const primaryChapterListDatalist = data.data['primaryChapter'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level2list = data.data['level2'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level3list = data.data['level3'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            const level4list = data.data['level4'].map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                level0: data.data['level0'] ? data.data['level0'] : [],
                                level2: data.data['level2'] ? data.data['level2'] : [],
                                level3: data.data['level3'] ? data.data['level3'] : [],
                                level4: data.data['level4'] ? data.data['level4'] : [],
                                primaryChapterListDataModal: primaryChapterListDatalist ? primaryChapterListDatalist : [],
                                level0Modal: level0list ? level0list : [],
                                level2Modal: level2list ? level2list : [],
                                level3Modal: level3list ? level3list : [],
                                level4Modal: level4list ? level4list : [],

                            })
                            resolve(true)
                        }
                        if (actionID === countryIWithCodeActionId) {
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []
                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", moment(data.data[0]['ExhibitionDateFrom']).format("DD/MM/YYYY"))
                            sessionStorage.setItem("exhibitionDateTo", moment(data.data[0]['ExhibitionDateTo']).format("DD/MM/YYYY"))
                            sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionCountryID'])
                            sessionStorage.setItem("sessionLogoPath", `${BASE_URL?.split('/api')[0]}${data.data[0]['Logo']}`)

                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])
                            sessionStorage.setItem("isVisitorB2B", data.data[0]['isVisitorB2B'])
                            sessionStorage.setItem("isVisitorSeminar", data.data[0]['isVisitorSeminar'])
                            sessionStorage.setItem("isVisitorRegistrationOpen", data.data[0]['isVisitorRegistrationOpen'])

                            sessionStorage.setItem("ExhVisitorVisaIssueDate", data.data[0]['ExhVisitorVisaIssueDate'])
                            this.setState({
                                isDataLoad: true,
                                bannerPath: data.data[0]['Banner'] != null && data.data[0]['Banner']
                            })

                            resolve(true)
                        }
                        if (actionID === exhibitionStatusActionId) {
                            this.setState({
                                isExhbitionClosed: data != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isLoading: false,
                            })
                            resolve(data.data[0]['Code'])
                        }
                        if (actionID === countryActionId) {
                            this.setState({
                                countryList: data != null ? data.data : [],
                                personalCountryList: data.data,
                                tempPersonalCountryList: data.data,
                                delgationCountryList: data.data,
                                tempDelegationCountryList: data.data,
                                passCountryList: data.data,
                                tempPassCountryList: data.data,
                                isLoading: false,

                            })
                            resolve(true)
                        }
                        if (actionID === stateActionId) {
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                tempGroupStateList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === companyTurnOverActionId) {
                            this.setState({
                                turnOverList: data.data,
                                turnOverListModal: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === cityActionId) {
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                                tempGroupCityList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === seminarInterestActionId) {
                            data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                            }));
                            list.sort((a, b) => a.SeqNo - b.SeqNo);
                            list.length > 0 && list.map((item) => {
                                if (item.ParentSeminarID != null) {
                                    item.Day = ''
                                }
                            })
                            listModal.sort((a, b) => a.SeqNo - b.SeqNo);
                            listModal.length > 0 && listModal.map((item) => {
                                if (item.ParentSeminarID != null) {
                                    item.Day = ''
                                }
                            })
                            const result = this.calculateRowspan(list);
                            const result2 = this.calculateRowspan(listModal);
                            this.setState({
                                seminarInterestList: result,
                                seminarInterestListModal: result2,
                                isLoading: false
                            })
                            resolve(true)
                        }
                        if (actionID === pincodeActionId) {
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                                tempGroupPincodeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === genderActionId) {
                            this.setState({
                                genderList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === GSTvalidationActionId) {
                            this.setState({
                                gstValidtionList: data.data, isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === industryChaptersActionId) {
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherNames: '',
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                OtherNames: '',
                            }));
                            this.setState({
                                chapterList: list,
                                chapterListModal: listModal,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === visitorTypeListActionId) {

                            data.data.length > 0 && data.data.map((item) => {
                                item.isChecked = false
                            })
                            this.setState({
                                visitorTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === visitPurposeActionId) {
                            const list = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                otherDetail: ""
                            }));
                            const listModal = data.data.map(item => ({
                                ...item,
                                isSelect: false,
                                otherDetail: ""
                            }));
                            this.setState({
                                visitPurposeList: list,
                                visitPurposeListModal: listModal,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === visitorInterestActionId) {
                            this.setState({
                                interestList: data.data,
                                interestListModal: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                        if (actionID === exhibitorBadgeDaysActionId) {
                            var DateList = []
                            var DateListModal = []
                            data.data.map((item) => {
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                }
                                DateList.push(mapData)
                            })
                            data.data.map((item) => {
                                var mapData = {
                                    "Code": item['DateValue'],
                                    "VisitDate": item['DateValue'],
                                    "isSelect": false,
                                    "isReadOnly": false,
                                }
                                DateListModal.push(mapData)
                            })
                            this.setState({
                                daysList: DateList,
                                daysListModal: DateListModal,
                                isLoading: false,
                                isExhibitionFree: data.data[0]['isExhibitionFree'],
                            })
                            resolve(true)
                        }
                        if (actionID === B2BTimeslotActionID) {
                            var B2bDates = []
                            var tempData = data.data.map(item => ({
                                ...item // Create a new object for the modal list
                            }));
                            tempData.sort((a, b) => {
                                const dateA = new Date(a.B2BDate);
                                const dateB = new Date(b.B2BDate);

                                if (dateA < dateB) return -1;
                                if (dateA > dateB) return 1;

                                if (a.B2BStartTime < b.B2BStartTime) return -1;
                                if (a.B2BStartTime > b.B2BStartTime) return 1;

                                return 0;
                            });
                            const uniqueDAta = tempData.filter((value, index, self) => {
                                const identifier = `${value.B2BDate}-${value.B2BLocation}`;

                                return index === self.findIndex((t) => `${t.B2BDate}-${t.B2BLocation}` === identifier);
                            });

                            const keysToKeep = ['B2BDate', 'B2BLocation'];

                            const modifiedArray = uniqueDAta.map(obj => {
                                return Object.keys(obj).reduce((newObj, key) => {
                                    if (keysToKeep.includes(key)) {
                                        newObj[key] = obj[key];
                                    }
                                    return newObj;
                                }, {});
                            });

                            modifiedArray.length > 0 && modifiedArray.map((item) => {
                                var obj = {}
                                obj.date = item
                                obj.timeSlotList = []
                                data.data.length > 0 && data.data.map((item2) => {
                                    if (item.B2BDate == item2.B2BDate && item.B2BLocation == item2.B2BLocation) {
                                        var timeobj = {}
                                        timeobj.timeslot = `${item2.B2BStartTime} To ${item2.B2BEndTime}`
                                        timeobj.IsBooked = item2.IsBooked
                                        timeobj.isSelect = false
                                        timeobj.B2BTimeSlotID = item2.B2BTimeSlotID
                                        obj.timeSlotList.push(timeobj)
                                    }
                                })

                                item.timeSlotList = obj.timeSlotList
                            })

                            data.data.length > 0 && data.data.map((item) => {
                                if (!B2bDates.includes(item.B2BDate)) {
                                    B2bDates.push(item.B2BDate)
                                }
                            })
                            B2bDates.map(item => {
                                var dateCount = 0
                                modifiedArray.map(obj => {
                                    if (item == obj.B2BDate) {
                                        dateCount++
                                        obj.rowSpan = 0
                                    }
                                })
                                for (var i = 0; i < modifiedArray.length; i++) {
                                    if (item == modifiedArray[i].B2BDate) {
                                        modifiedArray[i].rowSpan = dateCount
                                        break
                                    }
                                }
                            })
                            const modifiedArrayModal = modifiedArray.map(item => ({
                                ...item, // Copy the item object
                                timeSlotList: item.timeSlotList.map(subItem => ({ ...subItem })) // Deep clone the list inside each item
                            }));



                            this.setState({
                                B2bMeetingList: modifiedArray,
                                B2bMeetingListmodal: modifiedArrayModal,
                            }, () => {
                                setTimeout(() => {

                                }, 500);
                            })
                            resolve(true)
                        }

                        if (actionID === AccountTypeActionId) {
                            this.setState({
                                accountTypeList: data.data,
                                isLoading: false,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }


    handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            toastError("File size more than 5MB is not allowed.");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        this.setState({
            PersonPhoto: '',
            PersonPhotoPreview: image,
            PersonPhotoName: file.name,
            PersonPhotoType: fileExtension,
            PersonPhotoData: image,
            PersonPhotoErr: ''
        });
    };

    delegateImageUpload = async (e) => {
        const { delegateIndex, GroupDetailsList } = this.state;
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            toastError("File size more than 5MB is not allowed.");
            e.target.value = null;
            return;
        }

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            e.target.value = null;
            return;
        }

        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        const updatedList = [...GroupDetailsList];
        updatedList[delegateIndex] = {
            ...updatedList[delegateIndex],
            PersonPhoto: '',
            PersonPhotoPreview: image,
            PersonPhotoName: file.name,
            PersonPhotoType: fileExtension,
            PersonPhotoData: image.split(',')[1],
            PersonPhotoErr: ''
        };
        this.setState({ GroupDetailsList: updatedList });
    };

    clearFileInput = () => {
        this.setState({
            PersonPhoto: null,
            PersonPhotoPreview: '',
            PersonPhotoName: '',
            PersonPhotoData: '',
            PersonPhotoType: '',
        });
    };

    clearDelegateFileInput = () => {
        const { delegateIndex, GroupDetailsList } = this.state;
        if (delegateIndex === '' || delegateIndex === undefined) return;
        const updatedList = [...GroupDetailsList];
        updatedList[delegateIndex] = {
            ...updatedList[delegateIndex],
            PersonPhoto: '',
            PersonPhotoPreview: '',
            PersonPhotoName: '',
            PersonPhotoData: '',
            PersonPhotoType: '',
        };
        this.setState({ GroupDetailsList: updatedList });
    };

    clearDelegateFileInputModal = () => {
        const { delegateIndex, GroupDetailsList } = this.state;
        console.log(delegateIndex, 'delegateIndex', GroupDetailsList)
        if (delegateIndex === '' || delegateIndex === undefined) {
            this.setState({
                PersonPhotoModal: '',
                PersonPhotoPreviewModal: ''
            })
            // return;
        } else {

            // const updatedList = [...GroupDetailsList];
            GroupDetailsList[delegateIndex].PersonPhoto = ''
            GroupDetailsList[delegateIndex].PersonPhotoPreview = ''
            GroupDetailsList[delegateIndex].PersonPhotoName = ''
            GroupDetailsList[delegateIndex].PersonPhotoData = ''
            GroupDetailsList[delegateIndex].PersonPhotoType = ''

            // updatedList[delegateIndex] = {
            //     ...updatedList[delegateIndex],
            //     PersonPhoto: '',
            //     PersonPhotoPreview: '',
            //     PersonPhotoName: '',
            //     PersonPhotoData: '',
        }
        //     PersonPhotoType: '',
        // };
        this.setState({
            GroupDetailsList: GroupDetailsList, PersonPhotoModal: '',
            PersonPhotoPreviewModal: ''
        });
    };
    handleImageUploadModal = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            toastError("File size more than 5MB is not allowed.");
            e.target.value = null;
            this.clearDelegateFileInputModal();
            return;
        }

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            e.target.value = null;
            this.clearDelegateFileInputModal();
            return;
        }

        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        this.setState({
            PersonPhotoModal: '',
            PersonPhotoPreviewModal: image,
            PersonPhotoNameModal: file.name,
            PersonPhotoTypeModal: fileExtension,
            PersonPhotoDataModal: image, // remove base64 prefix
            PersonPhotoModalErr: ''
        });
    };

    clearFileInputModal = () => {
        this.setState({
            PersonPhotoModal: null,
            PersonPhotoPreviewModal: '',
            PersonPhotoNameModal: '',
            PersonPhotoDataModal: '',
            PersonPhotoTypeModal: '',
        });
    };
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 500, 600, "JPEG", 80, 0,
                (uri) => { resolve(uri); },
                "base64", 300, 300);
        });

    onCountrySelect(e, status) {
        const { countryList } = this.state
        var countryId = e.target.value
        if (countryId != '') {
            if (status == 1) {
                this.setState({ countryIdModal: countryId, countryIdErrModal: "" })
                var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNoModal: `+${countryCode}`,
                    preWhatsAppMobNoModal: `+${countryCode}`,
                    preApplicantMobNoModal: `+${countryCode}`,
                })
                if (countryId == 91) {
                    this.setState({ needVisaAssistanceModal: false })
                    this.setState({
                        passNameErrModal: "",
                        applicantMobNoErrModal: "",
                        applicantEmailErrModal: "",
                        passNoErrModal: "",
                        passDateErrModal: "",
                        passExipryDateErrModal: "",
                        passCountryErrModal: "",
                        passportFileErrModal: "",
                        applicantEmailErrModal: "",
                        mobNoModal: '',
                        whatsAppMobNoModal: '',
                        mobNoErrModal: '',
                        whatsAppMobNoErrModal: '',
                        pincodeModal: ''
                    });
                }
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
            } else if (status == 2) {
                this.setState({ passCountry: countryId, passCountryErr: "" })
            } else if (status == 3) {
                this.setState({ passCountryModal: countryId, passCountryErrModal: "" })
            } else {
                this.setState({ countryId: countryId, countryIdErr: "" })
                var countryCode = countryList.filter(obj => obj.Code == countryId)[0].CountryCode
                this.setState({
                    preMobNo: `+${countryCode}`,
                    preWhatsAppMobNo: `+${countryCode}`,
                    preApplicantMobNo: `+${countryCode}`,
                })
                if (countryId == 91) {
                    this.setState({ needVisaAssistance: false })
                    this.setState({
                        passNameErr: "",
                        applicantMobNoErr: "",
                        applicantEmailErr: "",
                        passNoErr: "",
                        passDateErr: "",
                        passExipryDateErr: "",
                        passCountryErr: "",
                        passportFileErr: "",
                        applicantEmailErr: "",
                        mobNo: '',
                        whatsAppMobNo: '',
                        mobNoErr: '',
                        whatsAppMobNoErr: '',
                        pincode: ''
                    });
                }
                this.getFillList(pincodeActionId, '', '', countryId, '', '')
                this.getFillList(stateActionId, '', '', countryId, '', '')
                this.getFillList(cityActionId, '', '', countryId, '', '')
            }
            setTimeout(() => {
                this.setState({
                    isDisplayPincodeList: false,
                    isDisplayCityList: false,
                    isDisplayStateList: false,
                    isDisplayPincodeListModal: false,
                    isDisplayCityListModal: false,
                    isDisplayStateListModal: false,
                })
            }, 200);
        }
    }

    onFilePick = async (e, file, key) => {
        e.preventDefault()
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    passportFile: '',
                    passPortFileName: '',
                    passportFileType: '',
                    passportFilePath: '',
                })
                document.getElementById("passportFile").value = ""
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString(), isVisaApplied: true })
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    this.setState({
                        passportFile: '',
                        passPortFileName: '',
                        passportFileType: '',
                        passportFilePath: '',
                    })
                    document.getElementById("passportFile").value = ""
                }
            }
        } else {
            this.setState({
                passportFile: '',
                passPortFileName: '',
                passportFileType: '',
                passportFilePath: '',
            })
            document.getElementById("passportFile").value = ""
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    onFilePickModal = async (e, file, key) => {
        e.preventDefault()
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    passportFileModal: '',
                    passPortFileNameModal: '',
                    passportFileTypeModal: '',
                    passportFilePathModal: '',
                })
                document.getElementById("passportFileModal").value = ""
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFileModal(file[0]);
                        if (key == 1) {
                            this.setState({ passportFileModal: image, passportFileErrModal: "", passPortFileNameModal: file[0]['name'].toString(), isVisaAppliedModal: true })
                        } else if (key == 2) {
                            this.setState({ visitorLetterFile: image })
                        }
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelectModal(file[0]);
                        if (key == 1) {
                            this.setState({ passportFileModal: image, passportFileErrModal: "", passPortFileNameModal: file[0]['name'].toString(), isVisaAppliedModal: true })
                        } else if (key == 2) {
                            this.setState({ visitorLetterFile: image })
                        }
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    if (key == 1) {
                        this.setState({ passportFileTypeModal: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    } else if (key == 2) {
                        this.setState({ visitorLetterFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    this.setState({
                        passportFileModal: '',
                        passPortFileNameModal: '',
                        passportFileTypeModal: '',
                        passportFilePathModal: '',
                    })
                    document.getElementById("passportFileModal").value = ""
                }
            }
        } else {
            this.setState({
                passportFileModal: '',
                passPortFileNameModal: '',
                passportFileTypeModal: '',
                passportFilePathModal: '',
            })
            document.getElementById("passportFileModal").value = ""
        }
    }

    onPdfSelectModal = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    resizeFileModal = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onCrossClick(key, mode) {
        const { isPassportFilePresent } = this.state
        if (isPassportFilePresent) {
            const { isOpen3 } = this.state
            this.setState({ isOpen3: !isOpen3, onCrossClickFlagCoordinator: true })
        } else {
            if (key == 1) {
                if (mode == 1) {
                    this.setState({ passportFile: "", isVisaApplied: false })
                } else {
                    this.setState({ passportFile: "", isVisaApplied: false })
                    document.getElementById("passportFile").value = ""
                }
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
    }

    onCrossClickModal(key, mode) {
        const { isPassportFilePresentModal } = this.state
        if (isPassportFilePresentModal) {
            const { isOpen3 } = this.state
            this.setState({ isOpen3: !isOpen3, onCrossClickFlagCoordinator: false })
        } else {
            if (key == 1) {
                if (mode == 1) {
                    this.setState({ passportFileModal: "", isVisaAppliedModal: false })
                } else {
                    this.setState({ passportFileModal: "", isVisaAppliedModal: false })
                    document.getElementById("passportFileModal").value = ""
                }
            } else if (key == 2) {
                this.setState({ visitorLetterFile: "" })
                document.getElementById("visitorLetter").value = ""
            }
        }
    }

    onPincodeSearch(e, status) {
        const { pincodeList, tempPincodeList, tempGroupPincodeList } = this.state
        if (status == 1) {
            if (e.target.value != '') {
                var searchPincodeList = tempGroupPincodeList.filter(data => {
                    return (
                        data
                            .Pincode
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    pincodeModal: e.target.value,
                    pincodeErrModal: "",
                    tempGroupPincodeList: searchPincodeList,
                    isDisplayPincodeListModal: true
                })
            } else {
                this.setState({
                    pincodeModal: e.target.value,
                    tempGroupPincodeList: pincodeList,
                    isDisplayPincodeListModal: false
                })
            }
        } else {
            if (e.target.value != '') {
                var searchPincodeList = tempPincodeList.filter(data => {
                    return (
                        data
                            .Pincode
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                    )
                })
                this.setState({
                    pincode: e.target.value,
                    pincodeErr: "",
                    tempPincodeList: searchPincodeList,
                    isDisplayPincodeList: true
                })
            } else {
                this.setState({
                    pincode: e.target.value,
                    tempPincodeList: pincodeList,
                    isDisplayPincodeList: false
                })
            }
        }
    }
    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPincodeList.length > 0 && tempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.setState({
                                pincode: data.Pincode,
                                isDisplayPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }
    renderGroupPincodeList() {
        const { tempGroupPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempGroupPincodeList.length > 0 && tempGroupPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.setState({
                                pincodeModal: data.Pincode,
                                isDisplayPincodeListModal: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }
    onStateSearch(e, status) {
        const { tempStateList, stateList, tempGroupStateList, countryId } = this.state
        if (countryId == 91 && !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '') {
        } else {
            if (status == 1) {
                if (e.target.value != '') {
                    var searchStateList = tempGroupStateList.filter(data => {
                        return (
                            data
                                .Description
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                        )
                    })
                    this.setState({
                        regStateModal: e.target.value,
                        regStateErrModal: "",
                        tempGroupStateList: searchStateList,
                        isDisplayStateListModal: true
                    })
                } else {
                    this.setState({
                        regStateModal: e.target.value,
                        tempGroupStateList: stateList,
                        isDisplayStateListModal: false
                    })
                }
            } else {
                if (e.target.value != '') {
                    var searchStateList = tempStateList.filter(data => {
                        return (
                            data
                                .Description
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                        )
                    })
                    this.setState({
                        regState: e.target.value,
                        regStateErr: "",
                        tempStateList: searchStateList,
                        isDisplayStateList: true
                    })
                } else {
                    this.setState({
                        regState: e.target.value,
                        tempStateList: stateList,
                        isDisplayStateList: false
                    })
                }
            }
        }

    }
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempStateList.length > 0 && tempStateList.map(data => (
                        <li
                            class="list-group-item"
                            key={Math.random()}
                            onClick={() => this.callStateList(data.Description, data.Code)}
                        >
                            {data.Description}
                        </li>

                    ))
                }
            </ul>
        )
    }
    renderGroupStateList() {
        const { tempGroupStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempGroupStateList.length > 0 && tempGroupStateList.map(data => (
                        <li
                            class="list-group-item"
                            key={Math.random()}
                            onClick={() => this.callStateListModal(data.Description, data.Code)}
                        >
                            {data.Description}
                        </li>

                    ))
                }
            </ul>
        )
    }
    callStateList(value, id) {
        const { stateList, stateName, tempStateList } = this.state;
        this.setState({ regState: value, stateId: id, isDisplayStateList: false, });
    }
    callStateListModal(value, id) {
        const { stateList, stateName, tempStateList } = this.state;
        this.setState({ regStateModal: value, stateIdModal: id, isDisplayStateListModal: false });
    }
    onCitySearch(e, status) {
        const { cityList, tempCityList, tempGroupCityList, countryId } = this.state
        if (countryId == 91 && !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '') {
        } else {
            if (status == 1) {
                if (e.target.value != '') {
                    var searchCityList = tempGroupCityList.filter(data => {
                        return (
                            data
                                .Description
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                        )
                    })
                    this.setState({
                        cityModal: e.target.value,
                        cityErrModal: "",
                        tempGroupCityList: searchCityList,
                        isDisplayCityListModal: true
                    })
                } else {
                    this.setState({
                        cityModal: e.target.value,
                        tempGroupCityList: cityList,
                        isDisplayCityListModal: false
                    })
                }
            } else {
                if (e.target.value != '') {
                    var searchCityList = tempCityList.filter(data => {
                        return (
                            data
                                .Description
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                        )
                    })
                    this.setState({
                        city: e.target.value,
                        cityErr: "",
                        tempCityList: searchCityList,
                        isDisplayCityList: true
                    })
                } else {
                    this.setState({
                        city: e.target.value,
                        tempCityList: cityList,
                        isDisplayCityList: false
                    })
                }
            }
        }
    }
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.setState({ city: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }
    renderGroupCityList() {
        const { tempGroupCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempGroupCityList.length > 0 && tempGroupCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.setState({ cityModal: data.Description, isDisplayCityListModal: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }
    onPreviousClick(e) {
        e.preventDefault();
        const win = window.location.replace('https://www.itme-africa.com/', '_blank');
        if (win != null) {
            win.focus();
        }
    }

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    onSameAsMobNoClick(e, status) {
        const { isSameAsMobNo, mobNo, preMobNo, isSameAsMobNoModal, mobNoModal, preMobNoModal } = this.state
        if (status == 1) {
            this.setState({ isSameAsMobNoModal: !isSameAsMobNoModal })
            var checked = e.target.checked
            if (checked) {
                this.setState({
                    whatsAppMobNoModal: mobNoModal,
                    preWhatsAppMobNoModal: preMobNoModal,
                    whatsAppMobNoErrModal: ""
                })
            } else {
                this.setState({
                    whatsAppMobNoErrModal: "",
                })

            }
        } else {
            this.setState({ isSameAsMobNo: !isSameAsMobNo })
            var checked = e.target.checked
            if (checked) {
                this.setState({
                    whatsAppMobNo: mobNo,
                    preWhatsAppMobNo: preMobNo,
                    whatsAppMobNoErr: ""
                })
            } else {
                this.setState({
                    whatsAppMobNo: "",

                })

            }
        }
    }

    verifyEmail(e, status) {
        const { modalID, isModalEdit, GroupDetailsList, DelegateRegistrationID, DelegateRegistrationIDModal } = this.state
        var value = e.target.value
        if (value != "") {
            var sameEmail = false
            if (GroupDetailsList.length > 0) {
                if (status == 1) {
                    if (!isModalEdit) {
                        for (var i = 0; i < GroupDetailsList.length; i++) {
                            if (GroupDetailsList[i].email == value) {
                                sameEmail = true
                                break
                            }
                        }
                    } else {
                        for (var i = 0; i < GroupDetailsList.length; i++) {
                            if (modalID != i) {
                                if (GroupDetailsList[i].email == value) {
                                    sameEmail = true
                                    break
                                }
                            }
                        }
                    }
                } else {
                    for (var i = 0; i < GroupDetailsList.length; i++) {
                        if (GroupDetailsList[i].email == value) {
                            sameEmail = true
                            break
                        }
                    }
                }
            }
            if (status == 1) {
                if (this.state.email == value && modalID != 'Coordinator') {
                    sameEmail = true
                }
            }
            if (!sameEmail) {
                var emailError = emailValidator(value)
                if (emailError != '') {
                    status == 1 ? this.setState({ emailErrModal: emailError }) : this.setState({ emailErr: emailError })
                } else {
                    this.setState({ isLoading: true })
                    this.props.verifyVisitorEmail_action(value, status == 1 ? DelegateRegistrationIDModal : DelegateRegistrationID)
                        .then((data) => {
                            if (data && data.error != 1) {
                                this.setState({ isLoading: false })
                                if (data.data['ErrMsg'] != "" && data.data['ErrMsg'] != null) {
                                    status == 1 ? this.setState({ emailErrModal: data.data['ErrMsg'] }) : status == 2 ? this.setState({ applicantEmailErr: data.data['ErrMsg'] }) : status == 3 ? this.setState({ applicantEmailErrModal: data.data['ErrMsg'] }) : this.setState({ emailErr: data.data['ErrMsg'] })
                                } else {
                                    status == 1 ? this.setState({ emailErrModal: '' }) : status == 2 ? this.setState({ applicantEmailErr: '' }) : status == 3 ? this.setState({ applicantEmailErrModal: '' }) : this.setState({ emailErr: "" })
                                }
                            } else {
                                this.setState({ isLoading: false })
                                status == 1 ? this.setState({ emailErrModal: '' }) : status == 2 ? this.setState({ applicantEmailErr: '' }) : status == 3 ? this.setState({ applicantEmailErrModal: '' }) : this.setState({ emailErr: "" })
                            }

                        })
                        .catch((err) => {
                        })
                }
            } else {
                status == 1 ? this.setState({ emailErrModal: "Please enter different Email" }) : this.setState({ emailErr: "Please enter different Email" })
            }

        } else {
            status == 1 ? this.setState({ emailErrModal: "Please enter Email" }) : status == 2 ? this.setState({ applicantEmailErr: "Please enter Email" }) : status == 3 ? this.setState({ applicantEmailErrModal: "Please enter Email" }) : this.setState({ emailErr: "Please enter Email" })
        }
    }

    onGSTchange(value, status) {
        const { gstValidtionList, stateId, stateIdModal } = this.state
        var code = value
        if (status == 1) {
            if (code.length >= 2) {
                var code = value.slice(0, 2)
                for (var i = 0; i < gstValidtionList.length; i++) {
                    if (gstValidtionList[i].StateID == stateIdModal) {
                        if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            this.setState({
                                compInfoGstNoErrModal: "Please enter proper gst no",
                            });
                        }
                        else {
                            this.setState({
                                compInfoGstNoModal: value,
                                compInfoGstNoErrModal: ''
                            })
                        }
                    } else {
                        this.setState({
                            compInfoGstNoModal: value,
                        });
                    }
                }
            }
            else {
                this.setState({
                    compInfoGstNoModal: value,
                });
            }
        } else {
            if (code.length >= 2) {
                var code = value.slice(0, 2)
                for (var i = 0; i < gstValidtionList.length; i++) {
                    if (gstValidtionList[i].StateID == stateId) {
                        if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            this.setState({
                                compInfoGstNoErr: "Please enter proper gst no",
                            });
                        }
                        else {
                            this.setState({
                                compInfoGstNo: value,
                                compInfoGstNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            compInfoGstNo: value,
                        });
                    }
                }
            }
            else {
                this.setState({
                    compInfoGstNo: value,
                });
            }
        }
    }

    onSelectPrimaryChapter(e, status) {
        const { chapterList, chapterListModal } = this.state
        var id = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            chapterListModal.length > 0 && chapterListModal.map((data) => {
                if (checked) {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = true
                        if (id == 16) {
                            this.setState({ isOtherOpenModal: true })
                        }
                    }
                }
                else {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = false
                        if (id == 16) {
                            this.setState({ isOtherOpenModal: false })
                        }
                    }
                }
            })
            this.setState({ chapterListModal: chapterListModal, chapterErrModal: "" })
        } else {
            chapterList.length > 0 && chapterList.map((data) => {
                if (checked) {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = true
                        if (id == 16) {
                            this.setState({ isOtherOpen: true })
                        }
                    }
                }
                else {
                    if (id == data.IndustrySegmentID) {
                        data.isSelect = false
                        if (id == 16) {
                            this.setState({ isOtherOpen: false })
                        }
                    }
                }
            })
            this.setState({ chapterList: chapterList, chapterErr: "" })
        }
    }

    onSelectPurpose(e, status) {
        const { visitPurposeList, visitPurposeListModal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            visitPurposeListModal.length > 0 && visitPurposeListModal.map((data) => {
                if (checked) {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = true
                    }
                }
                else {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = false
                        data.otherDetail = ""
                    }

                }
            })
            this.setState({ visitPurposeListModal: visitPurposeListModal, visitPurposeErrModal: "" })
        } else {
            visitPurposeList.length > 0 && visitPurposeList.map((data) => {
                if (checked) {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = true
                    }
                }
                else {
                    if (code == data.PurposeofVisitID) {
                        data.isSelect = false
                        data.otherDetail = ""
                    }

                }
            })
            this.setState({ visitPurposeList: visitPurposeList, visitPurposeErr: "" })
        }
    }

    otherDetailChange(e, status) {
        const { visitPurposeList, visitPurposeListModal } = this.state
        var value = e.target.value
        if (status == 1) {
            visitPurposeListModal.length > 0 && visitPurposeListModal.map((data) => {
                if (data.PurposeofVisitID == 10 && data.isSelect) {
                    data.otherDetail = value
                    this.setState({ visitPurposeErrModal: "" })

                } else {
                    data.otherDetail = ""
                }
            })
            this.setState({ visitPurposeListModal: visitPurposeListModal })
        } else {
            visitPurposeList.length > 0 && visitPurposeList.map((data) => {
                if (data.PurposeofVisitID == 10 && data.isSelect) {
                    data.otherDetail = value
                    this.setState({ visitPurposeErr: "" })
                } else {
                    data.otherDetail = ""
                }
            })
            this.setState({ visitPurposeList: visitPurposeList })
        }
    }

    toggleModel(id, index) {
        const { GroupDetailsList, firstName, lastName, seminarInterestList, countryId, preMobNo, preWhatsAppMobNo, gender, designation, institute, IECCode, Address1, Address2, Address3, pincode, regState, city, email, website, companywebsite, mobNo, whatsAppMobNo, telNo, tel1No, compInfoGstNo, visitPurposeList, stateId, compInfoPanNo, other, chapterList, companyProfile, isOpen, totalYears, turnOverId,
            chapterListModal, isInterestTwo, visitPurposeListModal, daysList, departureDate, arrivalDate, level2, level2Modal, level3, level3Modal, level4, level4Modal, primaryChapterListData, primaryChapterListDataModal, needVisaAssistance, passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate, passCountry, passportFile, B2bMeetingList, B2bMeetingListmodal
        } = this.state

        this.setState({ delegateIndex: index })

        var Err = true
        if (firstName == "" && this.showMandatoryFields(2, 0) && this.showMandatoryFields(2, 2)) {
            this.setState({ firstNameErr: "Please enter first name" });
            Err = false
        }
        if (lastName == "" && this.showMandatoryFields(3, 0) && this.showMandatoryFields(3, 2)) {
            this.setState({ lastNameErr: "Please enter last name" });
            Err = false
        }
        if (gender == "" && this.showMandatoryFields(4, 0) && this.showMandatoryFields(4, 2)) {
            this.setState({ genderErr: "Please select Gender" });
            Err = false
        }
        if (designation == "" && this.showMandatoryFields(5, 0) && this.showMandatoryFields(5, 2)) {
            this.setState({ designationErr: "Please enter designation" });
            Err = false
        }
        if (institute == "" && this.showMandatoryFields(6, 0) && this.showMandatoryFields(6, 2)) {
            this.setState({ instituteErr: "Please enter institue/Organization" });
            Err = false
        }
        if (Address1 == "" && this.showMandatoryFields(10, 0) && this.showMandatoryFields(10, 2)) {
            this.setState({ Address1Err: "Please enter Address" });
            Err = false
        }
        if (Address2 == "" && this.showMandatoryFields(11, 0) && this.showMandatoryFields(11, 2)) {
            this.setState({ Address2Err: "Please enter Address 2" });
            Err = false
        }
        if (Address3 == "" && this.showMandatoryFields(12, 0) && this.showMandatoryFields(12, 2)) {
            this.setState({ Address3Err: "Please enter Address 3" });
            Err = false
        }
        if (website == "" && this.showMandatoryFields(17, 0) && this.showMandatoryFields(17, 2)) {
            this.setState({ websiteErr: "Please enter website" });
            Err = false
        }
        if (telNo == "" && this.showMandatoryFields(18, 0) && this.showMandatoryFields(18, 2)) {
            this.setState({ telephoneErr: "Please enter telephone No" });
            Err = false
        }
        if (tel1No == "" && this.showMandatoryFields(19, 0) && this.showMandatoryFields(19, 2)) {
            this.setState({ telephone1Err: "Please enter telephone No 1" });
            Err = false
        }
        if (IECCode == "" && this.showMandatoryFields(9, 0) && this.showMandatoryFields(9, 2)) {
            this.setState({ IECCodeErr: "Please enter IEC Code " });
            Err = false
        }
        if (mobNo == "" && this.showMandatoryFields(21, 0) && this.showMandatoryFields(21, 2)) {
            this.setState({ mobNoErr: "Please enter mobile no" });
            Err = false
        }
        if (whatsAppMobNo == "" && this.showMandatoryFields(22, 0) && this.showMandatoryFields(22, 2)) {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
            Err = false
        }
        if (regState == "" && countryId == "91" && this.showMandatoryFields(14, 0) && this.showMandatoryFields(14, 2)) {
            this.setState({ regStateErr: "Please enter province/state" });
            Err = false
        }
        if (city == "" && this.showMandatoryFields(13, 0) && this.showMandatoryFields(13, 2)) {
            this.setState({ cityErr: "Please enter city" });
            Err = false
        }
        if (pincode == "" && this.showMandatoryFields(15, 0) && this.showMandatoryFields(15, 2)) {
            this.setState({ pincodeErr: "Please enter Pincode" });
            Err = false
        }
        if (email == "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            this.setState({ emailErr: "Please enter Email" });
            Err = false
        }
        if (email != "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            var emailError = emailValidator(email)
            if (emailError != '') {
                this.setState({ emailErr: emailError })
                Err = false
            }
        }
        if (this.state.emailErr != "") {
            Err = false
        }
        if (companyProfile == "" && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)) {
            this.setState({ companyProfileErr: "Please enter Company profile" });
            Err = false
        }
        if (countryId == "" && this.showMandatoryFields(20, 0) && this.showMandatoryFields(20, 2)) {
            this.setState({ countryIdErr: "Please select country" });
            Err = false
        }
        if (totalYears == "" && this.showMandatoryFields(25, 0) && this.showMandatoryFields(25, 2)) {
            this.setState({ totalYearsErr: "Please enter Total Years the Company Is Operational" });
            Err = false
        }
        if (turnOverId == "" && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)) {
            this.setState({ turnOverErr: "Please Fill Company Profile " });
            Err = false
        }
        if (compInfoGstNo == "" && countryId == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            this.setState({ compInfoGstNoErr: "Please enter GST no" });
            Err = false
        } else if (countryId == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            var errMsg = ''
            errMsg = gstNoValidator(compInfoGstNo)
            if (errMsg != '') {
                Err = false
                this.setState({ compInfoGstNoErr: errMsg });
            }
            else {
                this.setState({ compInfoGstNoErr: "" });
            }
        }
        if (compInfoPanNo == "" && countryId == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            this.setState({ compInfoPanNoErr: "Please enter Pan no" });
            Err = false
        } else if (countryId == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            var errMsg = ''
            errMsg = panNoValidator(compInfoPanNo)
            if (errMsg != '') {
                Err = false
                this.setState({ compInfoPanNoErr: errMsg });
            }
            else {
                this.setState({ compInfoPanNoErr: "" });
            }
        }

        const selectedChapter = chapterList.filter(data => data.isSelect == true)
        var chapterListData = []
        selectedChapter.map((data) => {
            var data = {
                "ChapterID": data.IndustrySegmentID,
                "ChapterName": data['Industrial Segment'],
                "OtherNames": data.IndustrySegmentID == 16 ? other : ''
            }
            chapterListData.push(data)
        })

        const purposeOfVisitlist = visitPurposeList.filter(data => data.isSelect == true)
        var purposeOfVisitlistData = []
        purposeOfVisitlist.map((data) => {
            var data = {
                "PurposeofVisitID": data.PurposeofVisitID,
                "otherDetail": data.otherDetail
            }
            purposeOfVisitlistData.push(data)
        })
        var otherPOV = false
        purposeOfVisitlistData.map((data) => {
            otherPOV = data.PurposeofVisitID == 10 && (data.otherDetail == '' || data.otherDetail == null) ? true : false
        })
        if ((purposeOfVisitlistData.length == 0 || otherPOV) && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            this.setState({ visitPurposeErr: "Please select Purpose of visit" })
            Err = false
        }

        const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
        var seminarInterestListData = []
        selectedSeminarList.map((data) => {
            var data = {
                "SeminarID": data.SeminarID,
            }
            seminarInterestListData.push(data)
        })

        var selectedDays = []
        selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        if (list.length == 0 && ((!isInterestTwo && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2)))) {
            this.setState({ daysErr: "Please select Visit Days" })
            Err = false
        } else {
            this.setState({ daysErr: "" })
        }

        var B2bList = []
        B2bMeetingList.length > 0 && B2bMeetingList.map(data => {
            data.timeSlotList.map(item => {
                if (item.isSelect) {
                    B2bList.push(item)
                }
            })
        })
        var B2bListfinal = []
        B2bList.length > 0 && B2bList.map(data => {
            var item = {
                "B2BTimeSlotID": data.B2BTimeSlotID
            }
            B2bListfinal.push(item)
        })

        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        var chapterListData2 = []
        filerArray.map((data) => {
            var data = {
                "ChapterID": data.ChapterID,
                "ChapterName": data.ChapterName,

            }
            chapterListData2.push(data)
        })
        var visaErr = false
        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
                visaErr = true
                Err = false
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
                visaErr = true
                Err = false
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
                visaErr = true
                Err = false
            }
            if (passDate == "") {
                this.setState({ passDateErr: "Please enter Passport Date " });
                visaErr = true
                Err = false
            }
            if (passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
                visaErr = true
                Err = false
            }
            if (passCountry == "") {
                this.setState({ passCountryErr: "Please Select Country " });
                visaErr = true
                Err = false
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email" });
                visaErr = true
                Err = false
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    visaErr = true
                    Err = false
                }
            }
            if (visaErr) {
                if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2)) {
                    this.setState({ visaErr: "Please Fill Visa Assistance" })
                    Err = false
                }
            } else {
                this.setState({ visaErr: "" })
            }
        } else {
            this.setState({
                passNameErr: "",
                applicantMobNoErr: "",
                applicantEmailErr: "",
                passNoErr: "",
                passDateErr: "",
                passExipryDateErr: "",
                passCountryErr: "",
                passportFileErr: "",
                applicantEmailErr: "",
                visaErr: ''
            });

        }

        for (var i = 0; i < GroupDetailsList.length; i++) {
            GroupDetailsList[i].B2BmappingList.length > 0 && GroupDetailsList[i].B2BmappingList.map(item2 => {
                B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map(item => {
                    item.timeSlotList.length > 0 && item.timeSlotList.map(element => {
                        if (element.B2BTimeSlotID == item2.B2BTimeSlotID) {
                            element.IsBooked = true
                        }
                    })
                })
            })
            this.setState({ B2bMeetingListmodal: B2bMeetingListmodal }, () => {
            })
        }
        var b2bIDarr = []
        B2bMeetingList.length > 0 && B2bMeetingList.map(item => {
            item.timeSlotList.length > 0 && item.timeSlotList.map(element => {
                if (element.isSelect) {
                    b2bIDarr.push(element.B2BTimeSlotID)
                }
            })
        })
        b2bIDarr.length > 0 && b2bIDarr.map(item2 => {
            B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map(item => {
                item.timeSlotList.length > 0 && item.timeSlotList.map(element => {
                    if (element.B2BTimeSlotID == item2) {
                        element.IsBooked = true
                    }
                })
            })
        })
        this.setState({ B2bMeetingListmodal: B2bMeetingListmodal }, () => {
        })
        setTimeout(() => {
            if (Err) {
                if (id != undefined && id != null) {
                    this.handleEditGroupDetail(id)
                } else {
                    chapterList.length > 0 && chapterList.map(data => {
                        if (data.isSelect) {
                            chapterListModal.length > 0 && chapterListModal.map(data2 => {
                                if (data.IndustrySegmentID == data2.IndustrySegmentID) {
                                    data2.isSelect = true
                                }
                            })
                        }
                    })

                    visitPurposeList.length > 0 && visitPurposeList.map(data => {
                        if (data.isSelect) {
                            visitPurposeListModal.length > 0 && visitPurposeListModal.map(data2 => {
                                if (data.PurposeofVisitID == data2.PurposeofVisitID) {
                                    data2.isSelect = true
                                }
                            })
                        }
                    })

                    primaryChapterListData.length > 0 && primaryChapterListData.map(data => {
                        if (data.isSelect) {
                            primaryChapterListDataModal.length > 0 && primaryChapterListDataModal.map(data2 => {
                                if (data.ChapterID == data2.ChapterID) {
                                    data2.isSelect = true
                                }
                            })
                        }
                    })

                    level2.length > 0 && level2.map(data => {
                        if (data.isSelect) {
                            level2Modal.length > 0 && level2Modal.map(data2 => {
                                if (data.ChapterID == data2.ChapterID) {
                                    data2.isSelect = true
                                }
                            })
                        }
                    })

                    level3.length > 0 && level3.map(data => {
                        if (data.isSelect) {
                            level3Modal.length > 0 && level3Modal.map(data2 => {
                                if (data.ChapterID == data2.ChapterID) {
                                    data2.isSelect = true
                                }
                            })
                        }
                    })

                    level4.length > 0 && level4.map(data => {
                        if (data.isSelect) {
                            level4Modal.length > 0 && level4Modal.map(data2 => {
                                if (data.ChapterID == data2.ChapterID) {
                                    data2.isSelect = true
                                }
                            })
                        }
                    })

                    this.setState({
                        instituteModal: institute,
                        IECCodeModal: IECCode,
                        regStateModal: regState,
                        countryIdModal: countryId,
                        websiteModal: website,
                        cityModal: city,
                        stateIdModal: countryId == 91 ? stateId : '',
                        pincodeModal: pincode,
                        companyProfileModal: companyProfile,
                        companywebsiteModal: companywebsite,
                        totalYearsModal: totalYears,
                        turnOverIdModal: turnOverId,
                        arrivalDateModal: arrivalDate,
                        departureDateModal: departureDate,
                        chapterListModal: chapterListModal,
                        visitPurposeListModal: visitPurposeListModal,
                        primaryChapterListDataModal: primaryChapterListDataModal,
                        level2Modal: level2Modal,
                        level3Modal: level3Modal,
                        level4Modal: level4Modal,
                        preMobNoModal: `${preMobNo}`,
                        preWhatsAppMobNoModal: `${preWhatsAppMobNo}`,
                    }, () => {
                        this.setState({
                            isOpenDropDownState: false,
                            focusedIndexState: -1,
                            isOpenDropDownStateModal: false,
                            focusedIndexStateModal: -1,

                            isOpenDropDownCity: false,
                            focusedIndexCity: -1,
                            isOpenDropDownCityModal: false,
                            focusedIndexCityModal: -1,

                            isOpenDropDownPin: false,
                            focusedIndexPin: -1,
                            isOpenDropDownPinModal: false,
                            focusedIndexPinModal: -1,
                        })
                    })
                    this.setState({ isOpen: !isOpen })
                }
            } else {
                toastError("Please enter mandatory fields")
            }
        }, 200);
    }

    toggleModel1(status) {
        const { GroupDetailsList, isOpen2, firstName,
            lastName, seminarInterestList, countryId, gender, designation, institute, IECCode, Address1, Address2, Address3, pincode, regState, city, email, website, companywebsite, mobNo, whatsAppMobNo, telNo, tel1No, compInfoGstNo, visitPurposeList, compInfoPanNo, other, chapterList, companyProfile, totalYears, turnOverId, isInterestTwo, daysList, departureDate, arrivalDate, level2, level3, level4, primaryChapterListData, needVisaAssistance, passName, applicantMobNo, applicantEmail, passNo, passDate, passExipryDate, passCountry, passportFile, B2bMeetingList } = this.state
        var Err = true
        if (firstName == "" && this.showMandatoryFields(2, 0) && this.showMandatoryFields(2, 2)) {
            this.setState({ firstNameErr: "Please enter first name" });
            Err = false
        }
        if (lastName == "" && this.showMandatoryFields(3, 0) && this.showMandatoryFields(3, 2)) {
            this.setState({ lastNameErr: "Please enter last name" });
            Err = false
        }
        if (gender == "" && this.showMandatoryFields(4, 0) && this.showMandatoryFields(4, 2)) {
            this.setState({ genderErr: "Please select Gender" });
            Err = false
        }
        if (designation == "" && this.showMandatoryFields(5, 0) && this.showMandatoryFields(5, 2)) {
            this.setState({ designationErr: "Please enter designation" });
            Err = false
        }
        if (institute == "" && this.showMandatoryFields(6, 0) && this.showMandatoryFields(6, 2)) {
            this.setState({ instituteErr: "Please enter institue/Organization" });
            Err = false
        }
        if (Address1 == "" && this.showMandatoryFields(10, 0) && this.showMandatoryFields(10, 2)) {
            this.setState({ Address1Err: "Please enter Address" });
            Err = false
        }
        if (Address2 == "" && this.showMandatoryFields(11, 0) && this.showMandatoryFields(11, 2)) {
            this.setState({ Address2Err: "Please enter Address 2" });
            Err = false
        }
        if (Address3 == "" && this.showMandatoryFields(12, 0) && this.showMandatoryFields(12, 2)) {
            this.setState({ Address3Err: "Please enter Address 3" });
            Err = false
        }
        if (website == "" && this.showMandatoryFields(17, 0) && this.showMandatoryFields(17, 2)) {
            this.setState({ websiteErr: "Please enter website" });
            Err = false
        }
        if (telNo == "" && this.showMandatoryFields(18, 0) && this.showMandatoryFields(18, 2)) {
            this.setState({ telephoneErr: "Please enter telephone No" });
            Err = false
        }
        if (tel1No == "" && this.showMandatoryFields(19, 0) && this.showMandatoryFields(19, 2)) {
            this.setState({ telephone1Err: "Please enter telephone No 1" });
            Err = false
        }
        if (IECCode == "" && this.showMandatoryFields(9, 0) && this.showMandatoryFields(9, 2)) {
            this.setState({ IECCodeErr: "Please enter IEC Code " });
            Err = false
        }
        if (mobNo == "" && this.showMandatoryFields(21, 0) && this.showMandatoryFields(21, 2)) {
            this.setState({ mobNoErr: "Please enter mobile no" });
            Err = false
        }
        if (whatsAppMobNo == "" && this.showMandatoryFields(22, 0) && this.showMandatoryFields(22, 2)) {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
            Err = false
        }
        if (regState == "" && countryId == "91" && this.showMandatoryFields(14, 0) && this.showMandatoryFields(14, 2)) {
            this.setState({ regStateErr: "Please enter province/state" });
            Err = false
        }
        if (city == "" && this.showMandatoryFields(13, 0) && this.showMandatoryFields(13, 2)) {
            this.setState({ cityErr: "Please enter city" });
            Err = false
        }
        if (pincode == "" && this.showMandatoryFields(15, 0) && this.showMandatoryFields(15, 2)) {
            this.setState({ pincodeErr: "Please enter Pincode" });
            Err = false
        }
        if (email == "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            this.setState({ emailErr: "Please enter Email" });
            Err = false
        }
        if (email != "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            var emailError = emailValidator(email)
            if (emailError != '') {
                this.setState({ emailErr: emailError })
                Err = false
            }
        }
        if (this.state.emailErr != "") {
            Err = false
        }
        if (companyProfile == "" && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)) {
            this.setState({ companyProfileErr: "Please enter Company profile" });
            Err = false
        }
        if (countryId == "" && this.showMandatoryFields(20, 0) && this.showMandatoryFields(20, 2)) {
            this.setState({ countryIdErr: "Please select country" });
            Err = false
        }
        if (totalYears == "" && this.showMandatoryFields(25, 0) && this.showMandatoryFields(25, 2)) {
            this.setState({ totalYearsErr: "Please enter Total Years the Company Is Operational" });
            Err = false
        }
        if (turnOverId == "" && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)) {
            this.setState({ turnOverErr: "Please Fill Company turn Over" });
            Err = false
        }
        if (compInfoGstNo == "" && countryId == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            this.setState({ compInfoGstNoErr: "Please enter GST no" });
            Err = false
        } else if (countryId == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            var errMsg = ''
            errMsg = gstNoValidator(compInfoGstNo)
            if (errMsg != '') {
                Err = false
                this.setState({ compInfoGstNoErr: errMsg });
            }
            else {
                this.setState({ compInfoGstNoErr: "" });
            }
        }
        if (compInfoPanNo == "" && countryId == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            this.setState({ compInfoPanNoErr: "Please enter Pan no" });
            Err = false
        } else if (countryId == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            var errMsg = ''
            errMsg = panNoValidator(compInfoPanNo)
            if (errMsg != '') {
                Err = false
                this.setState({ compInfoPanNoErr: errMsg });
            }
            else {
                this.setState({ compInfoPanNoErr: "" });
            }
        }

        const selectedChapter = chapterList.filter(data => data.isSelect == true)
        var chapterListData = []
        selectedChapter.map((data) => {
            var data = {
                "ChapterID": data.IndustrySegmentID,
                "ChapterName": data['Industrial Segment'],
                "OtherNames": data.IndustrySegmentID == 16 ? other : ''
            }
            chapterListData.push(data)
        })

        const purposeOfVisitlist = visitPurposeList.filter(data => data.isSelect == true)
        var purposeOfVisitlistData = []
        purposeOfVisitlist.map((data) => {
            var data = {
                "PurposeofVisitID": data.PurposeofVisitID,
                "otherDetail": data.otherDetail
            }
            purposeOfVisitlistData.push(data)
        })
        var otherPOV = false
        purposeOfVisitlistData.map((data) => {
            otherPOV = data.PurposeofVisitID == 10 && (data.otherDetail == '' || data.otherDetail == null) ? true : false
        })
        if (otherPOV && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            this.setState({ visitPurposeErr: "Please enter other purpose of visit" })
            Err = false
        }
        if (purposeOfVisitlistData.length == 0 && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            this.setState({ visitPurposeErr: "Please select Purpose of visit" })
            Err = false
        }

        const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
        var seminarInterestListData = []
        selectedSeminarList.map((data) => {
            var data = {
                "SeminarID": data.SeminarID,
            }
            seminarInterestListData.push(data)
        })


        var selectedDays = []
        selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        if (list.length == 0 && ((!isInterestTwo && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2)))) {
            this.setState({ daysErr: "Please select Visit Days" })
            Err = false
        } else {
            this.setState({ daysErr: "" })
        }

        var B2bList = []
        B2bMeetingList.length > 0 && B2bMeetingList.map(data => {
            data.timeSlotList.map(item => {
                if (item.isSelect) {
                    B2bList.push(item)
                }
            })
        })
        var B2bListfinal = []
        B2bList.length > 0 && B2bList.map(data => {
            var item = {
                "B2BTimeSlotID": data.B2BTimeSlotID
            }
            B2bListfinal.push(item)
        })


        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        var chapterListData2 = []
        filerArray.map((data) => {
            var data = {
                "ChapterID": data.ChapterID,
                "ChapterName": data.ChapterName,

            }
            chapterListData2.push(data)
        })


        var visaErr = false
        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
                visaErr = true
                Err = false
            }
            if (applicantMobNo == "") {
                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email " });
                visaErr = true
                Err = false
            }

            if (passNo == "") {
                this.setState({ passNoErr: "Please enter Passport No " });
                visaErr = true
                Err = false
            }
            if (passDate == "") {
                this.setState({ passDateErr: "Please enter Passport Date " });
                visaErr = true
                Err = false
            }
            if (passExipryDate == "") {
                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
                visaErr = true
                Err = false
            }
            if (passCountry == "") {
                this.setState({ passCountryErr: "Please Select Country " });
                visaErr = true
                Err = false
            }
            if (passportFile == "") {
                this.setState({ passportFileErr: "Please Upload File " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {
                this.setState({ applicantEmailErr: "Please enter Email" });
                visaErr = true
                Err = false
            }
            if (applicantEmail != "") {
                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {
                    this.setState({ applicantEmailErr: emailError })
                    visaErr = true
                    Err = false
                }
            }
            if (visaErr) {
                if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2)) {
                    this.setState({ visaErr: "Please Fill Visa Assistance" })
                    Err = false
                }
            } else {
                this.setState({ visaErr: "" })
            }
        } else {
            this.setState({
                passNameErr: "",
                applicantMobNoErr: "",
                applicantEmailErr: "",
                passNoErr: "",
                passDateErr: "",
                passExipryDateErr: "",
                passCountryErr: "",
                passportFileErr: "",
                applicantEmailErr: "",
                visaErr: ""
            });

        }



        if (Err) {
            this.setState({ isOpen2: !isOpen2, isFirst: false, })
            if (status == 1) {
                this.setState({ isCoordinatorAsDelegate: true })
                this.toggleModel()
            } else if (status == 0) {
                this.setState({ isCoordinatorAsDelegate: false })
                this.toggleModel()
            }
        } else {
            toastError("Please enter mandatory fields")
        }
    }

    renderGroupList() {
        const { GroupDetailsList, onJustSubmit } = this.state
        return (
            <div className="mt-4 px-2" style={{ position: 'relative', zIndex: 1 }}>
                {
                    GroupDetailsList.length > 0 && GroupDetailsList.map((data, index) => (<>
                        {data.IsCoordinator != true && (
                            <div className="card mb-3 text-start border" style={{ borderTop: "4px solid #006c5b", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                <div className="card-header bg-white d-flex justify-content-between align-items-center border-bottom-0 pt-0 pb-2">
                                    <h6 className="mb-0" style={{ display: "flex" }}>
                                        Delegate {index + 1}
                                    </h6>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-aqua text-white rounded-2 me-2"
                                            style={{ padding: "4px 12px", fontSize: "14px", fontWeight: "500" }}
                                            onClick={() => this.handleDeleteAdded(data.id)}
                                        >
                                            Delete
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-aqua text-white rounded-2"
                                            style={{ padding: "4px 12px", fontSize: "14px", fontWeight: "500", backgroundColor: "#006c5b", borderColor: "#006c5b" }}
                                            onClick={() => this.toggleModel(data.id, index)}
                                        >
                                            Edit
                                        </button>
                                    </div>
                                </div>
                                <hr className="m-0 mx-3" style={{ opacity: 0.15 }} />
                                <div className="card-body px-4 py-3 text-start">
                                    <div className="row text-start">
                                        {/* Column 1: Personal Information */}
                                        <div className="col-md-4">
                                            <h6 className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: "0.5px" }}>PERSONAL INFORMATION</h6>
                                            <hr className="mb-3 mt-0" style={{ opacity: 0.1, width: "80%" }} />

                                            {this.showMandatoryFields(2, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>First Name</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.firstName || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(3, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Last Name</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.lastName || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(5, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Designation</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.designation || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(6, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Institute/Organisation</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.CompanyName || "-"}</span>
                                            </div>}
                                        </div>

                                        {/* Column 2: Contact Details */}
                                        <div className="col-md-4">
                                            <h6 className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: "0.5px" }}>CONTACT DETAILS</h6>
                                            <hr className="mb-3 mt-0" style={{ opacity: 0.1, width: "80%" }} />

                                            {this.showMandatoryFields(16, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Email</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500", wordBreak: "break-all" }}>{data.PrimaryEmail || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(21, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Mobile</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.mobNo || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(22, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>WhatsApp No</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.whatsAppMobNo || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(17, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Website</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500", wordBreak: "break-all" }}>{data.Website || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(18, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Telephone</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Telephone || "-"}</span>
                                            </div>}
                                            {this.showMandatoryFields(19, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Telephone 1</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Telephone1 || "-"}</span>
                                            </div>}
                                        </div>

                                        {/* Column 3: Location */}
                                        <div className="col-md-4">
                                            <h6 className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: "0.5px" }}>LOCATION</h6>
                                            <hr className="mb-3 mt-0" style={{ opacity: 0.1, width: "80%" }} />

                                            {this.showMandatoryFields(20, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Country</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>
                                                    {this.state.countryList.length > 0 ? this.state.countryList.map(item => item.Code == data.CountryID ? item.Description : '') : "-"}
                                                </span>
                                            </div>}

                                            {this.showMandatoryFields(14, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>State</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.State || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(13, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>City</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.City || "-"}</span>
                                            </div>}

                                            {this.showMandatoryFields(15, 0) && <div className="mb-3">
                                                <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Pincode</small>
                                                <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Pin || "-"}</span>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                    ))
                }
            </div>
        )
    }

    // onCheckedSeminar(e, id) {
    //     const { seminarInterestListModal } = this.state
    //     const checked = e.target.checked
    //     if (checked != undefined) {
    //         seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
    //             if (data.SeminarID == id) {
    //                 if (checked) {
    //                     data.isSelect = true
    //                 } else {
    //                     data.isSelect = false
    //                 }
    //             }
    //         })
    //     } else {
    //         seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
    //             if (data.SeminarID == id) {
    //                 if (data.isSelect) {
    //                     data.isSelect = false
    //                 } else {
    //                     data.isSelect = true
    //                 }
    //             }
    //         })
    //     }
    //     console.log("aaaaaaaaaaa", e.target.checked, seminarInterestListModal)
    //     this.setState({})
    // }
    onCheckedSeminar(e, id, status) {
        const { seminarInterestList, seminarInterestListModal, daysList, daysListModal } = this.state
        const checked = e.target.checked
        if (status == 1) {
            if (checked != undefined) {
                seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
                    if (data.SeminarID == id) {
                        if (checked) {
                            for (var i = 0; i < daysListModal.length; i++) {
                                if (moment(data.Date).isSame(daysListModal[i].VisitDate, "day")) {
                                    this.state.daysListModal[i].isSelect = true
                                }
                            }
                            data.isSelect = true
                        } else {
                            data.isSelect = false
                        }
                    }
                })
            } else {
                seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => {
                    if (data.SeminarID == id) {
                        if (data.isSelect) {
                            data.isSelect = false
                        } else {
                            data.isSelect = true
                        }
                    }
                })
            }
            console.log("aaaaaaaaaaa", e.target.checked, seminarInterestListModal)
            this.setState({ seminarInterestListModal: seminarInterestListModal, SeminarErrModal: '' })
        } else {
            if (checked != undefined) {
                seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                    if (data.SeminarID == id) {
                        console.log(checked, 'checkedchecked', data, this.state.daysList)
                        if (checked) {
                            for (var i = 0; i < daysList.length; i++) {
                                if (moment(data.Date).isSame(daysList[i].VisitDate, "day")) {
                                    this.state.daysList[i].isSelect = true
                                }
                            }
                            data.isSelect = true
                        } else {
                            data.isSelect = false
                        }
                    }
                })
            } else {
                seminarInterestList.length > 0 && seminarInterestList.map((data) => {
                    if (data.SeminarID == id) {
                        if (data.isSelect) {
                            data.isSelect = false
                        } else {
                            data.isSelect = true
                        }
                    }
                })
            }
            this.setState({ seminarInterestList: seminarInterestList, SeminarErr: '', daysListModal: daysListModal, daysList: this.state.daysList })
        }
    }

    handleAddGroupDetail() {
        const {
            companywebsiteModal, other, isModalEdit, isOtherPreNameModal, otherNameModal, firstNameModal, prenameModal, lastNameModal,
            countryIdModal, preMobNoModal, preWhatsAppMobNoModal, genderModal, designationModal, instituteModal, IECCodeModal, Address1Modal,
            Address2Modal, Address3Modal, pincodeModal, regStateModal, cityModal, emailModal, mobNoModal, whatsAppMobNoModal, isSameAsMobNoModal,
            telNoModal, preTelNoModal, tel1NoModal, preTel1NoModal, compInfoGstNoModal, compInfoPanNoModal, chapterListModal, seminarInterestListModal,
            companyProfileModal, websiteModal, totalYearsModal, turnOverIdModal, isInterestTwoModal, visitPurposeListModal, daysListModal,
            departureDateModal, arrivalDateModal, level2Modal, level3Modal, level4Modal, primaryChapterListDataModal, GroupDetailsList,
            B2bMeetingListmodal, passPortFileNameModal, passportFilePathModal, passportFileTypeModal, needVisaAssistanceModal, passNameModal,
            applicantMobNoModal, preApplicantMobNoModal, applicantEmailModal, passNoModal, passDateModal, passExipryDateModal, passCountryModal,
            modalID, passportFileModal, PersonPhotoModal, PersonPhotoPreviewModal, PersonProfileModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoDataModal } = this.state
        var modalErr = true
        if (firstNameModal == "" && this.showMandatoryFields(2, 0) && this.showMandatoryFields(2, 2)) {
            this.setState({ firstNameErrModal: "Please enter first name" });
            modalErr = false
        }
        if (lastNameModal == "" && this.showMandatoryFields(3, 0) && this.showMandatoryFields(3, 2)) {
            this.setState({ lastNameErrModal: "Please enter last name" });
            modalErr = false
        }
        if (genderModal == "" && this.showMandatoryFields(4, 0) && this.showMandatoryFields(4, 2)) {
            this.setState({ genderErrModal: "Please select Gender" });
            modalErr = false
        }
        if (designationModal == "" && this.showMandatoryFields(5, 0) && this.showMandatoryFields(5, 2)) {
            this.setState({ designationErrModal: "Please enter designation" });
            modalErr = false
        }
        if (instituteModal == "" && this.showMandatoryFields(6, 0) && this.showMandatoryFields(6, 2)) {
            this.setState({ instituteErrModal: "Please enter institue/Organization" });
            modalErr = false
        }
        if (Address1Modal == "" && this.showMandatoryFields(10, 0) && this.showMandatoryFields(10, 2)) {
            this.setState({ Address1ErrModal: "Please enter Address" });
            modalErr = false
        } if (Address2Modal == "" && this.showMandatoryFields(11, 0) && this.showMandatoryFields(11, 2)) {
            this.setState({ Address2ErrModal: "Please enter Address 2" });
            modalErr = false
        }
        if (Address3Modal == "" && this.showMandatoryFields(12, 0) && this.showMandatoryFields(12, 2)) {
            this.setState({ Address3ErrModal: "Please enter Address 3" });
            modalErr = false
        }
        if (websiteModal == "" && this.showMandatoryFields(17, 0) && this.showMandatoryFields(17, 2)) {
            this.setState({ websiteErrModal: "Please enter website" });
            modalErr = false
        }
        if (telNoModal == "" && this.showMandatoryFields(18, 0) && this.showMandatoryFields(18, 2)) {
            this.setState({ telephoneErrModal: "Please enter telephone No" });
            modalErr = false
        }
        if (tel1NoModal == "" && this.showMandatoryFields(19, 0) && this.showMandatoryFields(19, 2)) {
            this.setState({ telephone1ErrModal: "Please enter telephone No 1" });
            modalErr = false
        }
        if (IECCodeModal == "" && this.showMandatoryFields(9, 0) && this.showMandatoryFields(9, 2)) {
            this.setState({ IECCodeErrModal: "Please enter IEC Code " });
            modalErr = false
        }
        if (mobNoModal == "" && this.showMandatoryFields(21, 0) && this.showMandatoryFields(21, 2)) {
            this.setState({ mobNoErrModal: "Please enter mobile no" });
            modalErr = false
        }
        if (whatsAppMobNoModal == "" && this.showMandatoryFields(22, 0) && this.showMandatoryFields(22, 2)) {
            this.setState({ whatsAppMobNoErrModal: "Please enter whatsapp no" });
            modalErr = false
        }
        if (regStateModal == "" && countryIdModal == "91" && this.showMandatoryFields(14, 0) && this.showMandatoryFields(14, 2)) {
            this.setState({ regStateErrModal: "Please enter province/state" });
            modalErr = false
        }
        if (cityModal == "" && this.showMandatoryFields(13, 0) && this.showMandatoryFields(13, 2)) {
            this.setState({ cityErrModal: "Please enter city" });
            modalErr = false
        }
        if (pincodeModal == "" && this.showMandatoryFields(15, 0) && this.showMandatoryFields(15, 2)) {
            this.setState({ pincodeErrModal: "Please enter Pincode" });
            modalErr = false
        }
        if (emailModal == "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            this.setState({ emailErrModal: "Please enter Email" });
            modalErr = false
        }
        if (emailModal != "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            var emailError = emailValidator(emailModal)
            if (emailError != '') {
                this.setState({ emailErrModal: emailError })
                modalErr = false
            }
        }
        if (this.state.emailErrModal != "") {
            modalErr = false
        }
        if (companyProfileModal == ""
            // && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)
        ) {
            this.setState({ companyProfileErrModal: "Please enter Company profile" });
            modalErr = false
        }
        if (PersonProfileModal == "") {
            this.setState({ PersonProfileModalErr: "Please enter Person profile" });
            modalErr = false
        }
        console.log(PersonPhotoModal, PersonPhotoPreviewModal, '...')
        if (PersonPhotoModal == '' && PersonPhotoPreviewModal == "") {
            this.setState({ PersonPhotoModalErr: "Please enter Person photo" });
            modalErr = false
        }
        if (countryIdModal == "" && this.showMandatoryFields(20, 0) && this.showMandatoryFields(20, 2)) {
            this.setState({ countryIdErrModal: "Please select country" });
            modalErr = false
        }
        if (totalYearsModal == ""
            // && this.showMandatoryFields(25, 0) && this.showMandatoryFields(25, 2)
        ) {
            this.setState({ totalYearsErrModal: "Please enter Total Years the Company Is Operational" });
            modalErr = false
        }
        if (turnOverIdModal == ""
            // && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)
        ) {
            this.setState({ turnOverErrModal: "Please Fill Company turn Over" });
            modalErr = false
        }
        if (compInfoGstNoModal == "" && countryIdModal == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            this.setState({ compInfoGstNoErrModal: "Please enter GST no" });
            modalErr = false
        } else if (countryIdModal == 91) {
            var errMsg = ''
            errMsg = gstNoValidator(compInfoGstNoModal)
            if (errMsg != '') {
                modalErr = false
                this.setState({ compInfoGstNoErrModal: errMsg });
            }
            else {
                this.setState({ compInfoGstNoErrModal: "" });
            }
        }
        if (compInfoPanNoModal == "" && countryIdModal == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            this.setState({ compInfoPanNoErrModal: "Please enter Pan no" });
            modalErr = false
        } else if (countryIdModal == 91) {
            var errMsg = ''
            errMsg = panNoValidator(compInfoPanNoModal)
            if (errMsg != '') {
                modalErr = false
                this.setState({ compInfoPanNoErrModal: errMsg });
            }
            else {
                this.setState({ compInfoPanNoErrModal: "" });
            }
        }
        const selectedChapter = chapterListModal.filter(data => data.isSelect == true)
        var chapterListData = []
        selectedChapter.map((data) => {
            var data = {
                "ChapterID": data.IndustrySegmentID,
                "ChapterName": data['Industrial Segment'],
                "OtherNames": data.IndustrySegmentID == 16 ? other : ''
            }
            chapterListData.push(data)
        })
        if (chapterListData.length == 0
            // && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)
        ) {
            this.setState({ chapterErrModal: "Please Select atleast 1 Industry segment" });
            modalErr = false
        }

        const purposeOfVisitlist = visitPurposeListModal.filter(data => data.isSelect == true)
        var purposeOfVisitlistData = []
        purposeOfVisitlist.map((data) => {
            var data = {
                "PurposeofVisitID": data.PurposeofVisitID,
                "otherDetail": data.otherDetail
            }
            purposeOfVisitlistData.push(data)
        })
        var otherPOV = false
        purposeOfVisitlistData.map((data) => {
            otherPOV = data.PurposeofVisitID == 10 && (data.otherDetail == '' || data.otherDetail == null) ? true : false
        })
        if (otherPOV
            // && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)
        ) {
            this.setState({ visitPurposeErrModal: "Please enter other purpose of visit" })
            modalErr = false
        }
        if (purposeOfVisitlistData.length == 0
            // && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)
        ) {
            this.setState({ visitPurposeErrModal: "Please select Purpose of visit" })
            modalErr = false
        }

        const selectedSeminarList = seminarInterestListModal.filter(data => data.isSelect == true)
        var seminarInterestListData = []
        selectedSeminarList.map((data) => {
            var data = {
                "SeminarID": data.SeminarID,
            }
            seminarInterestListData.push(data)
        })

        var selectedDays = []
        selectedDays = daysListModal.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = {
                "visitDay": data.VisitDate
            }
            list.push(data)
        })
        if (list.length == 0 && ((!isInterestTwoModal && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2)))) {
            this.setState({ daysErrModal: "Please select Visit Days" })
            modalErr = false
        } else {
            this.setState({ daysErrModal: "" })
        }

        var B2bList = []
        B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map(data => {
            data.timeSlotList.map(item => {
                if (item.isSelect) {
                    B2bList.push(item)
                }
            })
        })
        var B2bListfinal = []
        B2bList.length > 0 && B2bList.map(data => {
            var item = {
                "B2BTimeSlotID": data.B2BTimeSlotID
            }
            B2bListfinal.push(item)
        })


        var allArray = [...primaryChapterListDataModal, ...level2Modal, ...level3Modal, ...level4Modal]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        var chapterListData2 = []
        filerArray.map((data) => {
            var data = {
                "ChapterID": data.ChapterID,
                "ChapterName": data.ChapterName,

            }
            chapterListData2.push(data)
        })

        if (chapterListData2.length == 0
            // && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)
        ) {
            this.setState({ ChapterHallErrModal: "Please Select atleast 1 Product" });
            modalErr = false
        }


        var visaErr = false


        if (needVisaAssistanceModal) {
            if (passNameModal == "") {
                this.setState({ passNameErrModal: "Please enter Name " });
                visaErr = true
                modalErr = false
            }
            if (applicantMobNoModal == "") {
                this.setState({ applicantMobNoErrModal: "Please enter Mobile NO " });
                visaErr = true
                modalErr = false
            }
            if (applicantEmailModal == "") {
                this.setState({ applicantEmailErrModal: "Please enter Email " });
                visaErr = true
                modalErr = false
            }

            if (passNoModal == "") {
                this.setState({ passNoErrModal: "Please enter Passport No " });
                visaErr = true
                modalErr = false
            }
            if (passDateModal == "") {
                this.setState({ passDateErrModal: "Please enter Passport Date " });
                visaErr = true
                modalErr = false
            }
            if (passExipryDateModal == "") {
                this.setState({ passExipryDateErrModal: "Please enter Passport Expiry Date " });
                visaErr = true
                modalErr = false
            }
            if (passCountryModal == "") {
                this.setState({ passCountryErrModal: "Please Select Country " });
                visaErr = true
                modalErr = false
            }
            if (passportFileModal == "") {
                this.setState({ passportFileErrModal: "Please Upload File " });
                visaErr = true
                modalErr = false
            }
            if (applicantEmailModal != "") {
                var emailError = emailValidator(applicantEmailModal)
                if (emailError != '') {
                    this.setState({ applicantEmailErrModal: emailError })
                    visaErr = true
                }
            }
            if (visaErr) {
                if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2)) {
                    this.setState({ visaErrModal: "Please Fill Visa Assistance" })
                    modalErr = false

                }
            } else {
                this.setState({ visaErrModal: "" })
            }

        } else {
            this.setState({
                passNameErrModal: "",
                applicantMobNoErrModal: "",
                applicantEmailErrModal: "",
                passNoErrModal: "",
                passDateErrModal: "",
                passExipryDateErrModal: "",
                passCountryErrModal: "",
                passportFileErrModal: "",
                applicantEmailErrModal: "",
                visaErrModal: ""
            });

        }
        setTimeout(() => {
            if (modalErr) {
                if (isModalEdit) {
                    GroupDetailsList.map(item => {
                        if (item.id == modalID) {
                            item.DelegateRegistrationID = this.state.DelegateRegistrationIDModal
                            item.AccountTypeID = this.state.AccountTypeIDModal
                            item.AccountID = this.state.AccountIDModal
                            item.DelegateRegistrationNo = this.state.DelegateRegistrationNoModal
                            item.Title = isOtherPreNameModal ? otherNameModal : prenameModal
                            item.firstName = firstNameModal
                            item.lastName = lastNameModal
                            item.gender = genderModal
                            item.designation = designationModal
                            item.CompanyName = instituteModal
                            item.GSTNo = compInfoGstNoModal
                            item.PanNo = compInfoPanNoModal
                            item.IECCode = IECCodeModal
                            item.Address1 = Address1Modal
                            item.Address2 = Address2Modal
                            item.Address3 = Address3Modal
                            item.City = cityModal
                            item.State = regStateModal
                            item.Pin = pincodeModal
                            item.PrimaryEmail = emailModal
                            item.Website = websiteModal
                            item.Telephone = preTelNoModal != '' && preTelNoModal != null ? `${preTelNoModal}-${telNoModal}` : telNoModal
                            item.Telephone1 = preTel1NoModal != '' && preTel1NoModal != null ? `${preTel1NoModal}-${tel1NoModal}` : tel1NoModal
                            item.CountryID = countryIdModal
                            item.mobNo = preMobNoModal != '' && preMobNoModal != null ? `${preMobNoModal}-${mobNoModal}` : mobNoModal
                            item.whatsAppMobNo = preWhatsAppMobNoModal != '' && preWhatsAppMobNoModal != null ? `${preWhatsAppMobNoModal}-${whatsAppMobNoModal}` : whatsAppMobNoModal
                            item.IsIntrestedForB2B = isInterestTwoModal
                            item.CompanyProfile = companyProfileModal
                            item.CompanyWebsite = companywebsiteModal
                            item.TotalOperationalYears = totalYearsModal
                            item.CompanyTurnOverID = turnOverIdModal
                            item.ArrivalDate = arrivalDateModal
                            item.DepartureDate = departureDateModal
                            item.IsCoordinator = false
                            item.isCoordinatorAsDelegate = false
                            item.chaptersList = chapterListData2
                            item.seminarList = selectedSeminarList
                            item.visitdays = isInterestTwoModal ? [] : list
                            item.purposeOfVisitList = purposeOfVisitlistData
                            item.industrySegmentList = chapterListData
                            item.B2BmappingList = B2bListfinal
                            item.ApplicantEmailID = needVisaAssistanceModal ? applicantEmailModal : ''
                            item.ApplicantMobileNo = needVisaAssistanceModal ? preApplicantMobNoModal != '' && preApplicantMobNoModal != null ? `${preApplicantMobNoModal}-${applicantMobNoModal}` : applicantMobNoModal : ''
                            item.NameOnPassport = needVisaAssistanceModal ? passNameModal : ''
                            item.PassportExpiryDate = needVisaAssistanceModal ? passExipryDateModal : ''
                            item.PassportFile = needVisaAssistanceModal ? passportFileModal : ''
                            item.PassportFileName = needVisaAssistanceModal ? passPortFileNameModal : ''
                            item.passportFilePath = needVisaAssistanceModal ? passportFilePathModal : ''
                            item.PassportFileType = needVisaAssistanceModal ? passportFileTypeModal : ''
                            item.PassportIssueDate = needVisaAssistanceModal ? passDateModal : ''
                            item.PassportIssuingCountryID = needVisaAssistanceModal ? passCountryModal : ''
                            item.PassportNo = needVisaAssistanceModal ? passNoModal : ''
                            item.isVisaAssistance = needVisaAssistanceModal
                            item.isVisaApplied = needVisaAssistanceModal
                            item.isPassportFilePresent = false
                            item.isSameAsMobNo = isSameAsMobNoModal
                            item.PersonProfile = PersonProfileModal
                            item.PersonPhoto = PersonPhotoModal
                            item.PersonPhotoName = PersonPhotoNameModal
                            item.PersonPhotoData = PersonPhotoDataModal
                            item.PersonPhotoType = PersonPhotoTypeModal
                        }
                    })
                }
                else {
                    var obj = {
                        'id': GroupDetailsList.length + 1,
                        'DelegateRegistrationID': null,
                        'AccountTypeID': this.state.AccountTypeIDModal,
                        'AccountID': null,
                        'DelegateRegistrationNo': null,
                        'Title': isOtherPreNameModal ? otherNameModal : prenameModal,
                        'firstName': firstNameModal,
                        'lastName': lastNameModal,
                        'gender': genderModal,
                        'designation': designationModal,
                        'CompanyName': instituteModal,
                        'GSTNo': compInfoGstNoModal,
                        'PanNo': compInfoPanNoModal,
                        'IECCode': IECCodeModal,
                        'Address1': Address1Modal,
                        'Address2': Address2Modal,
                        'Address3': Address3Modal,
                        'City': cityModal,
                        'State': regStateModal,
                        'Pin': pincodeModal,
                        'PrimaryEmail': emailModal,
                        'Website': websiteModal,
                        'Telephone': preTelNoModal != '' && preTelNoModal != null ? `${preTelNoModal}-${telNoModal}` : telNoModal,
                        'Telephone1': preTel1NoModal != '' && preTel1NoModal != null ? `${preTel1NoModal}-${tel1NoModal}` : tel1NoModal,
                        'CountryID': countryIdModal,
                        'mobNo': preMobNoModal != '' && preMobNoModal != null ? `${preMobNoModal}-${mobNoModal}` : mobNoModal,
                        'whatsAppMobNo': preWhatsAppMobNoModal != '' && preWhatsAppMobNoModal != null ? `${preWhatsAppMobNoModal}-${whatsAppMobNoModal}` : whatsAppMobNoModal,
                        'IsIntrestedForB2B': isInterestTwoModal,
                        'CompanyProfile': companyProfileModal,
                        'CompanyWebsite': companywebsiteModal,
                        'TotalOperationalYears': totalYearsModal,
                        'CompanyTurnOverID': turnOverIdModal,
                        'ArrivalDate': arrivalDateModal,
                        'DepartureDate': departureDateModal,
                        'IsCoordinator': false,
                        'isCoordinatorAsDelegate': false,
                        'chaptersList': chapterListData2,
                        'seminarList': selectedSeminarList,
                        'visitdays': isInterestTwoModal ? [] : list,
                        'purposeOfVisitList': purposeOfVisitlistData,
                        'industrySegmentList': chapterListData,
                        'B2BmappingList': B2bListfinal,
                        'ApplicantEmailID': needVisaAssistanceModal ? applicantEmailModal : '',
                        'ApplicantMobileNo': needVisaAssistanceModal ? preApplicantMobNoModal != '' && preApplicantMobNoModal != null ? `${preApplicantMobNoModal}-${applicantMobNoModal}` : applicantMobNoModal : '',
                        'NameOnPassport': needVisaAssistanceModal ? passNameModal : '',
                        'PassportExpiryDate': needVisaAssistanceModal ? passExipryDateModal : '',
                        'PassportFile': needVisaAssistanceModal ? passportFileModal : '',
                        'PassportFileName': needVisaAssistanceModal ? passPortFileNameModal : '',
                        'passportFilePath': needVisaAssistanceModal ? passportFilePathModal : '',
                        'PassportFileType': needVisaAssistanceModal ? passportFileTypeModal : '',
                        'PassportIssueDate': needVisaAssistanceModal ? passDateModal : '',
                        'PassportIssuingCountryID': needVisaAssistanceModal ? passCountryModal : '',
                        'PassportNo': needVisaAssistanceModal ? passNoModal : '',
                        'isVisaAssistance': needVisaAssistanceModal,
                        'isVisaApplied': needVisaAssistanceModal,
                        'isPassportFilePresent': false,
                        'isSameAsMobNo': isSameAsMobNoModal,
                        'PersonProfile': PersonProfileModal,
                        'PersonPhoto': PersonPhotoModal,
                        'PersonPhotoName': PersonPhotoNameModal,
                        'PersonPhotoData': PersonPhotoDataModal,
                        'PersonPhotoType': PersonPhotoTypeModal
                    }

                    GroupDetailsList.push(obj)
                }
                this.setState({
                    GroupDetailsList: GroupDetailsList,
                    isOpen: false,
                })
                this.setState({
                    isOtherPreNameModal: false,
                    firstNameModal: '',
                    lastNameModal: '',
                    genderModal: '',
                    designationModal: '',
                    instituteModal: '',
                    compInfoGstNoModal: '',
                    compInfoPanNoModal: '',
                    IECCodeModal: '',
                    Address1Modal: '',
                    Address2Modal: '',
                    Address3Modal: '',
                    cityModal: '',
                    regStateModal: '',
                    pincodeModal: '',
                    emailModal: '',
                    websiteModal: '',
                    preTelNoModal: '',
                    telNoModal: '',
                    preTel1NoModal: '',
                    tel1NoModal: '',
                    countryIdModal: '',
                    preMobNoModal: '',
                    mobNoModal: '',
                    preWhatsAppMobNoModal: '',
                    whatsAppMobNoModal: '',
                    companyProfileModal: '',
                    companywebsiteModal: '',
                    totalYearsModal: '',
                    turnOverIdModal: '',
                    arrivalDateModal: '',
                    departureDateModal: '',
                    isInterestTwoModal: false,
                    applicantEmailModal: '',
                    preApplicantMobNoModal: '',
                    applicantMobNoModal: '',
                    passNameModal: '',
                    passExipryDateModal: '',
                    passportFileModal: '',
                    passPortFileNameModal: '',
                    passportFilePathModal: '',
                    passportFileTypeModal: '',
                    passDateModal: '',
                    passCountryModal: '',
                    passNoModal: '',
                    needVisaAssistanceModal: false,
                    isVisaAppliedModal: false,
                    isPassportFilePresentModal: false,
                    isSameAsMobNoModal: false,
                    PersonProfileModal: '',
                    PersonPhotoModal: '',
                    PersonPhotoNameModal: '',
                    PersonPhotoDataModal: '',
                    PersonPhotoTypeModal: '',
                    isOpenDropDownState: false,
                    focusedIndexState: -1,
                    isOpenDropDownStateModal: false,
                    focusedIndexStateModal: -1,
                    PersonPhotoPreviewModal: '',
                    PersonPhotoModal: '',
                    isOpenDropDownCity: false,
                    focusedIndexCity: -1,
                    isOpenDropDownCityModal: false,
                    focusedIndexCityModal: -1,

                    isOpenDropDownPin: false,
                    focusedIndexPin: -1,
                    isOpenDropDownPinModal: false,
                    focusedIndexPinModal: -1,
                })
                setTimeout(() => {
                    chapterListModal.length > 0 && chapterListModal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        chapterListModal: chapterListModal,
                    })
                    visitPurposeListModal.length > 0 && visitPurposeListModal.map((item) => {
                        item.isSelect = false
                        item.otherDetail = ""
                    })
                    this.setState({
                        visitPurposeListModal: visitPurposeListModal,
                    })
                    seminarInterestListModal.sort((a, b) => a.SeqNo - b.SeqNo);
                    seminarInterestListModal.length > 0 && seminarInterestListModal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        seminarInterestListModal: seminarInterestListModal,
                    })
                    daysListModal.length > 0 && daysListModal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        daysListModal: daysListModal,
                    })
                    B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map((data) => {
                        data.timeSlotList.map(item => {
                            item.isSelect = false
                        })
                    })
                    this.setState({
                        B2bMeetingListmodal: B2bMeetingListmodal,
                    })
                    level2Modal.length > 0 && level2Modal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        level2Modal: level2Modal,
                    })
                    level3Modal.length > 0 && level3Modal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        level3Modal: level3Modal,
                    })
                    level4Modal.length > 0 && level4Modal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        level4Modal: level4Modal,
                    })
                    primaryChapterListDataModal.length > 0 && primaryChapterListDataModal.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        primaryChapterListDataModal: primaryChapterListDataModal,
                    })
                    this.setState({ isModalEdit: false })
                    isModalEdit ? toastSuccess("Delegate updated successfully") : toastSuccess("Delegate added successfully")
                }, 200);
            } else {
                toastError("Please enter mandatory fields")
            }
        }, 200);
    }

    handleCancelModel() {
        const { chapterListModal, seminarInterestListModal, visitPurposeListModal, daysListModal, level2Modal,
            level3Modal, level4Modal, primaryChapterListDataModal, B2bMeetingListmodal } = this.state
        this.setState({
            isOtherPreNameModal: false, firstNameModal: '', lastNameModal: '', genderModal: '',
            designationModal: '', instituteModal: '', compInfoGstNoModal: '',
            compInfoPanNoModal: '', IECCodeModal: '', Address1Modal: '',
            Address2Modal: '', Address3Modal: '', cityModal: '', regStateModal: '',
            pincodeModal: '', emailModal: '', websiteModal: '', preTelNoModal: '',
            telNoModal: '', preTel1NoModal: '', tel1NoModal: '', countryIdModal: '',
            preMobNoModal: '', mobNoModal: '', preWhatsAppMobNoModal: '', whatsAppMobNoModal: '',
            companyProfileModal: '', companywebsiteModal: '', totalYearsModal: '',
            turnOverIdModal: '', arrivalDateModal: '', departureDateModal: '',
            isInterestTwoModal: false, applicantEmailModal: '', preApplicantMobNoModal: '',
            applicantMobNoModal: '', passNameModal: '', passExipryDateModal: '',
            passportFileModal: '', passPortFileNameModal: '', passportFilePathModal: '',
            passportFileTypeModal: '', passDateModal: '', passCountryModal: '',
            passNoModal: '', needVisaAssistanceModal: false, isVisaAppliedModal: false,
            isPassportFilePresentModal: false, isSameAsMobNoModal: false, firstNameErrModal: '',
            lastNameErrModal: '', countryIdErrModal: '', genderErrModal: '',
            designationErrModal: '', instituteErrModal: '', IECCodeErrModal: '',
            Address1ErrModal: '', pincodeErrModal: '', regStateErrModal: '',
            cityErrModal: '', emailErrModal: '', mobNoErrModal: '', whatsAppMobNoErrModal: '', compInfoGstNoErrModal: '',
            compInfoPanNoErrModal: '', visitPurposeErrModal: '', chapterErrModal: '',
            turnOverErrModal: '', totalYearsErrModal: '', companyProfileErrModal: '',
            arrivalDateErrModal: '', departureDateErrModal: '', daysErrModal: '',
            ChapterHallErrModal: '', b2bErrModal: '', SeminarErrModal: '',
            passNameErrModal: '', applicantMobNoErrModal: '', applicantEmailErrModal: '',
            passNoErrModal: '', passDateErrModal: '', passExipryDateErrModal: '',
            passCountryErrModal: '', passportFileErrModal: '', AccountTypeIDErr: '', PersonPhotoPreviewModal: '',
            PersonPhotoModal: '',
        })
        chapterListModal.length > 0 && chapterListModal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            chapterListModal: chapterListModal,
        })
        visitPurposeListModal.length > 0 && visitPurposeListModal.map((item) => {
            item.isSelect = false
            item.otherDetail = ""
        })
        this.setState({
            visitPurposeListModal: visitPurposeListModal,
        })
        seminarInterestListModal.sort((a, b) => a.SeqNo - b.SeqNo);
        seminarInterestListModal.length > 0 && seminarInterestListModal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            seminarInterestListModal: seminarInterestListModal,
        })
        daysListModal.length > 0 && daysListModal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            daysListModal: daysListModal,
        })
        B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map((data) => {
            data.timeSlotList.map(item => {
                item.isSelect = false
            })
        })
        this.setState({
            B2bMeetingListmodal: B2bMeetingListmodal,
        })
        level2Modal.length > 0 && level2Modal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            level2Modal: level2Modal,
        })
        level3Modal.length > 0 && level3Modal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            level3Modal: level3Modal,
        })
        level4Modal.length > 0 && level4Modal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            level4Modal: level4Modal,
        })
        primaryChapterListDataModal.length > 0 && primaryChapterListDataModal.map((item) => {
            item.isSelect = false
        })
        this.setState({
            primaryChapterListDataModal: primaryChapterListDataModal,
        })
        this.setState({ isModalEdit: false })
        this.setState({ isOpen: false })
    }

    handleEditGroupDetail(id) {
        const {

            chapterListModal, seminarInterestListModal, visitPurposeListModal, daysListModal, level2Modal, level3Modal, level4Modal, primaryChapterListDataModal, GroupDetailsList, B2bMeetingListmodal

        } = this.state

        for (var i = 0; i < GroupDetailsList.length; i++) {
            if (id == GroupDetailsList[i].id) {
                GroupDetailsList[i].visitdays.length > 0 && GroupDetailsList[i].visitdays.map(item2 => {
                    daysListModal.length > 0 && daysListModal.map(item => {

                        if (item.Code == item2.visitDay) {
                            item.isSelect = true
                        }
                    })
                })

                GroupDetailsList[i].industrySegmentList.length > 0 && GroupDetailsList[i].industrySegmentList.map(item2 => {
                    chapterListModal.length > 0 && chapterListModal.map(item => {

                        if (item.IndustrySegmentID == item2.ChapterID) {
                            item.isSelect = true
                        }
                    })
                })
                var SelectedHallChapters = GroupDetailsList[i]['chaptersList'] != null ? GroupDetailsList[i]['chaptersList'] : []
                primaryChapterListDataModal.length > 0 && primaryChapterListDataModal.map((item) => {
                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                        if (element.ChapterID == item.ChapterID) {
                            item.isSelect = true
                        }
                    })
                })
                level2Modal.length > 0 && level2Modal.map((item) => {
                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                        if (element.ChapterID == item.ChapterID) {
                            item.isSelect = true
                        }
                    })
                })
                level3Modal.length > 0 && level3Modal.map((item) => {
                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                        if (element.ChapterID == item.ChapterID) {
                            item.isSelect = true
                        }
                    })
                })
                level4Modal.length > 0 && level4Modal.map((item) => {
                    SelectedHallChapters.length > 0 && SelectedHallChapters.map((element) => {
                        if (element.ChapterID == item.ChapterID) {
                            item.isSelect = true
                        }
                    })
                })
                var SelectedpurposeOfVisitList = GroupDetailsList[i]['purposeOfVisitList'] != null ? GroupDetailsList[i]['purposeOfVisitList'] : []

                visitPurposeListModal.length > 0 && visitPurposeListModal.map(item => {
                    SelectedpurposeOfVisitList.length > 0 && SelectedpurposeOfVisitList.map(item2 => {
                        if (item.PurposeofVisitID == item2.PurposeofVisitID) {
                            item.isSelect = true
                        }
                    })
                })
                GroupDetailsList[i].seminarList.length > 0 && GroupDetailsList[i].seminarList.map(item2 => {
                    seminarInterestListModal.length > 0 && seminarInterestListModal.map(item => {
                        if (item.SeminarID == item2.SeminarID) {
                            item.isSelect = true
                        }
                    })
                })
                GroupDetailsList[i].B2BmappingList.length > 0 && GroupDetailsList[i].B2BmappingList.map(item2 => {
                    B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map(item => {
                        item.timeSlotList.length > 0 && item.timeSlotList.map(element => {
                            if (element.B2BTimeSlotID == item2.B2BTimeSlotID) {
                                element.isSelect = true
                                element.IsBooked = false
                            }
                        })
                    })
                })
                var mob1 = GroupDetailsList[i].mobNo
                const parts = mob1 != '' ? mob1.split("-") : '';
                const Mob1Code = parts.length > 1 && parts != '' ? parts[0] : '+91'
                const Mob1No = parts != '' ? parts.length > 1 ? parts[1] : parts[0] : ''
                var mob2 = GroupDetailsList[i].whatsAppMobNo
                const parts2 = mob2 != '' ? mob2.split("-") : ''
                const Mob2Code = parts2.length > 1 && parts2 != '' ? parts2[0] : '+91'
                const Mob2No = parts2 != '' ? parts2.length > 1 ? parts2[1] : parts2[0] : ''
                var tel = GroupDetailsList[i].Telephone
                const parts3 = tel != '' ? tel.split("-") : ''
                const telCode = parts3.length > 1 && parts3 != '' ? parts3[0] : ''
                const telNumber = parts3 != '' ? parts3.length > 1 ? parts3[1] : parts3[0] : ''
                var tel1 = GroupDetailsList[i].Telephone1
                const parts4 = tel1 != '' ? tel1.split("-") : ''
                const tel1Code = parts4.length > 1 && parts4 != '' ? parts4[0] : ''
                const tel1Number = parts4 != '' ? parts4.length > 1 ? parts4[1] : parts4[0] : ''

                var applicantMob = GroupDetailsList[i].ApplicantMobileNo
                const parts5 = applicantMob != '' ? applicantMob.split("-") : ''
                const applicantMobCode = parts5.length > 1 && parts5 != '' ? parts5[0] : ''
                const applicantMobNumber = parts5 != '' ? parts5.length > 1 ? parts5[1] : parts5[0] : ''
                this.setState({
                    isOtherPreNameModal: false,
                    firstNameModal: GroupDetailsList[i].firstName,
                    lastNameModal: GroupDetailsList[i].lastName,
                    genderModal: GroupDetailsList[i].gender,
                    designationModal: GroupDetailsList[i].designation,
                    instituteModal: GroupDetailsList[i].CompanyName,
                    compInfoGstNoModal: GroupDetailsList[i].GSTNo,
                    compInfoPanNoModal: GroupDetailsList[i].PanNo,
                    IECCodeModal: GroupDetailsList[i].IECCode,
                    Address1Modal: GroupDetailsList[i].Address1,
                    Address2Modal: GroupDetailsList[i].Address2,
                    Address3Modal: GroupDetailsList[i].Address3,
                    cityModal: GroupDetailsList[i].City,
                    regStateModal: GroupDetailsList[i].State,
                    pincodeModal: GroupDetailsList[i].Pin,
                    emailModal: GroupDetailsList[i].PrimaryEmail,
                    websiteModal: GroupDetailsList[i].Website,
                    preTelNoModal: telCode,
                    telNoModal: telNumber,
                    preTel1NoModal: tel1Code,
                    tel1NoModal: tel1Number,
                    countryIdModal: GroupDetailsList[i].CountryID,
                    preMobNoModal: Mob1Code,
                    mobNoModal: Mob1No,
                    preWhatsAppMobNoModal: Mob2Code,
                    whatsAppMobNoModal: Mob2No,
                    isInterestTwoModal: GroupDetailsList[i].B2BmappingList.length != 0 ? true : false,
                    companyProfileModal: GroupDetailsList[i].CompanyProfile,
                    companywebsiteModal: GroupDetailsList[i].CompanyWebsite,
                    totalYearsModal: GroupDetailsList[i].TotalOperationalYears,
                    turnOverIdModal: GroupDetailsList[i].CompanyTurnOverID,
                    arrivalDateModal: GroupDetailsList[i].ArrivalDate,
                    departureDateModal: GroupDetailsList[i].DepartureDate,
                    isModalEdit: true,
                    daysListModal: daysListModal,
                    chapterListModal: chapterListModal,
                    primaryChapterListDataModal: primaryChapterListDataModal,
                    level2Modal: level2Modal,
                    level3Modal: level3Modal,
                    level4Modal: level4Modal,
                    B2bMeetingListmodal: B2bMeetingListmodal,
                    visitPurposeListModal: visitPurposeListModal,
                    seminarInterestListModal: seminarInterestListModal,
                    applicantEmailModal: GroupDetailsList[i].ApplicantEmailID,
                    preApplicantMobNoModal: applicantMobCode,
                    applicantMobNoModal: applicantMobNumber,
                    passNameModal: GroupDetailsList[i].NameOnPassport,
                    passExipryDateModal: GroupDetailsList[i].PassportExpiryDate,
                    passportFileModal: GroupDetailsList[i].PassportFile,
                    passPortFileNameModal: GroupDetailsList[i].PassportFileName,
                    passportFilePathModal: GroupDetailsList[i].passportFilePath,
                    passportFileTypeModal: GroupDetailsList[i].PassportFileType,
                    passDateModal: GroupDetailsList[i].PassportIssueDate,
                    passCountryModal: GroupDetailsList[i].PassportIssuingCountryID,
                    passNoModal: GroupDetailsList[i].PassportNo,
                    needVisaAssistanceModal: GroupDetailsList[i].isVisaAssistance,
                    isVisaAppliedModal: GroupDetailsList[i].isVisaApplied,
                    isPassportFilePresentModal: GroupDetailsList[i].isPassportFilePresent,
                    isSameAsMobNoModal: GroupDetailsList[i].isSameAsMobNo,
                    DelegateRegistrationIDModal: GroupDetailsList[i].DelegateRegistrationID,
                    AccountTypeIDModal: GroupDetailsList[i].AccountTypeID,
                    AccountIDModal: GroupDetailsList[i].AccountID,
                    DelegateRegistrationNoModal: GroupDetailsList[i].DelegateRegistrationNo,
                    PersonProfileModal: GroupDetailsList[i].PersonProfile,
                    PersonPhotoModal: GroupDetailsList[i].PersonPhoto ? GroupDetailsList[i].PersonPhoto : GroupDetailsList[i].PersonPhotoData,
                    PersonPhotoPreviewModal: GroupDetailsList[i].PersonPhoto ? GroupDetailsList[i].PersonPhoto : GroupDetailsList[i].PersonPhotoData,
                    PersonPhotoNameModal: GroupDetailsList[i].PersonPhotoName,
                    PersonPhotoDataModal: GroupDetailsList[i].PersonPhotoData,
                    PersonPhotoTypeModal: GroupDetailsList[i].PersonPhotoType,
                    delegateIndex: i,
                    isOpen: true,
                    modalID: id,
                    // PersonPhoto: data.data[0][0].PersonPhoto ? data.data[0][0].PersonPhoto : (data.data[0][0].PassportFilePath ? data.data[0][0].PassportFilePath : ''

                })
                if (GroupDetailsList[i].CountryID == 91) {
                    this.getFillList(pincodeActionId, '', '', GroupDetailsList[i].CountryID, '', '')
                    this.getFillList(stateActionId, '', '', GroupDetailsList[i].CountryID, '', '')
                    this.getFillList(cityActionId, '', '', GroupDetailsList[i].CountryID, '', '')

                }
                setTimeout(() => {
                    this.setState({
                        isOpenDropDownState: false,
                        focusedIndexState: -1,
                        isOpenDropDownStateModal: false,
                        focusedIndexStateModal: -1,

                        isOpenDropDownCity: false,
                        focusedIndexCity: -1,
                        isOpenDropDownCityModal: false,
                        focusedIndexCityModal: -1,

                        isOpenDropDownPin: false,
                        focusedIndexPin: -1,
                        isOpenDropDownPinModal: false,
                        focusedIndexPinModal: -1,
                    })
                }, 100);
            }
            else {
                GroupDetailsList[i].B2BmappingList.length > 0 && GroupDetailsList[i].B2BmappingList.map(item2 => {
                    B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map(item => {
                        item.timeSlotList.length > 0 && item.timeSlotList.map(element => {
                            if (element.B2BTimeSlotID == item2.B2BTimeSlotID) {
                                element.IsBooked = true
                            }
                        })
                    })
                })
                this.setState({ B2bMeetingListmodal: B2bMeetingListmodal })
            }
        }
    }

    handleDeleteDelegate() {
        const { GroupDetailsList, AccountIDModal, DelegateRegistrationIDModal, deleteID } = this.state
        if (GroupDetailsList[deleteID - 1].AccountID != '' && GroupDetailsList[deleteID - 1].AccountID != null && GroupDetailsList[deleteID - 1].DelegateRegistrationID != '' && GroupDetailsList[deleteID - 1].DelegateRegistrationID != null) {
            this.setState({ isLoading: true })
            this.props.deleteDelegate_action(AccountIDModal, DelegateRegistrationIDModal)
                .then((data) => {
                    if (data && data.error != 1) {
                        var id = ''
                        GroupDetailsList.length > 0 && GroupDetailsList.map((item, i) => {
                            if (item.AccountID == AccountIDModal) id = i
                        })
                        GroupDetailsList.splice(id, 1)
                        this.setState({ GroupDetailsList: GroupDetailsList, isOpen4: false })
                        this.setState({ isLoading: false })
                    }
                })
        } else {
            GroupDetailsList.splice(deleteID - 1, 1)
            this.setState({ GroupDetailsList: GroupDetailsList, isOpen4: false })
        }
    }

    handleDeleteAdded(id) {
        const { GroupDetailsList } = this.state
        this.setState({ isOpen4: true, AccountIDModal: GroupDetailsList[id - 1].AccountID, DelegateRegistrationIDModal: GroupDetailsList[id - 1].DelegateRegistrationID, deleteID: id })
    }

    onSelectInterest(e, status) {
        const { daysList, B2bMeetingList, B2bMeetingListmodal, daysListModal, isInterestTwo, isInterestTwoModal } = this.state
        var checked = e.target.checked
        if (status == 1) {
            this.setState({ isInterestTwoModal: !isInterestTwoModal })
            if (checked) {
                this.setState({ daysErrModal: false })
                for (var i = 0; i < daysListModal.length; i++) {
                    daysListModal[i].isSelect = false
                }
                this.setState({ daysListModal: daysListModal, b2bErrModal: '' })
            } else {
                for (var i = 0; i < B2bMeetingListmodal.length; i++) {
                    for (var a = 0; a < B2bMeetingListmodal[i].timeSlotList.length; a++) {
                        if (!B2bMeetingListmodal[i].timeSlotList[a].IsBooked) {
                            B2bMeetingListmodal[i].timeSlotList[a].isSelect = false
                        }
                    }
                }
                this.setState({ B2bMeetingListmodal: B2bMeetingListmodal, b2bErrModal: '' })
            }
        } else {
            this.setState({ isInterestTwo: !isInterestTwo })
            if (checked) {
                this.setState({ daysErr: false })
                for (var i = 0; i < daysList.length; i++) {
                    daysList[i].isSelect = false
                }
                this.setState({ daysList: daysList, b2bErr: '' })
            }
            else {
                for (var i = 0; i < B2bMeetingList.length; i++) {
                    for (var a = 0; a < B2bMeetingList[i].timeSlotList.length; a++) {
                        if (!B2bMeetingList[i].timeSlotList[a].IsBooked) {
                            B2bMeetingList[i].timeSlotList[a].isSelect = false
                        }
                    }
                }
                this.setState({ B2bMeetingList: B2bMeetingList, b2bErr: '' })
            }
        }
    }

    onSelectDates(e, status) {
        const { daysList, daysListModal, B2bMeetingList, B2bMeetingListmodal } = this.state
        var code = e.target.value
        var checked = e.target.checked
        if (status == 1) {
            daysListModal.length > 0 && daysListModal.map((data) => {
                if (checked) {
                    if (code == data.Code) {
                        data.isSelect = true
                    }
                } else {
                    if (code == data.Code) {
                        data.isSelect = false
                    }

                }
            })
            var selectedDays = daysListModal.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            for (var i = 0; i < B2bMeetingListmodal.length; i++) {
                for (var a = 0; a < B2bMeetingListmodal[i].timeSlotList.length; a++) {
                    if (!B2bMeetingListmodal[i].timeSlotList[a].IsBooked || B2bMeetingListmodal[i].timeSlotList[a].isSelect) {
                        B2bMeetingListmodal[i].timeSlotList[a].isSelect = false
                    }
                }
            }

            this.setState({ daysListModal: daysListModal, B2bMeetingListmodal: B2bMeetingListmodal, daysErrModal: "" })
        } else {
            daysList.length > 0 && daysList.map((data) => {
                if (checked) {
                    if (code == data.Code) {
                        data.isSelect = true
                    }
                } else {
                    if (code == data.Code) {
                        data.isSelect = false
                    }

                }
            })
            var selectedDays = daysList.filter(data => data.isSelect == true)
            var list = []
            selectedDays.map((data) => {
                var data = {
                    "visitDay": data.VisitDate
                }
                list.push(data)
            })
            for (var j = 0; j < B2bMeetingList.length; j++) {
                for (var b = 0; b < B2bMeetingList[j].timeSlotList.length; b++) {
                    if (!B2bMeetingList[j].timeSlotList[b].IsBooked || B2bMeetingList[j].timeSlotList[b].isSelect) {
                        B2bMeetingList[j].timeSlotList[b].isSelect = false
                    }
                }
            }
            this.setState({ daysList: daysList, daysErr: "", B2bMeetingList: B2bMeetingList })
        }
    }

    onCheckLevel2(e, id, tempLevel1) {
        const { level2, level3, primaryChapterListData, level4 } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {
                if (event == true) {
                    level2[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.isSelect = true
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.isSelect = true
                                }
                            });
                        }
                    });

                } else {
                    level2[i]['isSelect'] = false

                    level3.forEach((level3) => {
                        if (level3.ParentChapterID == id) {
                            level3.isSelect = false
                            level4.forEach((level4) => {
                                if (level3.ChapterID == level4.ParentChapterID) {
                                    level4.isSelect = false
                                }
                            });
                        }
                    });
                }

            }
        }
        for (let i = 0; i < primaryChapterListData.length; i++) {
            for (let j = 0; j < level2.length; j++) {
                if (level2[j]['ChapterID'] == id) {
                    if (primaryChapterListData[i]['ChapterID'] == level2[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.isSelect == 1)
                        if (allSelectedChecked) {
                            primaryChapterListData[i]['isSelect'] = true
                        } else {
                            primaryChapterListData[i]['isSelect'] = false
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level2: level2 })
        }, 200);

    }

    onCheckLevel2Modal(e, id, tempLevel1) {
        const { level2Modal, level3Modal, level4Modal, primaryChapterListDataModal } = this.state
        const event = e.target.checked
        for (let i = 0; i < level2Modal.length; i++) {
            if (level2Modal[i]['ChapterID'] == id) {
                if (event == true) {
                    level2Modal[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })

                    level3Modal.forEach((level3Modal) => {
                        if (level3Modal.ParentChapterID == id) {
                            level3Modal.isSelect = true
                            level4Modal.forEach((level4Modal) => {
                                if (level3Modal.ChapterID == level4Modal.ParentChapterID) {
                                    level4Modal.isSelect = true
                                }
                            });
                        }
                    });

                } else {
                    level2Modal[i]['isSelect'] = false

                    level3Modal.forEach((level3Modal) => {
                        if (level3Modal.ParentChapterID == id) {
                            level3Modal.isSelect = false
                            level4Modal.forEach((level4Modal) => {
                                if (level3Modal.ChapterID == level4Modal.ParentChapterID) {
                                    level4Modal.isSelect = false
                                }
                            });
                        }
                    });
                }

            }
        }
        for (let i = 0; i < primaryChapterListDataModal.length; i++) {
            for (let j = 0; j < level2Modal.length; j++) {
                if (level2Modal[j]['ChapterID'] == id) {
                    if (primaryChapterListDataModal[i]['ChapterID'] == level2Modal[j]['ParentChapterID']) {
                        const allSelectedChecked = tempLevel1.every(item => item.isSelect == 1)
                        if (allSelectedChecked) {
                            primaryChapterListDataModal[i]['isSelect'] = true
                        } else {
                            primaryChapterListDataModal[i]['isSelect'] = false
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level2Modal: level2Modal, ChapterHallErrModal: '' })
        }, 200);

    }

    recordTwo(level2, level3, level4) {
        const { primaryChapterListLevel3 } = this.state
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button" style={{ cursor: 'pointer' }}
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {level3data.IsCheckbox &&
                                                    <input type="checkbox" className="from-left-sp"
                                                        id={level3data.ChapterID}
                                                        name="" checked={level3data.isSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID, tempLevel3)} />
                                                }
                                                <label for={level3data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                                    {formatChapterName(level3data.ChapterName)}
                                                </label></button>
                                        </h2>
                                        {this.recordThree(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );

    }

    recordTwoModal(level2, level3, level4) {
        const { primaryChapterListLevel3Modal } = this.state
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
                primaryChapterListLevel3Modal.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} >
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed " type="button" style={{ cursor: 'pointer' }}
                                                data-bs-toggle="collapse"
                                                data-bs-target={'#collapse_l2_' + level3data.ChapterID}
                                                aria-expanded="false"
                                                aria-controls={'collapse_l2_' + level3data.ChapterID}
                                            >
                                                {/* // checkbox for level3 */}
                                                {level3data.IsCheckbox &&
                                                    <input type="checkbox" className="from-left-sp"

                                                        name="" id={'M' + level3data.ChapterID} checked={level3data.isSelect}
                                                        onClick={e => this.onCheckLevel3Modal(e, level3data.ChapterID, tempLevel3)} />
                                                }
                                                <label for={'M' + level3data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                                    {formatChapterName(level3data.ChapterName)}
                                                </label>
                                            </button>
                                        </h2>
                                        {this.recordThreeModal(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    onCheckLevel3(e, id, tempLevel3) {
        const { level2, level3, primaryChapterListData, level4 } = this.state
        const event = e.target.checked

        var modelevel3 = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                level2.map((s) => {
                    if (level3[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListData.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }


        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })



        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {
                if (event == true) {
                    level3[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {

                            level4.isSelect = true
                        }
                    });

                } else {
                    level3[i]['isSelect'] = false
                    level4.forEach((level4) => {
                        if (level3[i]['ChapterID'] == level4.ParentChapterID) {
                            level4.isSelect = false
                        }
                    });

                }
            }
        }

        for (let i = 0; i < level3.length; i++) {
            for (let index = 0; index < level2.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    if (level3[i]['ChapterID'] == id) {
                        if (level2[index]['ChapterID'] == level3[i]['ParentChapterID']) {
                            if (primaryChapterListData[j]['ChapterID'] == level2[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.isSelect == 1)
                                if (allSelectedChecked) {
                                    level2[index]['isSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListData[j]['isSelect'] = true
                                    } else {
                                        primaryChapterListData[j]['isSelect'] = false
                                    }
                                }
                                else {
                                    level2[index]['isSelect'] = false
                                    primaryChapterListData[j]['isSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }
        setTimeout(() => {
            this.setState({ level3: level3, level2: level2 })
        }, 100);

    }

    onCheckLevel3Modal(e, id, tempLevel3) {
        const { level2Modal, level3Modal, level4Modal, primaryChapterListDataModal } = this.state
        const event = e.target.checked

        var modelevel3 = []
        for (let i = 0; i < level3Modal.length; i++) {
            if (level3Modal[i]['ChapterID'] == id) {
                level2Modal.map((s) => {
                    if (level3Modal[i].ParentChapterID == s.ChapterID) {
                        primaryChapterListDataModal.map(q => {
                            if (s.ParentChapterID == q.ChapterID) {
                                modelevel3.push(q)
                            }
                        })
                    }
                })
            }
        }


        const finalListlevel2 = []
        level2Modal.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })



        for (let i = 0; i < level3Modal.length; i++) {
            if (level3Modal[i]['ChapterID'] == id) {
                if (event == true) {
                    level3Modal[i]['isSelect'] = true
                    this.setState({ ChapterHallErr: "" })
                    level4Modal.forEach((level4Modal) => {
                        if (level3Modal[i]['ChapterID'] == level4Modal.ParentChapterID) {

                            level4Modal.isSelect = true
                        }
                    });

                } else {
                    level3Modal[i]['isSelect'] = false
                    level4Modal.forEach((level4Modal) => {
                        if (level3Modal[i]['ChapterID'] == level4Modal.ParentChapterID) {
                            level4Modal.isSelect = false
                        }
                    });

                }
            }
        }

        for (let i = 0; i < level3Modal.length; i++) {
            for (let index = 0; index < level2Modal.length; index++) {
                for (let j = 0; j < primaryChapterListDataModal.length; j++) {
                    if (level3Modal[i]['ChapterID'] == id) {
                        if (level2Modal[index]['ChapterID'] == level3Modal[i]['ParentChapterID']) {
                            if (primaryChapterListDataModal[j]['ChapterID'] == level2Modal[index]['ParentChapterID']) {
                                const allSelectedChecked = tempLevel3.every(item => item.isSelect == 1)
                                if (allSelectedChecked) {
                                    level2Modal[index]['isSelect'] = true
                                    const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                    if (allSelectedfinalListlevel2) {
                                        primaryChapterListDataModal[j]['isSelect'] = true
                                    } else {
                                        primaryChapterListDataModal[j]['isSelect'] = false
                                    }
                                }
                                else {
                                    level2Modal[index]['isSelect'] = false
                                    primaryChapterListDataModal[j]['isSelect'] = false
                                }
                            }
                        }
                    }
                }

            }

        }
        setTimeout(() => {
            this.setState({ level3Modal: level3Modal, level2Modal: level2Modal, ChapterHallErrModal: '' })
        }, 100);


    }

    recordThree(level3data, level4) {
        const { primaryChapterListLevel4 } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step" style={{ display: 'flex' }}>

                                {level4data.IsCheckbox &&
                                    <input type="checkbox" name="" id={level4data.ChapterID} checked={level4data.isSelect}
                                        onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID, tempLevel4)} />
                                }
                                <label for={level4data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                    {formatChapterName(level4data.ChapterName)}
                                </label>
                            </div>
                        )
                    })
                }
            </div>
        </>);

    }

    recordThreeModal(level3data, level4) {
        const { primaryChapterListLevel4Modal } = this.state
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
                primaryChapterListLevel4Modal.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step" style={{ display: 'flex' }}>

                                {level4data.IsCheckbox &&
                                    <input type="checkbox" id={'M' + level4data.ChapterID} checked={level4data.isSelect}
                                        onClick={(e) => this.onSelectLevel4Modal(e, level4data.ChapterID, tempLevel4)} />
                                }
                                <label for={'M' + level4data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                    {formatChapterName(level4data.ChapterName)}
                                </label>
                            </div>
                        )
                    })
                }
            </div>
        </>);

    }

    onSelectLevel4(e, id, tempLevel4) {
        const { level2, level3, primaryChapterListData, level4 } = this.state
        { console.log('accordion') }

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level4[i]['isSelect'] = !level4[i]['isSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []

        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {
                level3.map((s) => {
                    if (level4[i].ParentChapterID == s.ChapterID) {
                        level2.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListData.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }

        const finalListlevel3 = []
        level3.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })

        const finalListlevel2 = []
        level2.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })



        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3.length; index++) {
                for (let j = 0; j < primaryChapterListData.length; j++) {
                    for (let k = 0; k < level2.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2[k]['ChapterID'] == level3[index]['ParentChapterID']) {
                                    if (primaryChapterListData[j]['ChapterID'] == level2[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.isSelect == 1)
                                        if (allSelectedChecked) {
                                            level3[index]['isSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.isSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2[k]['isSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListData[j]['isSelect'] = true

                                                } else {
                                                    primaryChapterListData[j]['isSelect'] = false
                                                }

                                            } else {
                                                level2[k]['isSelect'] = false
                                            }


                                        }
                                        else {
                                            level3[index]['isSelect'] = false
                                            level2[k]['isSelect'] = false
                                            primaryChapterListData[j]['isSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        setTimeout(() => {
            this.setState({ level4: level4, level3: level3, level2: level2 })
        }, 100);

    }

    onSelectLevel4Modal(e, id, tempLevel4,) {
        const { level2Modal, level3Modal, level4Modal, primaryChapterListDataModal } = this.state
        for (let i = 0; i < level4Modal.length; i++) {
            if (level4Modal[i]['ChapterID'] == id) {
                level4Modal[i]['isSelect'] = !level4Modal[i]['isSelect']
            }
        }
        this.setState({ ChapterHallErr: "" })
        var modelevel2 = []
        var modelevel3 = []

        for (let i = 0; i < level4Modal.length; i++) {
            if (level4Modal[i]['ChapterID'] == id) {
                level3Modal.map((s) => {
                    if (level4Modal[i].ParentChapterID == s.ChapterID) {
                        level2Modal.map(p => {
                            if (s.ParentChapterID == p.ChapterID) {
                                modelevel2.push(p)
                                primaryChapterListDataModal.map(q => {
                                    if (p.ParentChapterID == q.ChapterID) {
                                        modelevel3.push(q)
                                    }
                                })
                            }
                        })
                    }
                })
            }
        }

        const finalListlevel3 = []
        level3Modal.map(data => {
            modelevel2.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel3.push(data)
                }

            })
        })

        const finalListlevel2 = []
        level2Modal.map(data => {
            modelevel3.map((item) => {
                if (item.ChapterID == data.ParentChapterID) {
                    finalListlevel2.push(data)
                }

            })
        })



        for (let i = 0; i < tempLevel4.length; i++) {
            for (let index = 0; index < level3Modal.length; index++) {
                for (let j = 0; j < primaryChapterListDataModal.length; j++) {
                    for (let k = 0; k < level2Modal.length; k++) {
                        if (tempLevel4[i]['ChapterID'] == id) {
                            if (level3Modal[index]['ChapterID'] == tempLevel4[i]['ParentChapterID']) {
                                if (level2Modal[k]['ChapterID'] == level3Modal[index]['ParentChapterID']) {
                                    if (primaryChapterListDataModal[j]['ChapterID'] == level2Modal[k]['ParentChapterID']) {
                                        const allSelectedChecked = tempLevel4.every(item => item.isSelect == 1)
                                        if (allSelectedChecked) {
                                            level3Modal[index]['isSelect'] = true

                                            const allSelectedfinalListlevel3 = finalListlevel3.every(item => item.isSelect == 1)
                                            if (allSelectedfinalListlevel3) {
                                                level2Modal[k]['isSelect'] = true

                                                const allSelectedfinalListlevel2 = finalListlevel2.every(item => item.isSelect == 1)
                                                if (allSelectedfinalListlevel2) {
                                                    primaryChapterListDataModal[j]['isSelect'] = true

                                                } else {
                                                    primaryChapterListDataModal[j]['isSelect'] = false
                                                }

                                            } else {
                                                level2Modal[k]['isSelect'] = false
                                            }


                                        }
                                        else {
                                            level3Modal[index]['isSelect'] = false
                                            level2Modal[k]['isSelect'] = false
                                            primaryChapterListDataModal[j]['isSelect'] = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        setTimeout(() => {
            this.setState({ level4Modal: level4Modal, level3Modal: level3Modal, level2Modal: level2Modal, ChapterHallErrModal: '' })
        }, 100);



    }

    onSelect(id, status) {
        const { B2bMeetingList, B2bMeetingListmodal } = this.state
        if (status == 1) {
            var tempStatus
            for (var i = 0; i < B2bMeetingListmodal.length; i++) {
                for (var j = 0; j < B2bMeetingListmodal[i].timeSlotList.length; j++) {
                    if (id == B2bMeetingListmodal[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingListmodal[i].timeSlotList[j].isSelect) {
                            B2bMeetingListmodal[i].timeSlotList[j].isSelect = false
                            tempStatus = false
                        }
                        else {
                            B2bMeetingListmodal[i].timeSlotList[j].isSelect = true
                            tempStatus = true
                        }
                    }
                }
            }
            for (var i = 0; i < B2bMeetingList.length; i++) {
                for (var j = 0; j < B2bMeetingList[i].timeSlotList.length; j++) {
                    if (id == B2bMeetingList[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingList[i].timeSlotList[j].IsBooked) {
                            B2bMeetingList[i].timeSlotList[j].IsBooked = false
                            tempStatus = false
                        }
                        else {
                            B2bMeetingList[i].timeSlotList[j].IsBooked = true
                            tempStatus = true
                        }
                    }
                }
            }

            this.setState({ B2bMeetingListmodal: B2bMeetingListmodal, B2bMeetingList: B2bMeetingList, b2bErrModal: '' })
        } else {
            var tempStatus
            for (var i = 0; i < B2bMeetingList.length; i++) {
                for (var j = 0; j < B2bMeetingList[i].timeSlotList.length; j++) {
                    if (id == B2bMeetingList[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingList[i].timeSlotList[j].isSelect) {
                            B2bMeetingList[i].timeSlotList[j].isSelect = false
                            tempStatus = false
                        }
                        else {
                            B2bMeetingList[i].timeSlotList[j].isSelect = true
                            tempStatus = true
                        }
                    }
                }
            }
            for (var i = 0; i < B2bMeetingListmodal.length; i++) {
                for (var j = 0; j < B2bMeetingListmodal[i].timeSlotList.length; j++) {
                    if (id == B2bMeetingListmodal[i].timeSlotList[j].B2BTimeSlotID) {
                        if (B2bMeetingListmodal[i].timeSlotList[j].IsBooked) {
                            B2bMeetingListmodal[i].timeSlotList[j].IsBooked = false
                            tempStatus = false
                        }
                        else {
                            B2bMeetingListmodal[i].timeSlotList[j].IsBooked = true
                            tempStatus = true
                        }
                    }
                }
            }

            this.setState({ B2bMeetingList: B2bMeetingList, B2bMeetingListmodal: B2bMeetingListmodal, b2bErr: '' })
        }
    }

    handleDelete(e) {
        e.preventDefault()
        const { GroupDetailsList, AccountIDModal, AccountTypeID, onCrossClickFlagCoordinator, DelegateRegistrationID, DelegateRegistrationIDModal, AccountID } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVisaDoc_action(AccountTypeID, onCrossClickFlagCoordinator ? AccountID : AccountIDModal, onCrossClickFlagCoordinator ? DelegateRegistrationID : DelegateRegistrationIDModal)
            .then((data) => {
                if (data && data.error != 1) {
                    toastSuccess("Passport Document Deleted SuccessFully")
                    if (onCrossClickFlagCoordinator) {
                        this.setState({ passportFile: '', isVisaApplied: false, passportFileType: '', passPortFileName: '', isPassportFilePresent: false, passportFilePath: '' })
                    } else {
                        GroupDetailsList.map(item => {
                            if (item.AccountID == AccountIDModal) {
                                item.PassportFile = ''
                                item.PassportFileType = ''
                                item.PassportFileName = ''
                                item.passportFilePath = ''
                                item.isPassportFilePresent = false
                                item.isVisaApplied = false
                            }
                        })
                        this.setState({ passportFileModal: '', isVisaAppliedModal: false, passportFileTypeModal: '', passPortFileNameModal: '', isPassportFilePresentModal: false, passportFilePathModal: '' })
                    }
                    this.setState({ isLoading: false, isOpen3: false })
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
            })
    }

    handleSubmit(e, mode) {
        const { isOtherPreName, otherName, firstName, prename, lastName, seminarInterestList, countryId,
            preMobNo, preWhatsAppMobNo, gender, designation, institute, IECCode, Address1, Address2, Address3,
            pincode, regState, city, email, website, companywebsite, mobNo, whatsAppMobNo, isSameAsMobNo,
            telNo, preTelNo, tel1No, preTel1No, compInfoGstNo, visitPurposeList, compInfoPanNo, other, chapterList,
            companyProfile, totalYears, turnOverId, isInterestTwo, daysList, arrivalDate, departureDate,
            daysErr, passportFilePath, passportFileType, primaryChapterListData, level2, level3, level4,
            B2bMeetingList, needVisaAssistance, passName, applicantMobNo, preApplicantMobNo, applicantEmail,
            passNo, passDate, passExipryDate, passCountry, passportFile, passPortFileName, GroupDetailsList,
            PersonPhoto, PersonPhotoData, PersonPhotoName, PersonPhotoType, PersonProfile, agreeTerms } = this.state
        e.preventDefault()
        var Err = true

        if (agreeTerms == "" && this.showMandatoryFields(29, 0) && this.showMandatoryFields(29, 2)) {
            this.setState({ agreeTermsErr: "Please checked rules & regulations" });
            Err = false

        }
        if (firstName == "" && this.showMandatoryFields(2, 0) && this.showMandatoryFields(2, 2)) {
            this.setState({ firstNameErr: "Please enter first name" });
            Err = false
        }
        if (lastName == "" && this.showMandatoryFields(3, 0) && this.showMandatoryFields(3, 2)) {
            this.setState({ lastNameErr: "Please enter last name" });
            Err = false
        }
        if (gender == "" && this.showMandatoryFields(4, 0) && this.showMandatoryFields(4, 2)) {
            this.setState({ genderErr: "Please select Gender" });
            Err = false
        }
        if (designation == "" && this.showMandatoryFields(5, 0) && this.showMandatoryFields(5, 2)) {
            this.setState({ designationErr: "Please enter designation" });
            Err = false
        }
        if (institute == "" && this.showMandatoryFields(6, 0) && this.showMandatoryFields(6, 2)) {
            this.setState({ instituteErr: "Please enter institue/Organization" });
            Err = false
        }
        if (Address1 == "" && this.showMandatoryFields(10, 0) && this.showMandatoryFields(10, 2)) {
            this.setState({ Address1Err: "Please enter Address" });
            Err = false
        }
        if (Address2 == "" && this.showMandatoryFields(11, 0) && this.showMandatoryFields(11, 2)) {
            this.setState({ Address2Err: "Please enter Address 2" });
            Err = false
        }
        if (Address3 == "" && this.showMandatoryFields(12, 0) && this.showMandatoryFields(12, 2)) {
            this.setState({ Address3Err: "Please enter Address 3" });
            Err = false
        }
        if (website == "" && this.showMandatoryFields(17, 0) && this.showMandatoryFields(17, 2)) {
            this.setState({ websiteErr: "Please enter website" });
            Err = false
        }
        if (telNo == "" && this.showMandatoryFields(18, 0) && this.showMandatoryFields(18, 2)) {
            this.setState({ telephoneErr: "Please enter telephone No" });
            Err = false

        }
        if (tel1No == "" && this.showMandatoryFields(19, 0) && this.showMandatoryFields(19, 2)) {
            this.setState({ telephone1Err: "Please enter telephone No 1" });
            Err = false

        }

        if (IECCode == "" && this.showMandatoryFields(9, 0) && this.showMandatoryFields(9, 2)) {
            this.setState({ IECCodeErr: "Please enter IEC Code " });
            Err = false

        }
        if (mobNo == "" && this.showMandatoryFields(21, 0) && this.showMandatoryFields(21, 2)) {
            this.setState({ mobNoErr: "Please enter mobile no" });
            Err = false

        }
        if (whatsAppMobNo == "" && this.showMandatoryFields(22, 0) && this.showMandatoryFields(22, 2)) {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
            Err = false

        }

        if (regState == "" && countryId == "91" && this.showMandatoryFields(14, 0) && this.showMandatoryFields(14, 2)) {
            this.setState({ regStateErr: "Please enter province/state" });
            Err = false

        }
        if (city == "" && this.showMandatoryFields(13, 0) && this.showMandatoryFields(13, 2)) {
            this.setState({ cityErr: "Please enter city" });
            Err = false

        }
        if (pincode == "" && this.showMandatoryFields(15, 0) && this.showMandatoryFields(15, 2)) {
            this.setState({ pincodeErr: "Please enter Pincode" });
            Err = false

        }
        if (email == "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            this.setState({ emailErr: "Please enter Email" });
            Err = false

        }
        if (email != "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            var emailError = emailValidator(email)
            if (emailError != '') {
                this.setState({ emailErr: emailError })
                Err = false

            }
        }
        if (this.state.emailErr != "") {
            Err = false
        }
        if (companyProfile == "" && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)) {
            this.setState({ companyProfileErr: "Please enter Company profile" });
            Err = false

        }
        if (countryId == "" && this.showMandatoryFields(20, 0) && this.showMandatoryFields(20, 2)) {
            this.setState({ countryIdErr: "Please select country" });
            Err = false

        }
        if (totalYears == "" && this.showMandatoryFields(25, 0) && this.showMandatoryFields(25, 2)) {
            this.setState({ totalYearsErr: "Please enter Total Years the Company Is Operational" });
            Err = false

        }
        if (turnOverId == "" && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)) {
            this.setState({ turnOverErr: "Please Fill Company Profile" });
            Err = false

        }


        if (compInfoGstNo == "" && countryId == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            this.setState({ compInfoGstNoErr: "Please enter GST no" });
            Err = false

        } else if (countryId == 91 && this.showMandatoryFields(7, 0) && this.showMandatoryFields(7, 2)) {
            var errMsg = ''
            errMsg = gstNoValidator(compInfoGstNo)
            if (errMsg != '') {

                Err = false
                this.setState({ compInfoGstNoErr: errMsg });
            }
            else {
                this.setState({ compInfoGstNoErr: "" });
            }
        }
        if (compInfoPanNo == "" && countryId == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            this.setState({ compInfoPanNoErr: "Please enter Pan no" });
            Err = false

        } else if (countryId == 91 && this.showMandatoryFields(8, 0) && this.showMandatoryFields(8, 2)) {
            var errMsg = '';
            errMsg = panNoValidator(compInfoPanNo)
            if (errMsg != '') {

                Err = false
                this.setState({ compInfoPanNoErr: errMsg });
            }
            else {
                this.setState({ compInfoPanNoErr: "" });
            }
        }
        const selectedChapter = chapterList.filter(data => data.isSelect == true)
        var chapterListData = []
        selectedChapter.map((data) => {
            var data = {
                "ChapterID": data.IndustrySegmentID,
                "ChapterName": data['Industrial Segment'],
                "OtherNames": data.IndustrySegmentID == 16 ? other : ''
            }
            chapterListData.push(data)
        })

        const purposeOfVisitlist = visitPurposeList.filter(data => data.isSelect == true)
        var purposeOfVisitlistData = []
        purposeOfVisitlist.map((data) => {
            var data = {
                "PurposeofVisitID": data.PurposeofVisitID,
                "otherDetail": data.otherDetail
            }
            purposeOfVisitlistData.push(data)
        })
        var otherPOV = false
        purposeOfVisitlistData.map((data) => {
            otherPOV = data.PurposeofVisitID == 10 && (data.otherDetail == '' || data.otherDetail == null) ? true : false
        })
        if (otherPOV && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            this.setState({ visitPurposeErr: "Please enter other purpose of visit" })

            Err = false
        }
        if (purposeOfVisitlistData.length == 0 && this.showMandatoryFields(31, 0) && this.showMandatoryFields(31, 2)) {
            this.setState({ visitPurposeErr: "Please select Purpose of visit" })

            Err = false
        }
        const selectedSeminarList = seminarInterestList.filter(data => data.isSelect == true)
        var seminarInterestListData = []
        selectedSeminarList.map((data) => {
            var data = {
                "SeminarID": data.SeminarID,
            }
            seminarInterestListData.push(data)
        })

        var selectedDays = []
        selectedDays = daysList.filter(data => data.isSelect == true)
        var list = []
        selectedDays.map((data) => {
            var data = { "visitDay": data.VisitDate }
            list.push(data)
        })
        if (list.length == 0 && ((!isInterestTwo && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2)))) {
            this.setState({ daysErr: "Please select Visit Days" })

            Err = false
        } else {
            this.setState({ daysErr: "" })
        }
        var B2bList = []
        B2bMeetingList.length > 0 && B2bMeetingList.map(data => {
            data.timeSlotList.map(item => {
                if (item.isSelect) {
                    B2bList.push(item)
                }
            })
        })
        var B2bListfinal = []
        B2bList.length > 0 && B2bList.map(data => {
            var item = {
                "B2BTimeSlotID": data.B2BTimeSlotID
            }
            B2bListfinal.push(item)
        })

        var allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        var filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        var chapterListData2 = []
        filerArray.map((data) => {
            var data = {
                "ChapterID": data.ChapterID,
                "ChapterName": data.ChapterName,
            }
            chapterListData2.push(data)
        })

        var visaErr = false
        if (needVisaAssistance) {
            if (passName == "") {
                this.setState({ passNameErr: "Please enter Name " });
                visaErr = true
                Err = false
            }
            if (applicantMobNo == "") {

                this.setState({ applicantMobNoErr: "Please enter Mobile NO " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {

                this.setState({ applicantEmailErr: "Please enter Email " });
                visaErr = true
                Err = false
            }

            if (passNo == "") {

                this.setState({ passNoErr: "Please enter Passport No " });
                visaErr = true
                Err = false
            }
            if (passDate == "") {

                this.setState({ passDateErr: "Please enter Passport Date " });
                visaErr = true
                Err = false
            }
            if (passExipryDate == "") {

                this.setState({ passExipryDateErr: "Please enter Passport Expiry Date " });
                visaErr = true
                Err = false
            }
            if (passCountry == "") {

                this.setState({ passCountryErr: "Please Select Country " });
                visaErr = true
                Err = false
            }
            if (passportFile == "") {

                this.setState({ passportFileErr: "Please Upload File " });
                visaErr = true
                Err = false
            }
            if (applicantEmail == "") {

                this.setState({ applicantEmailErr: "Please enter Email" });
                visaErr = true
                Err = false
            }
            if (applicantEmail != "") {

                var emailError = emailValidator(applicantEmail)
                if (emailError != '') {

                    this.setState({ applicantEmailErr: emailError })
                    visaErr = true
                    Err = false
                }
            }
            if (visaErr) {

                if (this.showMandatoryFields(35, 0) && this.showMandatoryFields(35, 2)) {
                    this.setState({ visaErr: "Please Fill Visa Assistance" })
                    Err = false

                }
            } else {

                this.setState({ visaErr: "" })
            }
        } else {
            this.setState({
                passNameErr: "",
                applicantMobNoErr: "",
                applicantEmailErr: "",
                passNoErr: "",
                passDateErr: "",
                passExipryDateErr: "",
                passCountryErr: "",
                passportFileErr: "",
                applicantEmailErr: "",
                visaErr: ""
            });
        }
        var visaFlag = true
        GroupDetailsList.map(item => {
            if (item.isVisaAssistance) {
                if (item.PassportFile == '' || item.PassportFile == null) {
                    visaFlag = false
                }
            }
        })
        console.log()
        setTimeout(() => {
            if (daysErr == "" && visaFlag && Err
            ) {
                if (Err) {
                    if (this.state.GroupDetailsList.length == 0) {
                        toastError("Please Add Atleast 1 Delegate")
                    } else {
                        var obj = {
                            'id': 0,
                            'DelegateRegistrationID': this.state.DelegateRegistrationID,
                            'AccountTypeID': this.state.AccountTypeID,
                            'AccountID': this.state.AccountID,
                            'DelegateRegistrationNo': this.state.DelegateRegistrationNo,
                            'Title': isOtherPreName ? otherName : prename,
                            'firstName': firstName,
                            'lastName': lastName,
                            'gender': gender,
                            'designation': designation,
                            'CompanyName': institute,
                            'GSTNo': compInfoGstNo,
                            'PanNo': compInfoPanNo,
                            'IECCode': IECCode,
                            'Address1': Address1,
                            'Address2': Address2,
                            'Address3': Address3,
                            'City': city,
                            'State': regState,
                            'Pin': pincode,
                            'PrimaryEmail': email,
                            'Website': website,
                            'Telephone': preTelNo != '' && preTelNo != null ? `${preTelNo}-${telNo}` : telNo,
                            'Telephone1': preTel1No != '' && preTel1No != null ? `${preTel1No}-${tel1No}` : tel1No,
                            'CountryID': countryId,
                            'mobNo': preMobNo != '' && preMobNo != null ? `${preMobNo}-${mobNo}` : mobNo,
                            'whatsAppMobNo': preWhatsAppMobNo != '' && preWhatsAppMobNo != null ? `${preWhatsAppMobNo}-${whatsAppMobNo}` : whatsAppMobNo,
                            'IsIntrestedForB2B': isInterestTwo,
                            'CompanyProfile': companyProfile,
                            'CompanyWebsite': companywebsite,
                            'TotalOperationalYears': totalYears,
                            'CompanyTurnOverID': turnOverId,
                            'ArrivalDate': arrivalDate,
                            'DepartureDate': departureDate,
                            'IsCoordinator': true,
                            'isCoordinatorAsDelegate': true,
                            'chaptersList': chapterListData2,
                            'seminarList': selectedSeminarList,
                            'visitdays': isInterestTwo ? [] : list,
                            'purposeOfVisitList': purposeOfVisitlistData,
                            'industrySegmentList': chapterListData,
                            'B2BmappingList': B2bListfinal,
                            'ApplicantEmailID': needVisaAssistance ? applicantEmail : '',
                            'ApplicantMobileNo': needVisaAssistance ? preApplicantMobNo != '' && preApplicantMobNo != null ? `${preApplicantMobNo}-${applicantMobNo}` : applicantMobNo : '',
                            'NameOnPassport': needVisaAssistance ? passName : '',
                            'PassportExpiryDate': needVisaAssistance ? passExipryDate : '',
                            'PassportFile': needVisaAssistance ? passportFile : '',
                            'PassportFileName': needVisaAssistance ? passPortFileName : '',
                            'passportFilePath': needVisaAssistance ? passportFilePath : '',
                            'PassportFileType': needVisaAssistance ? passportFileType : '',
                            'PassportIssueDate': needVisaAssistance ? passDate : '',
                            'PassportIssuingCountryID': needVisaAssistance ? passCountry : '',
                            'PassportNo': needVisaAssistance ? passNo : '',
                            'isVisaAssistance': needVisaAssistance,
                            'isVisaApplied': needVisaAssistance,
                            'isPassportFilePresent': false,
                            'isSameAsMobNo': isSameAsMobNo,
                            'PersonProfile': PersonProfile,
                            'PersonPhoto': PersonPhoto,
                            'PersonPhotoName': PersonPhotoName,
                            'PersonPhotoData': PersonPhotoData,
                            'PersonPhotoType': PersonPhotoType
                        }
                        this.setState({ onJustSubmit: true })
                        GroupDetailsList.unshift(obj)
                        if (GroupDetailsList.length > 1) {
                            this.setState({ isLoading: true })
                            this.props.delegateRegistrationGroupNext_action(GroupDetailsList, agreeTerms)
                                .then((data) => {
                                    if (data && data.error != 1) {
                                        this.setState({ isLoading: false })
                                        sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0][0]))
                                        sessionStorage.setItem('DelegateTypeID', this.state.AccountTypeID)
                                        if (mode == 1) {
                                            GroupDetailsList.shift()
                                            this.setState({ GroupDetailsList: [], onJustSubmit: false }, () => {
                                                this.getRegistrationDetails()
                                            })
                                        } else {
                                            sessionStorage.setItem("countryId", countryId)
                                            if (sessionStorage.getItem('AccountTypeID') == 10) {
                                                this.props.navigate('/delegatePreview')
                                            } else {
                                                this.props.navigate('/delegateAdditionalDetails')
                                            }
                                        }
                                    } else {
                                        this.setState({ isLoading: false })
                                        toastError(data.msg);
                                        GroupDetailsList.shift()
                                        this.setState({ onJustSubmit: false })
                                    }
                                })
                                .catch((err) => {
                                    GroupDetailsList.shift()
                                    this.setState({ onJustSubmit: false })
                                    toastError('something went wrong...');
                                })
                        } else { toastError("add atleast 1 Delegate") }
                    }
                } else { toastError("Enter Coordinator Details") }
            } else { toastError("Enter Mandatory Fields") }
        }, 200);
    }

    handleSubmitIndividual(e) {
        const { firstName, prename, lastName, countryId, preMobNo, gender, designation, institute, IECCode, Address1, Address2, Address3,
            pincode, regState, city, email, website, programList, companywebsite, mobNo, whatsAppMobNo, isSameAsMobNo, telNo,
            tel1No, compInfoGstNo, compInfoPanNo, companyProfile, totalYears, turnOverId, arrivalDate, departureDate,
            AccountID, DelegateRegistrationID, AccountTypeID, PersonProfile, PersonPhoto, PersonPhotoData, PersonPhotoName, PersonPhotoType, agreeTerms } = this.state
        e.preventDefault()
        var Err = true

        if (agreeTerms == "" && this.showMandatoryFields(29, 0) && this.showMandatoryFields(29, 2)) {
            this.setState({ agreeTermsErr: "Please checked rules & regulations" });
            Err = false

        }
        if (firstName == "" && this.showMandatoryFields(2, 0) && this.showMandatoryFields(2, 2)) {
            this.setState({ firstNameErr: "Please enter first name" });
            Err = false
        }
        if (lastName == "" && this.showMandatoryFields(3, 0) && this.showMandatoryFields(3, 2)) {
            this.setState({ lastNameErr: "Please enter last name" });
            Err = false
        }
        if (gender == "" && this.showMandatoryFields(4, 0) && this.showMandatoryFields(4, 2)) {
            this.setState({ genderErr: "Please select Gender" });
            Err = false
        }
        if (designation == "" && this.showMandatoryFields(5, 0) && this.showMandatoryFields(5, 2)) {
            this.setState({ designationErr: "Please enter designation" });
            Err = false
        }
        if (institute == "" && this.showMandatoryFields(6, 0) && this.showMandatoryFields(6, 2)) {
            this.setState({ instituteErr: "Please enter institue/Organization" });
            Err = false
        }
        if (Address1 == "" && this.showMandatoryFields(10, 0) && this.showMandatoryFields(10, 2)) {
            this.setState({ Address1Err: "Please enter Address" });
            Err = false
        }
        if (Address2 == "" && this.showMandatoryFields(11, 0) && this.showMandatoryFields(11, 2)) {
            this.setState({ Address2Err: "Please enter Address 2" });
            Err = false
        }
        if (Address3 == "" && this.showMandatoryFields(12, 0) && this.showMandatoryFields(12, 2)) {
            this.setState({ Address3Err: "Please enter Address 3" });
            Err = false
        }
        if (website == "" && this.showMandatoryFields(17, 0) && this.showMandatoryFields(17, 2)) {
            this.setState({ websiteErr: "Please enter website" });
            Err = false
        }
        if (telNo == "" && this.showMandatoryFields(18, 0) && this.showMandatoryFields(18, 2)) {
            this.setState({ telephoneErr: "Please enter telephone No" });
            Err = false
        }
        if (tel1No == "" && this.showMandatoryFields(19, 0) && this.showMandatoryFields(19, 2)) {
            this.setState({ telephone1Err: "Please enter telephone No 1" });
            Err = false
        }
        if (IECCode == "" && this.showMandatoryFields(9, 0) && this.showMandatoryFields(9, 2)) {
            this.setState({ IECCodeErr: "Please enter IEC Code " });
            Err = false
        }
        if (mobNo == "" && this.showMandatoryFields(21, 0) && this.showMandatoryFields(21, 2)) {
            this.setState({ mobNoErr: "Please enter mobile no" });
            Err = false
        }
        if (whatsAppMobNo == "" && this.showMandatoryFields(22, 0) && this.showMandatoryFields(22, 2)) {
            this.setState({ whatsAppMobNoErr: "Please enter whatsapp no" });
            Err = false
        }
        if (regState == "" && countryId == "91" && this.showMandatoryFields(14, 0) && this.showMandatoryFields(14, 2)) {
            this.setState({ regStateErr: "Please enter province/state" });
            Err = false
        }
        if (city == "" && this.showMandatoryFields(13, 0) && this.showMandatoryFields(13, 2)) {
            this.setState({ cityErr: "Please enter city" });
            Err = false
        }
        if (pincode == "" && this.showMandatoryFields(15, 0) && this.showMandatoryFields(15, 2)) {
            this.setState({ pincodeErr: "Please enter Pincode" });
            Err = false
        }
        if (email == "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            this.setState({ emailErr: "Please enter Email" });
            Err = false
        }
        if (email != "" && this.showMandatoryFields(16, 0) && this.showMandatoryFields(16, 2)) {
            var emailError = emailValidator(email)
            if (emailError != '') {
                this.setState({ emailErr: emailError })
                Err = false
            }
        }
        if (this.state.emailErr != "") {
            Err = false
        }
        if (companyProfile == "" && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)) {
            this.setState({ companyProfileErr: "Please enter Company profile" });
            Err = false
        }
        if (countryId == "" && this.showMandatoryFields(20, 0) && this.showMandatoryFields(20, 2)) {
            this.setState({ countryIdErr: "Please select country" });
            Err = false
        }
        if (totalYears == "" && this.showMandatoryFields(25, 0) && this.showMandatoryFields(25, 2)) {
            this.setState({ totalYearsErr: "Please enter Total Years the Company Is Operational" });
            Err = false
        }
        if (turnOverId == "" && this.showMandatoryFields(26, 0) && this.showMandatoryFields(26, 2)) {
            this.setState({ turnOverErr: "Please Fill Company Profile" });
            Err = false
        }
        if (AccountTypeID == "") {

            this.setState({ AccountTypeIDErr: "Please select Account type" });
            Err = false
        }
        if (PersonPhoto == "" && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)) {

            if (PersonPhotoData == "") {

                this.setState({ PersonPhotoErr: "Please select Person Photo" });
                Err = false
            }
        } if (PersonProfile == '' && this.showMandatoryFields(23, 0) && this.showMandatoryFields(23, 2)) {
            this.setState({ PersonProfileErr: "Please Enter Person Profile" })
        }
        setTimeout(() => {
            if (Err) {
                var ExhProgramList = []
                var ExhProgramDateList = []
                var ExhProgramCategory = []
                programList.map(item => {
                    if (item.isSelect) {
                        if (!ExhProgramList.includes(item.ExhProgramID)) {
                            ExhProgramList.push(item.ExhProgramID)
                        }
                        if (!ExhProgramDateList.includes(item.ExhProgramDateID)) {
                            ExhProgramDateList.push(item.ExhProgramDateID)
                        }
                        item.catogary.length > 0 && item.catogary.map(item2 => {
                            if (item2.isSelect) {
                                if (!ExhProgramCategory.includes(item2.ExhProgramCategoryID)) {
                                    ExhProgramCategory.push(item2.ExhProgramCategoryID)
                                }
                            }
                        })
                    }
                })
                this.setState({ isLoading: true })
                this.props.delegateRegistrationNext_action(AccountID, DelegateRegistrationID, countryId, AccountTypeID, this.state.isOtherPreName ? this.state.otherName : prename, firstName, lastName,
                    gender, designation, institute, compInfoGstNo, compInfoPanNo, IECCode, Address1, Address2, Address3, website, `${preMobNo}-${mobNo}`,
                    `${preMobNo}-${whatsAppMobNo}`, isSameAsMobNo, regState, city, pincode, email, telNo, tel1No, companyProfile, companywebsite, totalYears,
                    turnOverId, arrivalDate, departureDate, false, false, PersonProfile, PersonPhoto, PersonPhotoName, PersonPhotoData, PersonPhotoType, agreeTerms, ExhProgramList, ExhProgramDateList, ExhProgramCategory, this.state.Source)
                    .then((data) => {
                        if (data && data.error != 1) {
                            this.setState({ isLoading: false })
                            sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0]))
                            if (sessionStorage.getItem("AccountTypeID") == 12) {
                                sessionStorage.setItem("delegateShowName", 'VIP')
                            } else {
                                sessionStorage.setItem("delegateShowName", 'Delegate')
                            }
                            sessionStorage.setItem('DelegateTypeID', AccountTypeID)
                            sessionStorage.setItem("countryId", countryId)
                            if (sessionStorage.getItem('AccountTypeID') == 10) {
                                this.props.navigate('/delegatePreview')
                            } else {
                                if (this.showMandatoryFields(30, 0) || this.showMandatoryFields(31, 0) || this.showMandatoryFields(32, 0) || this.showMandatoryFields(33, 0) || this.showMandatoryFields(34, 0) || (this.showMandatoryFields(35, 0) && !(parseInt(this.state.countryId) == parseInt(sessionStorage.getItem('ExhibitionCountryID')))) || this.showMandatoryFields(36, 0)) {
                                    this.props.navigate('/delegateAdditionalDetails')
                                } else {
                                    this.props.navigate('/delegatePreview')
                                }
                            }
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg);
                        }
                    }).catch((err) => { console.log(err) })
            } else { toastError("Enter Mandatory Fields") }
        }, 200);
    }

    onAccountTypeChange(id) {
        if (id != '') {
            sessionStorage.setItem('AccountTypeID', id)
            this.setState({ AccountTypeID: id, AccountTypeIDErr: '' }, () => { this.getFieldList(id) })
        }
    }
    calculateRowspan(data) {
        const parentChildMap = {};
        data.forEach(item => {
            item.Rowspan = 0;
            if (item.ParentSeminarID !== null) {
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });
        return data;
    }

    handleSearchChange = (event, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ regState: event.target.value, isOpenDropDownState: event.target.value.length > 0, tempStateList: this.filterItems(event.target.value, mode, status), focusedIndexState: -1, regStateErr: '' });
            }
            else if (status == 1) {
                this.setState({ regStateModal: event.target.value, isOpenDropDownStateModal: event.target.value.length > 0, tempStateListModal: this.filterItems(event.target.value, mode, status), focusedIndexStateModal: -1, regStateErrModal: '' });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: event.target.value, isOpenDropDownCity: event.target.value.length > 0, tempCityList: this.filterItems(event.target.value, mode, status), focusedIndexCity: -1, cityErr: '' });
            }
            else if (status == 1) {
                this.setState({ cityModal: event.target.value, isOpenDropDownCityModal: event.target.value.length > 0, tempCityListModal: this.filterItems(event.target.value, mode, status), focusedIndexCityModal: -1, cityErrModal: '' });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: event.target.value, isOpenDropDownPin: event.target.value.length > 0, tempPincodeList: this.filterItems(event.target.value, mode, status), focusedIndexPin: -1, pincodeErr: '' });
            }
            else if (status == 1) {
                this.setState({ pincodeModal: event.target.value, isOpenDropDownPinModal: event.target.value.length > 0, tempPincodeListModal: this.filterItems(event.target.value, mode, status), focusedIndexPinModal: -1, pincodeErrModal: '' });
            }
        }
    };

    filterItems = (searchTerm, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.stateList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 1) {
            if (status == 0) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.cityList.filter(item =>
                    item.Description.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        } else if (mode == 2) {
            if (status == 0) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            } else if (status == 1) {
                return this.state.pincodeList.filter(item =>
                    item.Pincode.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
        }
    };

    handleSelect = (option, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ focusedIndexState: -1, tempStateList: [], isOpenDropDownState: false, }, () => {
                    this.callStateList(option.Description, option.Code)
                });
            } else if (status == 1) {
                this.setState({ focusedIndexStateModal: -1, tempCityListModal: [], isOpenDropDownStateModal: false, });
                this.callStateListModal(option.Description, option.Code)

            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ city: option.Description, focusedIndexCity: -1, tempCityList: [], isOpenDropDownCity: false, });
            } else if (status == 1) {
                this.setState({ cityModal: option.Description, focusedIndexCityModal: -1, tempStateListModal: [], isOpenDropDownCityModal: false, });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ pincode: option.Pincode, focusedIndexPin: -1, tempCityList: [], isOpenDropDownPin: false, });
            } else if (status == 1) {
                this.setState({ pincodeModal: option.Pincode, focusedIndexPinModal: -1, tempCityListModal: [], isOpenDropDownPinModal: false, });
            }
        }
    };

    handleKeyDown = (e, mode, status) => {
        const { focusedIndexState, tempPincodeList, tempPincodeListModal, focusedIndexPin, focusedIndexPinModal, tempStateList, focusedIndexStateModal, tempStateListModal, tempCityList, focusedIndexCity, focusedIndexCityModal, tempCityListModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexState: Math.min(focusedIndexState + 1, tempStateList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexState: Math.max(focusedIndexState - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexState >= 0) {
                    this.handleSelect(tempStateList[focusedIndexState], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexStateModal: Math.min(focusedIndexStateModal + 1, tempStateListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexStateModal: Math.max(focusedIndexStateModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexStateModal >= 0) {
                    this.handleSelect(tempStateListModal[focusedIndexStateModal], mode, status);
                }
            }
        } else if (mode == 1) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexCity: Math.min(focusedIndexCity + 1, tempCityList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCity >= 0) {
                    this.handleSelect(tempCityList[focusedIndexCity], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexCityModal: Math.min(focusedIndexCityModal + 1, tempCityListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexCityModal: Math.max(focusedIndexCityModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexCityModal >= 0) {
                    this.handleSelect(tempCityListModal[focusedIndexCityModal], mode, status);
                }
            }
        } else if (mode == 2) {
            if (status == 0) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexPin: Math.min(focusedIndexPin + 1, tempPincodeList.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexPin: Math.max(focusedIndexPin - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPin >= 0) {
                    this.handleSelect(tempPincodeList[focusedIndexPin], mode, status);
                }
            } else if (status == 1) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexPinModal: Math.min(focusedIndexPinModal + 1, tempPincodeListModal.length - 1),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.setState({
                        focusedIndexPinModal: Math.max(focusedIndexPinModal - 1, 0),
                    }, () => this.scrollIntoView(mode, status));
                } else if (e.key === 'Enter' && focusedIndexPinModal >= 0) {
                    this.handleSelect(tempPincodeListModal[focusedIndexPinModal], mode, status);
                }
            }
        }
    };

    handleHover = (index, mode, status) => {
        if (mode == 0) {
            if (status == 0) {
                this.setState({ focusedIndexState: index });
            } else if (status == 1) {
                this.setState({ focusedIndexStateModal: index });
            }
        } else if (mode == 1) {
            if (status == 0) {
                this.setState({ focusedIndexCity: index });
            } else if (status == 1) {
                this.setState({ focusedIndexCityModal: index });
            }
        } else if (mode == 2) {
            if (status == 0) {
                this.setState({ focusedIndexPin: index });
            } else if (status == 1) {
                this.setState({ focusedIndexPinModal: index });
            }
        }
    };

    scrollIntoView = (mode, status) => {
        const { focusedIndexState, focusedIndexStateModal, focusedIndexPin, focusedIndexPinModal, focusedIndexCity, focusedIndexCityModal } = this.state;
        if (mode == 0) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexState];
                if (!focusedItem) return;

                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;

                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {




                const dropdownMenu = document.querySelector('.modal .dropdown-menu');

                const focusedItem = dropdownMenu.children[focusedIndexStateModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;


                setTimeout(() => {
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 1) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexCity];
                if (!focusedItem) return;

                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;

                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {




                const dropdownMenu = document.querySelector('.modal .dropdown-menu');

                const focusedItem = dropdownMenu.children[focusedIndexCityModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;


                setTimeout(() => {
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        } else if (mode == 2) {
            if (status == 0) {
                const dropdownMenu = document.querySelector('.dropdown-menu'); // Get the dropdown menu
                if (!dropdownMenu) return;

                const focusedItem = dropdownMenu.children[focusedIndexPin];
                if (!focusedItem) return;

                const dropdownTop = dropdownMenu.getBoundingClientRect().top;
                const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
                const itemTop = focusedItem.getBoundingClientRect().top;
                const itemBottom = focusedItem.getBoundingClientRect().bottom;
                const menuTop = dropdownMenu.scrollTop;
                const menuHeight = dropdownMenu.offsetHeight;

                if (itemBottom > dropdownBottom) {
                    dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                }
                else if (itemTop < dropdownTop) {
                    dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                }
            } else if (status == 1) {
                const dropdownMenu = document.querySelector('.modal .dropdown-menu');

                const focusedItem = dropdownMenu.children[focusedIndexPinModal];
                const dropdownRect = dropdownMenu.getBoundingClientRect();
                const itemRect = focusedItem.getBoundingClientRect();

                const modalRect = document.querySelector('.modal').getBoundingClientRect();
                const dropdownTop = dropdownRect.top - modalRect.top;
                const dropdownBottom = dropdownRect.bottom - modalRect.top;
                const itemTop = itemRect.top - modalRect.top;
                const itemBottom = itemRect.bottom - modalRect.top;
                const menuTop = dropdownMenu.scrollTop;


                setTimeout(() => {
                    if (itemBottom > dropdownBottom) {
                        dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
                    } else if (itemTop < dropdownTop) {
                        dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
                    }
                }, 50);
            }
        }
    };

    showMandatoryFields(FieldID, mode) {
        const { showFieldList } = this.state
        var isFieldAvailable = false
        for (var i = 0; i < showFieldList.length; i++) {
            if (showFieldList[i].id == FieldID) {
                isFieldAvailable = true
                if (mode == 0) {
                    return true
                } else if (mode == 1) {
                    return showFieldList[i].name
                } else if (mode == 2) {
                    if (showFieldList[i].mandatory) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        }
        if (!isFieldAvailable) {
            return false
        }
    }

    selectProgram(flag, id) {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        if (flag == 1) {
            var beforeValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramID == id) {
                    if (programList[i].isSelect) {
                        beforeValue = true
                        break
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramID == id) {
                    if (beforeValue) {
                        programList[i].isSelect = false
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = false
                        }
                    } else {
                        programList[i].isSelect = true
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
        } if (flag == 2) {
            var beforeValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == id) {
                    if (programList[i].isSelect) {
                        beforeValue = true
                        break
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == id) {
                    if (beforeValue) {
                        programList[i].isSelect = false
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = false
                        }
                    } else {
                        programList[i].isSelect = true
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
        } if (flag == 3) {
            var beforeValue = false
            var DateId = ''
            var DateValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    if (programList[i].catogary[j].ExhProgramCategoryID == id) {
                        DateId = programList[i].ExhProgramDateID
                        if (programList[i].catogary[j].isSelect) {
                            beforeValue = true
                            break
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    if (programList[i].catogary[j].ExhProgramCategoryID == id) {
                        if (beforeValue) {
                            programList[i].catogary[j].isSelect = false
                        } else {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == DateId) {
                    for (var j = 0; j < programList[i].catogary.length; j++) {
                        if (programList[i].catogary[j].isSelect) {
                            DateValue = true
                            break
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == DateId) {
                    if (DateValue) {
                        programList[i].isSelect = true

                    } else {
                        programList[i].isSelect = false
                    }
                }
            }
        }
        this.setState({ programList: programList })
    }

    checkSelectedProgram(id) {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        var beforeValue = false
        for (var i = 0; i < programList.length; i++) {
            if (programList[i].ExhProgramID == id) {
                if (programList[i].isSelect) {
                    beforeValue = true
                    break
                }
            }
        }
        return beforeValue
    }

    checkselectallprogram() {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        var checkIfAllfalse = false
        for (var i = 0; i < programList.length; i++) {
            if (programList[i].isSelect == false) {
                checkIfAllfalse = true
            }
            for (var j = 0; j < programList[i].catogary.length; j++) {
                if (programList[i].catogary[j].isSelect == false) {
                    checkIfAllfalse = true
                }
            }
        }
        return !checkIfAllfalse
    }

    selectAllProgram() {
        const { isLoading, programList, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
        } = this.state
        var checkIfAllfalse = false
        for (var i = 0; i < programList.length; i++) {
            if (programList[i].isSelect == false) {
                checkIfAllfalse = true
            }
            for (var j = 0; j < programList[i].catogary.length; j++) {
                if (programList[i].catogary[j].isSelect == false) {
                    checkIfAllfalse = true
                }
            }
        }
        console.log('checkIfAllfalse', checkIfAllfalse)
        if (checkIfAllfalse) {
            for (var i = 0; i < programList.length; i++) {
                programList[i].isSelect = true
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    programList[i].catogary[j].isSelect = true
                }
            }
        } else {
            for (var i = 0; i < programList.length; i++) {
                programList[i].isSelect = false
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    programList[i].catogary[j].isSelect = false
                }
            }
        }
        this.setState({ programList: programList })
    }

    render() {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            lastName, lastNameErr, genderList, programList, countryIdErr, seminarInterestList, countryId, countryList, preMobNo, preWhatsAppMobNo, tempStateList, tempCityList,
            tempPincodeList, gender, genderErr, designation, designationErr, institute, instituteErr, IECCode, IECCodeErr, Address1, Address2, Address3, Address1Err,
            pincode, pincodeErr, regState, regStateErr, city, cityErr, email, emailErr, showFieldList, website, companywebsite, companywebsiteModal, mobNo, mobNoErr,
            whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, telNo, preTelNo, tel1No, preTel1No, compInfoGstNo, compInfoGstNoErr, visitPurposeList, visitPurposeErr,
            compInfoPanNoErr, compInfoPanNo, chapterList, companyProfile, isModalEdit, isOpen, totalYears, totalYearsErr, companyProfileErr, isOtherPreNameModal,
            otherNameModal, firstNameModal, firstNameErrModal, prenameModal, lastNameModal, lastNameErrModal, countryIdErrModal, countryIdModal, genderErrModal,
            preMobNoModal, preWhatsAppMobNoModal, tempStateListModal, tempCityListModal, tempPincodeListModal, genderModal, designationModal, designationErrModal,
            instituteModal, instituteErrModal, IECCodeModal, IECCodeErrModal, Address1Modal, Address2Modal, Address3Modal, Address1ErrModal, pincodeModal, pincodeErrModal,
            regStateModal, regStateErrModal, cityModal, cityErrModal, emailModal, emailErrModal, mobNoModal, mobNoErrModal, whatsAppMobNoModal, whatsAppMobNoErrModal,
            isSameAsMobNoModal, telNoModal, preTelNoModal, tel1NoModal, preTel1NoModal, compInfoGstNoModal, compInfoGstNoErrModal, compInfoPanNoErrModal,
            compInfoPanNoModal, chapterListModal, seminarInterestListModal, companyProfileModal, websiteModal, totalYearsModal, totalYearsErrModal, isInterestTwo,
            companyProfileErrModal, visitPurposeListModal, daysList, daysListModal, visitPurposeErrModal, arrivalDate, arrivalDateErr, departureDate, departureDateErr,
            arrivalDateModal, arrivalDateErrModal, departureDateModal, departureDateErrModal, isInterestTwoModal, daysErr, daysErrModal, isOpen3, primaryChapterListData,
            level2, level3, level4, primaryChapterListDataModal, level2Modal, level3Modal, level4Modal, B2bMeetingList, B2bMeetingListmodal, needVisaAssistance, passName,
            passNameErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate,
            passExipryDateErr, passCountryErr, passCountry, isPassportFilePresent, isVisaApplied, passportFileErr, passportFile, passPortFileName, needVisaAssistanceModal,
            passNameModal, passNameErrModal, applicantMobNoModal, applicantMobNoErrModal, preApplicantMobNoModal, applicantEmailModal, applicantEmailErrModal, isLinkOpen,
            passNoModal, passNoErrModal, passDateModal, passDateErrModal, passExipryDateModal, passExipryDateErrModal, passCountryErrModal, passCountryModal, isPassportFilePresentModal,
            isVisaAppliedModal, passportFileErrModal, passportFileModal, passPortFileNameModal, isOpenDropDownStateModal, isOpenDropDownCity, isOpenDropDownCityModal, isOpenDropDownPin,
            isOpenDropDownPinModal, Address2Err, Address3Err, websiteErr, Source, telephoneErr, telephone1Err, companyWebsiteErr, Address2ErrModal, Address3ErrModal, websiteErrModal,
            telephoneErrModal, telephone1ErrModal, companyWebsiteErrModal, PersonProfile, PersonProfileErr, PersonPhoto, PersonPhotoPreview, PersonPhotoErr, PersonProfileModal,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, GroupDetailsList, delegateIndex } = this.state
        const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        const filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        const allArrayModal = [...primaryChapterListDataModal, ...level2Modal, ...level3Modal, ...level4Modal]
        const filerArrayModal = allArrayModal.filter((data) => data.IsCheckbox && data.isSelect)
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const linkOpenStatus = JSON.parse(sessionStorage.getItem('isLinkOpen')) || 'false';
        const linkOpenStatus2 = JSON.parse(sessionStorage.getItem('loginDataSS'))?.['loginAccesslist'];
        const delegateData = sessionStorage.getItem('DelegateDataSS');
        console.log(this.state.seminarInterestList, 'AccountTypeID', this.state.programList, this.state.prename, this.state.otherName, this.state.isOtherPreName)
        return (
            <>
                {
                    isLoading ? (
                        <Loader></Loader>
                    ) : (
                        null
                    )
                }
                <ToastContainer />
                {!linkOpenStatus && <VisitorHeader />}
                {linkOpenStatus2 && <AdminDrawer />}

                <div
                    className={
                        linkOpenStatus2
                            ? 'main-content app-content with-dr-container no-scroll'
                            : ''
                    }
                    style={{ marginTop: '5rem' }}
                >
                    {(linkOpenStatus && delegateData) ||
                        (linkOpenStatus && isDataLoad) ? (
                        <VisitorHeader />
                    ) : null}
                    <div
                        className="main-content app-content mt-0 no-scroll delegate-form-page"
                        style={{ marginInlineStart: 0 }}
                    >
                        <div className="side-app">
                            <div className="container-fluid p-0">
                                {/* Grey title bar fixed under the header, same as the visitor registration pages */}
                                <div className="row m-0">
                                    <div className="breadcrumb-scroll-fixed p-0 delegate-reg-bar">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0 p-2 text-white">{this.state.accountTypeList.length > 0 && this.state.accountTypeList.find(obj => obj.AccountTypeID == this.state.AccountTypeID)?.Name?.split(' ')[0]} Registration Form</h6>
                                            {!this.state.isLinkOpen && <a style={{ color: 'white', fontWeight: 500, cursor: 'pointer', marginRight: '1rem' }} href={`/#/delegateRegistration/${sessionStorage.getItem("exhibitionCode")}`} target="_blank"><i class="fa fa-share-alt" ></i> Copy Registration Link</a>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!isExhbitionClosed ? (
                                <div className="needs-validation after-step mt-1 ms-1 delegate-reg-content">
                                    <div id="Menu1">
                                        <div id="section-1">
                                            {/* <div className="one-section">
                                            <div className="containerfluid">
                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <div className="p-1 title-bg d-flex">
                                                            <p className="mb-0">
                                                                Delegate Type <span className="text-red">*</span>
                                                            </p>
                                                            {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.visitorTypeErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-6 mb-4">
                                                <div className="row mt-4">
                                                    {
                                                        this.state.visitorTypeList.length > 0 && this.state.visitorTypeList.map((data) => (
                                                            <div className="col-sm-4" key={data.VisitorTypeID}>
                                                                <label className="d-flex">
                                                                    <input type="radio" name="vistorType" value={data.VisitorTypeID}
                                                                        checked={data.VisitorTypeID == this.state.VisitorTypeID}
                                                                        onChange={(e) => this.setState({ VisitorTypeID: data.VisitorTypeID, GroupDetailsList: [] })}
                                                                    />
                                                                    {data.VisitorType}
                                                                </label>
                                                            </div>
                                                        ))
                                                    }


                                                </div>
                                            </div>
                                        </div> */}
                                            {!this.state.isLinkOpen &&
                                                <div className="one-section">
                                                    <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg">
                                                                    <p className="mb-0">Account Type</p>
                                                                    {/* <p className="mb-0">Personal Information</p> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-xl-3 mt-3">
                                                                <div className="d-flex">
                                                                    <label className="w-auto" >
                                                                        Select Account Type
                                                                        <span className="text-red">*</span>

                                                                    </label>
                                                                </div>
                                                                <select className="form-control" value={this.state.AccountTypeID}
                                                                    onChange={(e) => this.onAccountTypeChange(e.target.value)}
                                                                >
                                                                    <option value={''}>Select Type</option>
                                                                    {
                                                                        this.state.accountTypeList.length > 0 && this.state.accountTypeList.map((data) => (
                                                                            <option key={data.AccountTypeID} value={data.AccountTypeID} >{data.Name}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                {<span className='text-danger text-start text-left d-block '>{this.state.AccountTypeIDErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            } <div className="row">
                                                <div className="col-sm-3">


                                                    {/* If no results found, show a message */}
                                                    {/* {isOpenDropDown && filteredOptions.length === 0 && (
                                                        <Dropdown.Menu show style={{ position: 'absolute', width: '100%', zIndex: 999 }}>
                                                            <Dropdown.Item disabled>No results found</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    )} */}
                                                </div>
                                            </div>
                                            {sessionStorage.getItem('AccountTypeID') == 10 && <div className="pt-0 px-3 mb-2">
                                                <h6 className="mb-0" style={{ textAlign: 'left' }}>
                                                    Note: Kindly enter the Co-ordinator details below.
                                                </h6>
                                            </div>}
                                            {showFieldList.length !== 0 && (
                                                <>
                                                    <div className="accordion mt-2 m-2" id="accordionExample">
                                                        <div className="accordion-item mb-2">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') === 10 ? 'selected-chapter' : ''}`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h1"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h1"
                                                                >{delegateUUID ? <>Delegate Information</> : <>
                                                                    {sessionStorage.getItem('AccountTypeID') == 10
                                                                        ? 'Coordinator personal information'
                                                                        : 'Personal Information'}
                                                                </>}
                                                                </button>
                                                            </h5>
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h1">
                                                                <div className="accordion-body p-0 pb-3">
                                                                    <div className="one-section">
                                                                        {/* {showFieldList.length != 0 && <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg">
                                                                    <p className="mb-0">{sessionStorage.getItem('AccountTypeID') == 10 ? 'Coordinator Information' : 'Personal Information'}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>} */}
                                                                        {/* {sessionStorage.getItem('AccountTypeID') == 10 && <div className="col-md-12">
                                                            <div className="row">
                                                        <div className="col-sm-3">
                                                            <label className="d-flex mt-3">
                                                                <input type="checkbox" name="fav_language"
                                                                    value={this.state.isCoordinatorAsDelegate} checked={this.state.isCoordinatorAsDelegate}
                                                                    onClick={(e) => this.setState({ isCoordinatorAsDelegate: !this.state.isCoordinatorAsDelegate })}
                                                                />
                                                                is Coordinator Visiting?
                                                            </label>
                                                        </div>
                                                    </div> 
                                                        </div>} */}
                                                                        <div className="col-md-12">
                                                                            <div className="row">
                                                                                {this.showMandatoryFields(2, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        First Name{this.showMandatoryFields(2, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <div className="name-input-group">
                                                                                        {this.showMandatoryFields(1, 0) && (
                                                                                            <select
                                                                                                className="form-control name-prefix"
                                                                                                value={prename}
                                                                                                onChange={(e) => this.setState({
                                                                                                    prename: e.target.value,
                                                                                                    prenameModal: e.target.value,
                                                                                                    isOtherPreName: e.target.value === "Other",
                                                                                                    isOtherPreNameModal: e.target.value === "Other"
                                                                                                })}
                                                                                            >
                                                                                                <option value="Mr">Mr</option>
                                                                                                <option value="Ms">Ms</option>
                                                                                                <option value="DR">DR</option>
                                                                                                <option value="Prof">Prof</option>
                                                                                                <option value="Other">Other</option>
                                                                                            </select>
                                                                                        )}
                                                                                        {isOtherPreName && (
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control name-other"
                                                                                                maxLength={'40'}
                                                                                                value={otherName}
                                                                                                onChange={e => this.setState({ otherName: e.target.value, otherNameModal: e.target.value })}
                                                                                                placeholder={'Prefix'}
                                                                                            />
                                                                                        )}
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control name-no"
                                                                                            maxLength={'50'}
                                                                                            placeholder="Enter first name"
                                                                                            value={firstName}
                                                                                            onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ firstName: e.target.value, firstNameErr: '' })}
                                                                                        />
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block'>{firstNameErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(3, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Last Name{this.showMandatoryFields(3, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={lastName} maxLength={'50'}
                                                                                        onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ lastName: e.target.value, lastNameErr: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block'>{lastNameErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(20, 0) && <div className="col-xl-3 mt-3">
                                                                                    <div className="d-flex">
                                                                                        <label className="w-auto" >

                                                                                            Select Country
                                                                                            {this.showMandatoryFields(20, 2) && <span className="text-red">*</span>}
                                                                                        </label>
                                                                                    </div>
                                                                                    <select className="form-control" value={countryId}
                                                                                        onChange={(e) => this.onCountrySelect(e)}
                                                                                    >
                                                                                        <option value={''}>Select Your Country</option>
                                                                                        {
                                                                                            countryList.length > 0 && countryList.map((data) => (
                                                                                                <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                    {<span className='text-danger text-start text-left d-block  '>{countryIdErr}</span>}
                                                                                </div>}

                                                                                {this.showMandatoryFields(4, 0) && <div className="col-xl-3 mt-3">
                                                                                    <div className="d-flex">
                                                                                        <label className="w-auto" >
                                                                                            Gender
                                                                                            {this.showMandatoryFields(4, 2) && <span className="text-red">*</span>}
                                                                                        </label>
                                                                                    </div>
                                                                                    <select className="form-control" value={gender}
                                                                                        onChange={(e) => e.target.value != '' ? this.setState({ gender: e.target.value, genderErr: '' }) : null}
                                                                                    >
                                                                                        <option value={''}>Select Your Gender</option>
                                                                                        {
                                                                                            genderList.length > 0 && genderList.map((data) => (
                                                                                                <option key={data.GenderID} value={data.GenderID} >{data.Name}</option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                    {<span className='text-danger text-start text-left d-block'>{genderErr}</span>}

                                                                                </div>}
                                                                                {this.showMandatoryFields(5, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Designation{this.showMandatoryFields(5, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={designation} maxLength={'50'}
                                                                                        onChange={(e) => this.setState({ designation: e.target.value, designationErr: "" })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block'>{designationErr}</span>}

                                                                                </div>}
                                                                                {this.showMandatoryFields(6, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Institute/Organisation{this.showMandatoryFields(6, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={institute} maxLength={'500'}
                                                                                        onChange={(e) => this.setState({ institute: e.target.value, instituteErr: "" })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block'>{instituteErr}</span>}

                                                                                </div>}

                                                                                {this.showMandatoryFields(10, 0) && <div className="col-xl-6 mt-3">
                                                                                    <label>
                                                                                        Address 1{this.showMandatoryFields(10, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={Address1} maxLength={'1000'}
                                                                                        onChange={(e) => this.setState({ Address1: e.target.value, Address1Err: "" })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{Address1Err}</span>}

                                                                                </div>}
                                                                                {this.showMandatoryFields(11, 0) && <div className="col-xl-6 mt-3">
                                                                                    <label>
                                                                                        Address 2{this.showMandatoryFields(11, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={Address2} maxLength={'1000'}
                                                                                        onChange={(e) => this.setState({ Address2: e.target.value, Address2Err: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{Address2Err}</span>}
                                                                                    {/* {<span className='text-danger text-start text-left d-block '>{IECCodeErr}</span>} */}

                                                                                </div>}

                                                                                {this.showMandatoryFields(12, 0) && <div className="col-xl-6 mt-3">
                                                                                    <label>
                                                                                        Address 3{this.showMandatoryFields(12, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={Address3} maxLength={'1000'}
                                                                                        onChange={(e) => this.setState({ Address3: e.target.value, Address3Err: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{Address3Err}</span>}

                                                                                    {/* {<span className='text-danger text-start text-left d-block '>{Address1Err}</span>} */}

                                                                                </div>}
                                                                                {this.showMandatoryFields(9, 0) && <div className="col-xl-6 mt-3">
                                                                                    <label>
                                                                                        IEC Code (Importer-Exporter Code){this.showMandatoryFields(9, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={IECCode} maxLength={'50'}
                                                                                        onChange={(e) => this.setState({ IECCode: e.target.value, IECCodeErr: "" })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{IECCodeErr}</span>}

                                                                                </div>}

                                                                                {this.showMandatoryFields(15, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Pincode/Zipcode{this.showMandatoryFields(15, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    {/* {
                                                                countryId == "91" &&
                                                                <input type="text" className="form-control" value={pincode}
                                                                    maxLength={'6'}
                                                                    onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.onPincodeSearch(e) : null}
                                                                />
                                                            }
                                                            {
                                                                countryId != "91" &&
                                                                <input type="text" className="form-control" value={pincode}
                                                                    maxLength={10} onChange={(e) => this.onPincodeSearch(e)}
                                                                    onInput={toInputUppercase}
                                                                />
                                                            } */}
                                                                                    {/* {isDisplayPincodeList && this.renderPincodeList()} */}
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        value={pincode}
                                                                                        maxLength={countryId == "91" ? 6 : 10}
                                                                                        onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.handleSearchChange(e, 2, 0) : null}
                                                                                        onFocus={() => pincode.length > 0 && this.setState({ isOpenDropDownPin: true })}
                                                                                        onBlur={() => setTimeout(() => {
                                                                                            this.setState({ isOpenDropDownPin: false })
                                                                                        }, 500)}
                                                                                        onKeyDown={(e) => this.handleKeyDown(e, 2, 0)}
                                                                                    />

                                                                                    {/* Dropdown options - shown only if there are results */}
                                                                                    {isOpenDropDownPin && tempPincodeList.length > 0 && (
                                                                                        <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                                            {tempPincodeList.map((item, index) => (
                                                                                                <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 2, 0)}
                                                                                                    style={{
                                                                                                        whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                                        backgroundColor: this.state.focusedIndexPin === index ? '#a4c2df' : 'transparent',
                                                                                                    }}
                                                                                                    onMouseEnter={() => this.handleHover(index, 2, 0)}
                                                                                                >
                                                                                                    {item.Pincode}
                                                                                                </Dropdown.Item>
                                                                                            ))}
                                                                                        </Dropdown.Menu>
                                                                                    )}
                                                                                    {<span className='text-danger text-start text-left d-block '>{pincodeErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(14, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        State/Province{countryId == "91" && this.showMandatoryFields(14, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    {/* <input type="text" className="form-control" value={regState} maxLength={'50'}
                                                                onChange={(e) => this.onStateSearch(e)}
                                                            />
                                                            {isDisplayStateList && this.renderStateList()} */}
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        value={regState}
                                                                                        onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 0)}
                                                                                        onFocus={() => regState.length > 0 && this.setState({ isOpenDropDownState: true })}
                                                                                        onBlur={() => setTimeout(() => {
                                                                                            this.setState({ isOpenDropDownState: false })
                                                                                        }, 500)}
                                                                                        onKeyDown={(e) => this.handleKeyDown(e, 0, 0)}
                                                                                    />

                                                                                    {/* Dropdown options - shown only if there are results */}
                                                                                    {isOpenDropDownState && tempStateList.length > 0 && (
                                                                                        <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                                            {tempStateList.map((item, index) => (
                                                                                                <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 0, 0)}
                                                                                                    style={{
                                                                                                        whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                                        backgroundColor: this.state.focusedIndexState === index ? '#a4c2df' : 'transparent',
                                                                                                    }}
                                                                                                    onMouseEnter={() => this.handleHover(index, 0, 0)}
                                                                                                >
                                                                                                    {item.Description}
                                                                                                </Dropdown.Item>
                                                                                            ))}
                                                                                        </Dropdown.Menu>
                                                                                    )}

                                                                                    {<span className='text-danger text-start text-left d-block '>{regStateErr}</span>}
                                                                                </div>}

                                                                                {this.showMandatoryFields(13, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        City{this.showMandatoryFields(13, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    {/* <input type="text" className="form-control" value={city} maxLength={'50'}
                                                                onChange={(e) => this.onCitySearch(e)} />
                                                            {isDisplayCityList && this.renderCityList()} */}
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        value={city}
                                                                                        onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 1, 0)}
                                                                                        onFocus={() => city.length > 0 && this.setState({ isOpenDropDownCity: true })}
                                                                                        onBlur={() => setTimeout(() => {
                                                                                            this.setState({ isOpenDropDownCity: false })
                                                                                        }, 500)}
                                                                                        onKeyDown={(e) => this.handleKeyDown(e, 1, 0)}
                                                                                    />

                                                                                    {/* Dropdown options - shown only if there are results */}
                                                                                    {isOpenDropDownCity && tempCityList.length > 0 && (
                                                                                        <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 1, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                                            {tempCityList.map((item, index) => (
                                                                                                <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 1, 0)}
                                                                                                    style={{
                                                                                                        whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none',
                                                                                                        backgroundColor: this.state.focusedIndexCity === index ? '#a4c2df' : 'transparent',
                                                                                                    }}
                                                                                                    onMouseEnter={() => this.handleHover(index, 1, 0)}
                                                                                                >
                                                                                                    {item.Description}
                                                                                                </Dropdown.Item>
                                                                                            ))}
                                                                                        </Dropdown.Menu>
                                                                                    )}
                                                                                    {<span className='text-danger text-start text-left d-block '>{cityErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(16, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Email{this.showMandatoryFields(16, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={email} maxLength={'50'}
                                                                                        onChange={(e) => this.setState({ email: e.target.value, emailErr: "" })}
                                                                                        onBlur={(e) => this.verifyEmail(e)}
                                                                                        autoComplete="new-password"
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{emailErr}</span>}
                                                                                </div>}

                                                                                {this.showMandatoryFields(17, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Website{this.showMandatoryFields(17, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={website} maxLength={'50'}

                                                                                        onChange={(e) => this.setState({ website: e.target.value, websiteErr: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{websiteErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(21, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Mobile No{this.showMandatoryFields(21, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <div className="phone-input-group">
                                                                                        <input placeholder="ISD"
                                                                                            type="text"
                                                                                            className="form-control phone-code" autoComplete="off" readOnly
                                                                                            maxLength={'4'}
                                                                                            value={preMobNo}
                                                                                        />
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control phone-no"
                                                                                            placeholder="Enter mobile number"
                                                                                            value={mobNo}
                                                                                            maxLength={countryId == 91 ? '10' : '11'}
                                                                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                                                            onPaste={(e) => this.handlePaste(e)}
                                                                                            onWheel={(e) => e.target.blur()}
                                                                                            onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ mobNo: e.target.value, mobNoErr: '' }) : null}
                                                                                        />
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block '>{mobNoErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(22, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Whatsapp Mobile No{this.showMandatoryFields(22, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <div className="phone-input-group">
                                                                                        <input placeholder="ISD"
                                                                                            type="text"
                                                                                            className="form-control phone-code" autoComplete="off" readOnly
                                                                                            maxLength={'4'}
                                                                                            value={preWhatsAppMobNo}
                                                                                        />
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control phone-no"
                                                                                            placeholder="Enter mobile number"
                                                                                            value={whatsAppMobNo}
                                                                                            maxLength={countryId == 91 ? '10' : '11'}
                                                                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                                                            onPaste={(e) => this.handlePaste(e)}
                                                                                            onWheel={(e) => e.target.blur()}
                                                                                            onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ whatsAppMobNo: e.target.value, whatsAppMobNoErr: '' }) : null}
                                                                                        />
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block '>{whatsAppMobNoErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(21, 0) && this.showMandatoryFields(22, 0) && <div className="col-sm-3 d-flex align-items-center" style={{ paddingTop: '38px' }}>
                                                                                    <label className="d-flex align-items-center mb-0" style={{ gap: '8px', cursor: 'pointer' }}>
                                                                                        <input type="checkbox" name="fav_language"
                                                                                            value={isSameAsMobNo} checked={isSameAsMobNo}
                                                                                            onClick={(e) => this.onSameAsMobNoClick(e)}
                                                                                            style={{ width: 16, height: 16, marginTop: 0 }}
                                                                                        />
                                                                                        <span>Same As Mobile No</span>
                                                                                    </label>
                                                                                </div>}

                                                                                {!isLinkOpen && this.showMandatoryFields(37, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Source
                                                                                        {/* {this.showMandatoryFields(12, 2) && <span className="text-red">*</span>} */}
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={Source} maxLength={'1000'}
                                                                                        onChange={(e) => this.setState({ Source: e.target.value, })}
                                                                                    />
                                                                                    {/* {<span className='text-danger text-start text-left d-block '>{Address3ErrModal}</span>} */}
                                                                                    {/* {<span className='text-danger text-start text-left d-block '>{Address1Err}</span>} */}

                                                                                </div>}

                                                                                {this.showMandatoryFields(18, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Telephone No{this.showMandatoryFields(18, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <div className="phone-input-group">
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control phone-code" autoComplete="off"
                                                                                            maxLength={'4'}
                                                                                            value={preTelNo}
                                                                                            placeholder="STD"
                                                                                            onChange={(e) => this.setState({ preTelNo: e.target.value })}
                                                                                        />
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control phone-no"
                                                                                            placeholder="Enter telephone number"
                                                                                            value={telNo}
                                                                                            maxLength={countryId == 91 ? '10' : '11'}
                                                                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                                                            onPaste={(e) => this.preventMinus(e)}
                                                                                            onWheel={(e) => e.target.blur()}
                                                                                            onChange={(e) => e.target.value >= 0 && this.setState({ telNo: e.target.value, telephoneErr: '' })}
                                                                                        />
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block '>{telephoneErr}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(19, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        Telephone No 1{this.showMandatoryFields(19, 2) && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <div className="phone-input-group">
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control phone-code" autoComplete="off"
                                                                                            maxLength={'4'}
                                                                                            value={preTel1No}
                                                                                            placeholder="STD"
                                                                                            onChange={(e) => this.setState({ preTel1No: e.target.value })}
                                                                                        />
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control phone-no"
                                                                                            placeholder="Enter telephone number"
                                                                                            value={tel1No}
                                                                                            maxLength={countryId == 91 ? '10' : '11'}
                                                                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                                                            onPaste={(e) => this.handlePaste(e)}
                                                                                            onWheel={(e) => e.target.blur()}
                                                                                            onChange={(e) => e.target.value >= 0 && this.setState({ tel1No: e.target.value, telephone1Err: '' })}
                                                                                        />
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block '>{telephone1Err}</span>}
                                                                                </div>}
                                                                                {this.showMandatoryFields(7, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        GST No{this.showMandatoryFields(7, 2) && countryId == 91 && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input
                                                                                        type="text"
                                                                                        maxLength={15}
                                                                                        className="form-control"
                                                                                        value={compInfoGstNo}
                                                                                        onChange={(e) =>
                                                                                            this.onGSTchange(e.target.value)
                                                                                        }
                                                                                        onInput={toInputUppercase}
                                                                                    />
                                                                                    {countryId == "91" && (
                                                                                        <span className="text-danger text-start text-left d-block ">
                                                                                            {compInfoGstNoErr}
                                                                                        </span>
                                                                                    )}
                                                                                </div>}
                                                                                {this.showMandatoryFields(8, 0) && <div className="col-xl-3 mt-3">
                                                                                    <label>
                                                                                        PAN No{this.showMandatoryFields(8, 2) && countryId == 91 && <span className="text-red">*</span>}
                                                                                    </label>
                                                                                    <input
                                                                                        type="text"
                                                                                        maxLength={10}
                                                                                        className="form-control"
                                                                                        value={compInfoPanNo}
                                                                                        onChange={(e) =>
                                                                                            this.setState({
                                                                                                compInfoPanNo: e.target.value,
                                                                                                compInfoPanNoErr: "",
                                                                                            })
                                                                                        }
                                                                                        onInput={toInputUppercase}
                                                                                    />
                                                                                    {countryId == "91" && (
                                                                                        <span className="text-danger text-start text-left d-block ">
                                                                                            {compInfoPanNoErr}
                                                                                        </span>
                                                                                    )}
                                                                                </div>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>)}


                                            {(this.showMandatoryFields(23, 0) || this.showMandatoryFields(24, 0) || this.showMandatoryFields(25, 0) || this.showMandatoryFields(26, 0)) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h7"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h7"
                                                            >
                                                                Company Profile
                                                            </button>
                                                        </h5>
                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.companyProfileErr}</span>} */}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h7">
                                                            <div className="accordion-body p-0 pb-3">
                                                                <div className="one-section">
                                                                    {/* <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="containerfluid">
                                                            <div className="row mt-2">
                                                              
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Company Profile<span className="text-red">*</span>
                                                                    </p>
                                                                   {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.turnOverErr}</span>} 
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div> */}
                                                                    {this.showMandatoryFields(23, 0) && <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-xl-12 mb-1">
                                                                                <label className="mt-3">Company Profile{this.showMandatoryFields(23, 2) && <span className="text-red">*</span>}</label>
                                                                                <textarea type="text" className="form-control" value={companyProfile}
                                                                                    maxLength={'500'}
                                                                                    onChange={(e) => this.setState({ companyProfile: e.target.value, companyProfileErr: '' })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block '>{companyProfileErr}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>}


                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            <div className="col-xl-12 mb-1">
                                                                                <label className="mt-3">{delegateUUID ? <>Delegate's Photo</> : <>Person's Photo</>}{this.showMandatoryFields(23, 2) && <span className="text-red">*</span>}</label>

                                                                                {(PersonPhoto ? PersonPhoto : PersonPhotoPreview) ? (
                                                                                    <div style={{ position: "relative", display: "inline-block" }}>
                                                                                        <img
                                                                                            src={
                                                                                                (PersonPhoto?.includes("base64,") ||
                                                                                                    PersonPhotoPreview?.includes("base64,"))
                                                                                                    ? (PersonPhoto || PersonPhotoPreview)
                                                                                                    : BASE_URL?.split('/api')[0] +
                                                                                                    (PersonPhoto || PersonPhotoPreview)
                                                                                            }
                                                                                            alt="Preview"
                                                                                            style={{ width: "250px", height: "250px", objectFit: "contain" }}
                                                                                        />
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={this.clearFileInput}
                                                                                            style={{
                                                                                                position: "absolute",
                                                                                                top: "-8px",
                                                                                                right: "-8px",
                                                                                                background: "#dc3545",
                                                                                                color: "#fff",
                                                                                                border: "none",
                                                                                                borderRadius: "50%",
                                                                                                width: "26px",
                                                                                                height: "26px",
                                                                                                padding: 0,
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                justifyContent: "center",
                                                                                                lineHeight: 1,
                                                                                                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)",
                                                                                                cursor: "pointer",
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                            title="Remove"
                                                                                        >
                                                                                            <i className="fa fa-times"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (<>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept="image/jpeg, image/png, image/jpg"
                                                                                        className="form-control"
                                                                                        placeholder="Upload Logo"
                                                                                        onChange={this.handleImageUpload}
                                                                                        ref={(ref) => (this.fileInputRef = ref)}
                                                                                    />
                                                                                    {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{PersonPhotoErr}</span>}
                                                                                </>
                                                                                )}
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {/* {this.showMandatoryFields(24, 0) &&
                                                                                <div className="col-xl-4 mb-1">
                                                                                    <label className="mt-3">Company Website{this.showMandatoryFields(24, 2) && <span className="text-red">*</span>}</label>
                                                                                    <input type="text" className="form-control" value={companywebsite}
                                                                                        maxLength={'50'}
                                                                                        onChange={(e) => this.setState({ companywebsite: e.target.value, companyWebsiteErr: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{companyWebsiteErr}</span>}
                                                                                </div>} */}
                                                                            {this.showMandatoryFields(25, 0) && <div className="col-xl-3 mb-1">
                                                                                <label className="mt-3">Total Years the Company Is Operational{this.showMandatoryFields(25, 2) && <span className="text-red">*</span>}</label>
                                                                                <input type="text" className="form-control" value={totalYears}
                                                                                    maxLength={'50'}
                                                                                    onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ totalYears: e.target.value, totalYearsErr: '' }) : null}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block '>{totalYearsErr}</span>}

                                                                            </div>}
                                                                            <div className="col-xl-9 mb-1">
                                                                                <label className="mt-3">{delegateUUID ? <>Delegate's Profile</> : <>Person's Profile</>}{this.showMandatoryFields(23, 2) && <span className="text-red">*</span>}</label>
                                                                                <textarea type="text" className="form-control" value={PersonProfile} maxLength={'500'}
                                                                                    onChange={(e) => this.setState({ PersonProfile: e.target.value, PersonProfileErr: '' })}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block '>{PersonProfileErr}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                            {this.showMandatoryFields(26, 0) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h8"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h8"
                                                            >
                                                                Company Turn Over (in USD){this.showMandatoryFields(26, 2) && <span className="text-red">*</span>}
                                                            </button>
                                                        </h5>
                                                        {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{this.state.turnOverErr}</span>}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h8">
                                                            <div className="accordion-body p-0">
                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        {/* <div className="containerfluid">
                                                            <div className="row mt-2">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Company Turn Over (in USD){this.showMandatoryFields(26, 2) && <span className="text-red">*</span>}</p>
                                                                    {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{this.state.turnOverErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                                        <div className="col-12 mb-1">
                                                                            <div className="row mt-2">
                                                                                {
                                                                                    this.state.turnOverList.length > 0 && this.state.turnOverList.map((data) => (
                                                                                        <div className="col-12 col-sm-auto pe-sm-5" key={data.CompanyTurnOverID}>
                                                                                            <label className="d-flex">
                                                                                                <input type="radio" name="turnOver" value={data.CompanyTurnOverID}
                                                                                                    checked={data.CompanyTurnOverID == this.state.turnOverId}
                                                                                                    onChange={() => this.setState({ turnOverId: data.CompanyTurnOverID, turnOverErr: '' })}
                                                                                                />
                                                                                                {data.Description}
                                                                                            </label>
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                            {/* {(this.showMandatoryFields(27, 0) || this.showMandatoryFields(28, 0)) &&
                                                <div className="accordion" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button" data-bs-toggle="collapse" data-bs-target="#collapse_l1_h11"
                                                                aria-expanded="true" aria-controls="collapse_l1_h11">Arrival and Departure<span className="text-red">*</span>
                                                            </button>
                                                        </h5>
                                                        {<span className='text-danger/ text-start text-left d-block mt-1 ml-2'>{this.state.SeminarErrModal}</span>}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h11">
                                                            <div className="accordion-body">
                                                                < div className="one-section">
                                                                    <div className="col-md-12">
                                                                        <div className="row">
                                                                            {this.showMandatoryFields(27, 0) && <div className="col-sm-3">
                                                                                <label>Arrival Date{this.showMandatoryFields(27, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                                                <DatePicker
                                                                                    style={{ zIndex: '99999' }}
                                                                                    selected={arrivalDate}
                                                                                    dateFormat={"dd/MM/yyyy"}
                                                                                    className="form-control"
                                                                                    onChange={(date) => this.setState({ arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), arrivalDateErr: '' })}
                                                                                    peekNextMonth
                                                                                    minDate={new Date()}
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    placeholderText="Arrival Date"
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block '>{arrivalDateErr}</span>}
                                                                            </div>}
                                                                            {this.showMandatoryFields(28, 0) && <div className="col-sm-3">
                                                                                <label >Departure Date{this.showMandatoryFields(28, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                                                <DatePicker
                                                                                    style={{ zIndex: '99999' }}
                                                                                    selected={departureDate}
                                                                                    dateFormat={"dd/MM/yyyy"}
                                                                                    className="form-control"
                                                                                    onChange={(date) => this.setState({ departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), departureDateErr: '' })}
                                                                                    peekNextMonth
                                                                                    minDate={new Date()}
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    placeholderText="Departure Date"
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block '>{departureDateErr}</span>}
                                                                            </div>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>} */}

                                            {sessionStorage.getItem('AccountTypeID') == 10 && this.showMandatoryFields(30, 0) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h2"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h2"
                                                            >
                                                                Industry Segment
                                                                {/* {this.showMandatoryFields(30, 2) && <span className="text-red">*</span>} */}
                                                            </button>
                                                        </h5>
                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.chapterErr}</span>} */}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h2">
                                                            <div className="accordion-body p-0">
                                                                <div className="one-section">
                                                                    {/* <div className="containerfluid">
                                                                        <div className="row">
                                                                            <div className="col-md-12">
                                                                                <div className="p-1 title-bg d-flex">
                                                                                    <p className="mb-0">Industry Segment{this.showMandatoryFields(30, 2) && <span className="text-red">*</span>}
                                                                                    </p>
                                                                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.chapterErr}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                    <div className="">
                                                                        <div className="row ">
                                                                            <div className="asc">
                                                                                <div className="" >
                                                                                    <form className="needs-validation" noValidate="">
                                                                                        <div className="form-row mt-2">
                                                                                            {console.log(chapterList, 'hittttt')}
                                                                                            {chapterList.length > 0 && chapterList.map((data) => (
                                                                                                <div className="col-12 col-sm-6 col-lg-3 mb-2">
                                                                                                    <section className="" key={data.IndustrySegmentID}>
                                                                                                        <h2 className="handle-no-icon m-0" style={{ fontSize: '13px' }}>
                                                                                                            <label style={{ color: '#212529' }}>
                                                                                                                <input type="checkbox"
                                                                                                                    select={data.isSelect} checked={data.isSelect}
                                                                                                                    value={data.IndustrySegmentID}
                                                                                                                    onChange={(e) => this.onSelectPrimaryChapter(e)} />
                                                                                                                {data['Industrial Segment']}
                                                                                                            </label>
                                                                                                        </h2>
                                                                                                        {data.IndustrySegmentID == 16 && this.state.isOtherOpen && <input type="text" className="form-control" value={this.state.other}
                                                                                                            onChange={(e) =>
                                                                                                                this.setState({ other: e.target.value, })}
                                                                                                        />}
                                                                                                    </section>
                                                                                                </div>
                                                                                            ))
                                                                                            }
                                                                                        </div>
                                                                                    </form>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {sessionStorage.getItem('AccountTypeID') == 10 && this.showMandatoryFields(31, 0) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h3"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h3"
                                                            >
                                                                Purpose of Visit{this.showMandatoryFields(31, 2) && <span className="text-red">*</span>}
                                                            </button>
                                                        </h5>
                                                        {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{visitPurposeErr}</span>}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h3">
                                                            <div className="accordion-body p-0">
                                                                <div className="one-section mt-2">
                                                                    {/* <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{visitPurposeErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                    <div className="col-xl-12 mb-1">
                                                                        <div className="row">
                                                                            {
                                                                                visitPurposeList.length > 0 && visitPurposeList.map((data) => (
                                                                                    <div className="col-12 col-sm-6 col-lg-3 mb-2" key={data.PurposeofVisitID}>
                                                                                        <label className="d-flex">
                                                                                            <input type="checkbox" name="fav_language"
                                                                                                select={data.isSelect} checked={data.isSelect}
                                                                                                value={data.PurposeofVisitID}
                                                                                                onChange={(e) => this.onSelectPurpose(e)}
                                                                                            />
                                                                                            {data.PurposeofVisitName}
                                                                                        </label>
                                                                                        {
                                                                                            data.PurposeofVisitID == 10 && data.isSelect &&
                                                                                            <input
                                                                                                className="form-control"
                                                                                                maxLength={'100'}
                                                                                                value={data.otherDetail}
                                                                                                onChange={(e) => this.otherDetailChange(e)}
                                                                                            >
                                                                                            </input>
                                                                                        }
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {sessionStorage.getItem('AccountTypeID') == 10 && this.showMandatoryFields(32, 0) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h4"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h4"
                                                            >
                                                                Products
                                                                {/* {this.showMandatoryFields(32, 2) && <span className="text-red">*</span>} */}
                                                            </button>
                                                        </h5>
                                                        {/* {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{ChapterHallErr}</span>} */}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h4">
                                                            <div className="accordion-body p-0 pb-3">
                                                                <div className="one-section">
                                                                    {/* <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Products{this.showMandatoryFields(32, 2) && <span className="text-red">*</span>}
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{ChapterHallErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                                    <div className="col-xl-12 mb-4">
                                                                        <div className="row mt-4">
                                                                            <div class="accordion" id="accordionExample">
                                                                                {
                                                                                    level2.length > 0 && level2.map(level2Data => (
                                                                                        <>
                                                                                            {
                                                                                                <div class="accordion-item">
                                                                                                    <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                                        <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                                            type="button" data-bs-toggle="collapse"
                                                                                                            data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                                            aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                                            {/* // checkbox for level2 */}
                                                                                                            {
                                                                                                                level2Data.IsCheckbox &&
                                                                                                                <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                                                    checked={level2Data.isSelect}
                                                                                                                    onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                                            }
                                                                                                            {formatChapterName(level2Data.ChapterName)} </button>
                                                                                                    </h2>
                                                                                                    {this.recordTwo(level2Data, level3, level4)}
                                                                                                </div>
                                                                                            }

                                                                                        </>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="" style={{ marginLeft: "10px" }}>
                                                                        <p className="mb-0" style={{ fontSize: 15 }}>
                                                                            <strong>  Selected Products</strong>
                                                                        </p>
                                                                    </div>
                                                                    <div style={{ padding: "0px 0px 0px 10px" }}>
                                                                        {
                                                                            filerArray.length > 0 ? <ul className="selected-products-list">{filerArray.map((data) => (
                                                                                <li>
                                                                                    {formatChapterName(data.ChapterName)}
                                                                                </li>
                                                                            ))}</ul> :
                                                                                <p>
                                                                                    {"No Results"}
                                                                                </p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {sessionStorage.getItem('AccountTypeID') == 10 && <>
                                                {/* {this.showMandatoryFields(33, 0) && <>
                                                    <div className="accordion" id="accordionExample">
                                                        <div className="accordion-item mb-2">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button
                                                                    className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h5"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h5"
                                                                >
                                                                    B2B meetings{isInterestTwo && this.showMandatoryFields(33, 2) && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.b2bErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h5">
                                                                <div className="accordion-body">
                                                                    <div className="one-section">
                                                                        <div className="containerfluid">
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            <div className="row">
                                                                                <div className="col-sm-12 mt-2 mb-2" >
                                                                                    <label className="d-flex">
                                                                                        <input type="checkbox" name="fav_language"
                                                                                            select={isInterestTwo} checked={isInterestTwo}
                                                                                            onChange={(e) => this.onSelectInterest(e)}
                                                                                        />
                                                                                        Select your B2B meeting schedule
                                                                                    </label>
                                                                                    {isInterestTwo &&
                                                                                        <>
                                                                                            {console.log(B2bMeetingList, 'B2bMeetingList', seminarInterestList)}
                                                                                            <div className="col-md-12">
                                                                                                <div className="table-responsive" >
                                                                                                    <table className="table border table-bordered mb-0 mt-1" >
                                                                                                        <thead>
                                                                                                            <tr>
                                                                                                                <th className="text-center" style={{ width: '150px' }}>Date</th>
                                                                                                                <th className="text-center" style={{ width: '200px' }}>Location</th>
                                                                                                                <th className="text-center">TimeSlots</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            {
                                                                                                                B2bMeetingList.length > 0 && B2bMeetingList.map((data) => (
                                                                                                                    <tr key={Math.random()}>
                                                                                                                        {data.rowSpan != 0 ? <td rowSpan={data.rowSpan} className="text-center" >
                                                                                                                            {moment(data.B2BDate).format('DD MMM YYYY')}
                                                                                                                            <br />
                                                                                                                            <small>{moment(data.B2BDate).format('dddd')}</small>
                                                                                                                        </td> : <></>}
                                                                                                                        <td className="text-center" >{data.B2BLocation}</td>
                                                                                                                        <td>
                                                                                                                            <div className="d-flex flex-wrap gap-2 m-2">
                                                                                                                                {data.timeSlotList.length > 0 && data.timeSlotList.map((item) => (

                                                                                                                                    <div>
                                                                                                                                        <ToggleButton
                                                                                                                                            style={{ whiteSpace: 'nowrap' }}
                                                                                                                                            className={`p-2 rounded-5 ${item.IsBooked && 'text-white'} no-hover-toggle `}
                                                                                                                                            id={item.B2BTimeSlotID}
                                                                                                                                            type="checkbox"
                                                                                                                                            variant={!item.IsBooked ? "outline-primary" : "outline-secondary"}
                                                                                                                                            disabled={item.IsBooked}
                                                                                                                                            checked={item.isSelect || item.IsBooked}
                                                                                                                                            value={item.B2BTimeSlotID}
                                                                                                                                            onClick={() => this.onSelect(item.B2BTimeSlotID)}
                                                                                                                                        >
                                                                                                                                            {item.timeslot}
                                                                                                                                        </ToggleButton>
                                                                                                                                    </div>
                                                                                                                                ))}
                                                                                                                            </div>
                                                                                                                        </td>
                                                                                                                    </tr>
                                                                                                                ))
                                                                                                            }
                                                                                                        </tbody>
                                                                                                    </table>

                                                                                                    <div />
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>} */}
                                                {(!isInterestTwo && this.showMandatoryFields(34, 0) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 0))) &&
                                                    <div className="accordion m-2" id="accordionExample">
                                                        <div className="accordion-item mb-2">
                                                            <h5 className="accordion-header delegate-section-title">
                                                                <button
                                                                    className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapse_l1_h6"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapse_l1_h6"
                                                                >
                                                                    Date of Visit Single Day Pass / All Day Pass{" "}{((!isInterestTwo && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2))) && <span className="text-red">*</span>}
                                                                </button>
                                                            </h5>
                                                            {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{daysErr}</span>}
                                                            <div className="accordion-collapse collapse show" id="collapse_l1_h6">
                                                                <div className="accordion-body p-0">
                                                                    <div className="one-section">
                                                                        <div className="col-12 mb-1">
                                                                            <div className="row mt-2" >
                                                                                {
                                                                                    daysList.length > 0 && daysList.map((data) => (
                                                                                        <div className="col-6 col-sm-4 col-lg-2" key={data.Code}>
                                                                                            <label className="d-flex">
                                                                                                <input type="checkbox" select={data.isSelect}
                                                                                                    checked={data.isSelect} value={data.Code}
                                                                                                    onChange={(e) => this.onSelectDates(e)}
                                                                                                />
                                                                                                {data.VisitDate}
                                                                                            </label>
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }</>
                                            }
                                            {!(parseInt(this.state.countryId) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) &&
                                                sessionStorage.getItem('AccountTypeID') == 10 && this.showMandatoryFields(35, 0) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h9"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h9"
                                                            >
                                                                Visa Application {needVisaAssistance && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                                            </button>
                                                        </h5>
                                                        {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.visaErr}</span>}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h9">
                                                            <div className="accordion-body">
                                                                <div className="one-section">
                                                                    {/* <div className="containerfluid">
                                                        <div className="row mt-2">
                                                            <div className="col-md-12">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Visa Application
                                                                        {needVisaAssistance && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                                                        {!isExhibitionFree && <span
                                                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                                                    className="mb-0 text-danger"
                                                                                    onClick={() => this.setState({ isOpen4: true })}>
                                                                                    Visit days Charges
                                                                                </span>}
                                                                    </p>
                                                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.visaErr}</span>}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div> */}

                                                                    <div className="col-sm-12 ">
                                                                        {/* Plain wrapper (a .row here pulled the label 12px left of the title) */}
                                                                        <div className="mt-2">
                                                                            <label className="d-flex">
                                                                                <input type="checkbox" name="fav_language"
                                                                                    select={needVisaAssistance} checked={needVisaAssistance}
                                                                                    onChange={() => this.setState({
                                                                                        needVisaAssistance: !needVisaAssistance,
                                                                                        applicantMobNo: applicantMobNo != '' && applicantMobNo != null ? applicantMobNo : this.state.mobNo,
                                                                                        applicantEmail: applicantEmail != '' && applicantEmail != null ? applicantEmail : this.state.email,
                                                                                        preApplicantMobNo: preApplicantMobNo != '' && preApplicantMobNo != null ? preApplicantMobNo : this.state.preMobNo,
                                                                                        visaErr: ''
                                                                                    })}
                                                                                />
                                                                                Do you need Visa Invitation Letter?
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        needVisaAssistance &&
                                                                        <div
                                                                            className="col-md-12 mb-2"
                                                                            id="divMsg"
                                                                        >
                                                                            <div className="row">
                                                                                <div className="col-xl-3">
                                                                                    <label className="mt-3">
                                                                                        Name as per Passport<span className="text-red">*</span>
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={passName} maxLength={'50'}
                                                                                        onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ passName: e.target.value, passNameErr: '' })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{passNameErr}</span>}
                                                                                </div>
                                                                                <div className="col-xl-3">
                                                                                    <label className="mt-3">
                                                                                        Applicant mobile number<span className="text-red">*</span>
                                                                                    </label>

                                                                                    <div className="phone-input-group">
                                                                                        <input placeholder="ISD"
                                                                                            type="text"
                                                                                            className="form-control phone-code" autoComplete="off" readOnly
                                                                                            maxLength={'4'}
                                                                                            value={preApplicantMobNo}
                                                                                        />
                                                                                        <input type="text" className="form-control phone-no" value={applicantMobNo}
                                                                                            maxLength={countryId == 91 ? '10' : '11'}
                                                                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                                            onPaste={(e) => this.handlePaste(e)}
                                                                                            onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                                            onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ applicantMobNo: e.target.value, applicantMobNoErr: '' }) : null}
                                                                                        />
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block '>{applicantMobNoErr}</span>}
                                                                                </div>
                                                                                <div className="col-xl-3">
                                                                                    <label className="mt-3">
                                                                                        Applicant email id<span className="text-red">*</span>
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={applicantEmail} maxLength={'50'}
                                                                                        onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                                                        onBlur={(e) => this.verifyEmail(e, 2)}
                                                                                    />

                                                                                    {<span className='text-danger text-start text-left d-block '>{applicantEmailErr}</span>}
                                                                                </div>
                                                                                <div className="col-xl-3">
                                                                                    <label className="mt-3">Passport No
                                                                                        <span className="text-red">*</span>
                                                                                    </label>
                                                                                    <input type="text" className="form-control" value={passNo} maxLength={'10'}
                                                                                        onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                                                    />
                                                                                    {<span className='text-danger text-start text-left d-block '>{passNoErr}</span>}
                                                                                </div>
                                                                                <div className="col-xl-3">
                                                                                    <label className="mt-3">Passport issue Date
                                                                                        <span className="text-red">*</span>
                                                                                    </label>
                                                                                    <DatePicker selected={passDate}
                                                                                        onChange={(date) =>
                                                                                            this.setState({
                                                                                                passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                passDateErr: ""
                                                                                            })}
                                                                                        dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                        peekNextMonth
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        maxDate={passExipryDate}
                                                                                        dropdownMode="select"
                                                                                        placeholderText="Passport Issued Date"
                                                                                        dayClassName={() => "example-datepicker-day-class"}
                                                                                        popperClassName="example-datepicker-class" />
                                                                                    {<span className='text-danger text-start text-left d-block '>{passDateErr}</span>}
                                                                                </div>
                                                                                <div className="col-xl-3">
                                                                                    <label className="mt-3">Passport Expiry Date
                                                                                        <span className="text-red">*</span>
                                                                                    </label>
                                                                                    <DatePicker selected={passExipryDate}
                                                                                        onChange={(date) =>
                                                                                            this.setState({
                                                                                                passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                                                passExipryDateErr: ""
                                                                                            })}
                                                                                        dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                                        peekNextMonth
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        minDate={passDate}
                                                                                        dropdownMode="select"
                                                                                        placeholderText="Passport Expiry Date"
                                                                                        dayClassName={() => "example-datepicker-day-class"}
                                                                                        popperClassName="example-datepicker-class" />
                                                                                    {<span className='text-danger text-start text-left d-block '>{passExipryDateErr}</span>}
                                                                                </div>
                                                                                <div className="col-xl-3">
                                                                                    <div className="d-flex">
                                                                                        <label className="mt-3 w-auto" >
                                                                                            Passport issuing Country
                                                                                            <span className="text-red">*</span>

                                                                                        </label>
                                                                                    </div>
                                                                                    <select className="form-control" value={passCountry}
                                                                                        onChange={(e) => this.onCountrySelect(e, 2)}
                                                                                    >
                                                                                        <option>Select Your Country</option>
                                                                                        {
                                                                                            countryList.length > 0 && countryList.map((data) => (
                                                                                                <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                    {<span className='text-danger text-start text-left d-block '>{passCountryErr}</span>}

                                                                                </div>
                                                                                {/* <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={passCountry}
                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                        />
                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                        {<span className='text-danger text-start text-left d-block '>{ }</span>}
                                                    </div> */}
                                                                                {!(isPassportFilePresent) && !isVisaApplied &&
                                                                                    < div className="col-xl-12">
                                                                                        <label className="mt-3">
                                                                                            Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                                            <span className="text-red">*</span>
                                                                                            {<span className='text-danger text-start text-left   ms-4' style={{ marginTop: '2px' }}>{passportFileErr}</span>}
                                                                                        </label>
                                                                                        <form action="/action_page.php" style={{ position: 'relative', textAlign: 'left' }}>
                                                                                            <input type="file" id="passportFile" name="filename"
                                                                                                accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                                                onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                                            />
                                                                                            {
                                                                                                passportFile != "" &&
                                                                                                <i class="fa fa-times text-danger img-can" style={{ marginTop: '2px' }} onClick={() => this.onCrossClick(1)}></i>
                                                                                            }
                                                                                        </form>
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    isVisaApplied && passportFile != "" && passportFile != null &&
                                                                                    <div className="col-xl-12">
                                                                                        <label className="mt-3">
                                                                                            Passport Front Page File
                                                                                            <span className="text-red">*</span>
                                                                                        </label>
                                                                                        <div style={{
                                                                                            border: '1px solid #ccc',
                                                                                            padding: '10px',
                                                                                            alignItems: 'center',
                                                                                            marginTop: '10px',
                                                                                            maxWidth: '300px'
                                                                                        }}>
                                                                                            <span style={{ marginRight: '10px' }}
                                                                                            >{passPortFileName}</span>
                                                                                            <i className="fa fa-times text-danger img-can" style={{ marginTop: '2px' }} onClick={() => this.onCrossClick(1, 1)}></i>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {sessionStorage.getItem('AccountTypeID') == 10 && this.showMandatoryFields(36, 0) &&
                                                <div className="accordion m-2" id="accordionExample">
                                                    <div className="accordion-item mb-2">
                                                        <h5 className="accordion-header delegate-section-title">
                                                            <button
                                                                className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#collapse_l1_h10"
                                                                aria-expanded="true"
                                                                aria-controls="collapse_l1_h10"
                                                            >
                                                                Seminar {this.showMandatoryFields(36, 2) && <span className="text-red">*</span>}
                                                            </button>
                                                        </h5>
                                                        {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.SeminarErr}</span>}
                                                        <div className="accordion-collapse collapse show" id="collapse_l1_h10">
                                                            <div className="accordion-body p-0 pb-3">
                                                                <div className="one-section">
                                                                    {/* <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="containerfluid">
                                                                <div className="row mt-2">
                                                                   
                                                                    <div className="p-1 title-bg d-flex">
                                                                        <p className="mb-0">
                                                                            Seminar
                                                                            {this.showMandatoryFields(36, 2) && <span className="text-red">*</span>}
                                                                        </p>
                                                                        {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.SeminarErr}</span>}
                                                                       
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div> */}
                                                                    <div className="col-md-12">
                                                                        <div className="table-responsive" >
                                                                            <table className="table border table-bordered mb-0 mt-1" >
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                                                        <th style={{ width: '200px' }} className="text-center">Register</th>
                                                                                        <th style={{ width: '350px' }}>Date & Time</th>
                                                                                        <th >Session Name</th>
                                                                                        {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                                                        {/* <th style={{ width: '250px' }} className="text-center">Info</th> */}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        seminarInterestList.length > 0 && seminarInterestList.map((data) => (
                                                                                            <>
                                                                                                {/* {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                                            <td style={{ borderRight: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                        </tr>} */}
                                                                                                {data.IsDelegate && <tr key={Math.random()}>
                                                                                                    {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                                                        <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                                                        : <></>}
                                                                                                    <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                                                        {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                                                            (data.SeminarTypeID == 2 ?
                                                                                                                <a
                                                                                                                    style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                                                    className="btn btn-aqua me-2"
                                                                                                                    // type="submit"
                                                                                                                    onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                >
                                                                                                                    {data.isSelect ? "Withdraw Request" : "Request for Invite"}
                                                                                                                </a>
                                                                                                                : data.SeminarTypeID == 3 ?

                                                                                                                    <input
                                                                                                                        // style={{ marginTop: '12px' }}
                                                                                                                        type="checkbox"
                                                                                                                        checked={data.isSelect}
                                                                                                                        onChange={(e) =>
                                                                                                                            this.setState({
                                                                                                                                ChargesPop: !data.isSelect ? true : false,
                                                                                                                                seminarCharges: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR - data.INRSGST - data.INRCGST) : (data.PriceINR - data.INRIGST) : data.PriceINR : data.IsGSTIncluded == 1 ? (data.PriceUSD - data.USDIGST) : data.PriceUSD,
                                                                                                                                seminarCGST: sessionStorage.getItem("countryId") == 91 ? data.INRCGST : 0,
                                                                                                                                seminarSGST: sessionStorage.getItem("countryId") == 91 ? data.INRSGST : 0,
                                                                                                                                seminarIGST: sessionStorage.getItem("countryId") == 91 ? data.INRIGST : data.USDIGST,
                                                                                                                                TotalPayable: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.PriceINR : data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR + data.INRSGST + data.INRCGST) : (data.PriceINR + data.INRIGST) : data.IsGSTIncluded == 1 ? data.PriceUSD : (data.PriceUSD + data.USDIGST),
                                                                                                                            }, () => {
                                                                                                                                this.onCheckedSeminar(e, data.SeminarID)
                                                                                                                            })
                                                                                                                        }
                                                                                                                    />
                                                                                                                    :
                                                                                                                    <input type="checkbox"
                                                                                                                        value={data.isSelect}
                                                                                                                        checked={data.isSelect}
                                                                                                                        onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                                                    />)
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.DateTime}</td>
                                                                                                    <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.SessionName}{data.SeminarDetailsHtmlRef ? <>&nbsp;<span style={{ cursor: 'pointer' }} className="text-primary" onClick={() => {
                                                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                    }}>Click Here</span> to view more details.</> : ''}</td>
                                                                                                    {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                                                    {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                                                    {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                                                    {/* <td className="text-center">
                                                                                                                {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                                                    <span onClick={() => {
                                                                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                    }}>
                                                                                                                        <i class="bi bi-info-circle"></i>
                                                                                                                    </span> : <></>}
                                                                                                            </td> */}

                                                                                                </tr>}
                                                                                            </>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </table>

                                                                            <div />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                        </div>
                                        {/* Program Selection Table */}
                                        {!isLinkOpen && sessionStorage.getItem('AccountTypeID') != 10 && sessionStorage.getItem('AccountTypeID') != null && (
                                            <div className="mt-4 m-2">
                                                <h6 className="mb-1 mt-2 fw-semibold mb-3"><i className="fa fa-list-alt me-2"></i>Program</h6>
                                                <div className="table-responsive border rounded bg-white shadow-sm">
                                                    <table className="table table-bordered table-hover align-middle mb-0">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="text-center" style={{ width: '50px' }}>
                                                                    <input type="checkbox" className=" mt-0"
                                                                        onClick={() => this.selectAllProgram()}
                                                                        checked={this.checkselectallprogram()}
                                                                    // onChange={() => {
                                                                    //     if (this.checkselectallprogram()) {
                                                                    //         for (var i = 0; i < programList.length; i++) {
                                                                    //             programList[i].isSelect = false
                                                                    //             for (var j = 0; j < programList[i].catogary.length; j++) {
                                                                    //                 programList[i].catogary[j].isSelect = false
                                                                    //             }
                                                                    //         }
                                                                    //         this.setState({ programList: programList })
                                                                    //     } else {
                                                                    //         if (this.checkselectallprogram()) {
                                                                    //             for (var i = 0; i < programList.length; i++) {
                                                                    //                 programList[i].isSelect = true
                                                                    //                 for (var j = 0; j < programList[i].catogary.length; j++) {
                                                                    //                     programList[i].catogary[j].isSelect = true
                                                                    //                 }
                                                                    //             }
                                                                    //             this.setState({ programList: programList })
                                                                    //         }
                                                                    //     }
                                                                    // }}
                                                                    // onChange={(e) => {
                                                                    //     const checked = e.target.checked;
                                                                    //     const newState = {
                                                                    //         master_all: checked,
                                                                    //         p1_all: checked,
                                                                    //         p2_all: checked, p2_0: checked, p2_1: checked, p2_2: checked,
                                                                    //         p3_all: checked
                                                                    //     };
                                                                    //     ['p3_0_cat_0', 'p3_0_cat_1', 'p3_0_cat_2', 'p3_0_cat_3'].forEach(k => newState[k] = checked);
                                                                    //     this.setState(newState);
                                                                    // }}
                                                                    />
                                                                </th>
                                                                <th style={{ width: '220px' }}>Program Name </th>
                                                                <th style={{ width: '220px' }}>Date & time</th>
                                                                <th>Category</th>
                                                                <th className="text-center" style={{ width: '100px' }}>Location</th>
                                                                <th className="text-center" style={{ width: '100px' }}>Invitation Card</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {programList.length > 0 && programList.map(item => (
                                                                <tr>
                                                                    {item.toShow && <>
                                                                        <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0">
                                                                            <input type="checkbox" className=" mt-0"
                                                                                checked={this.checkSelectedProgram(item.ExhProgramID)}
                                                                                onChange={(e) => this.selectProgram(1, item.ExhProgramID)} />
                                                                        </td>
                                                                        <td rowSpan={item.rowspan} className="fw-semibold align-middle bg-white border-bottom-0 text-dark">{item.ProgramName}</td>
                                                                    </>}
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            {
                                                                                item.rowspan > 1 &&
                                                                                <input type="checkbox" className=" me-2 mt-0"
                                                                                    checked={item.isSelect}
                                                                                    onChange={(e) => this.selectProgram(2, item.ExhProgramDateID)}
                                                                                //  onChange={(e) => this.setState({ [`p2_${i}`]: e.target.checked, p2_all: false, master_all: false })}
                                                                                />}
                                                                            <span style={{ fontSize: '14px' }}>{item.Date}</span>
                                                                            {<span style={{ fontSize: '14px' }} className="ms-2 text-muted"><i className="fa fa-clock-o me-1"></i>{item.StartTime} - {item.EndTime}</span>}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex flex-wrap gap-3">
                                                                            {item.catogary.length > 0 ?
                                                                                <div className="d-flex flex-row align-items-center gap-3 flex-nowrap">{
                                                                                    item.catogary.map(element => (
                                                                                        <label className="mb-0 d-flex flex-row align-items-center" style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}>
                                                                                            {item.catogary.length > 1 && <input type="checkbox" className="me-2 mt-0" style={{ width: '16px', height: '16px' }}
                                                                                                checked={element.isSelect}
                                                                                                onChange={(e) => this.selectProgram(3, element.ExhProgramCategoryID)}
                                                                                            // onChange={(e) => this.setState({ [`${d.rowKey}_cat_${cIdx}`]: e.target.checked, p3_all: false, master_all: false })}
                                                                                            />}
                                                                                            <span className="text-dark">{element.CategoryName}</span>
                                                                                        </label>
                                                                                    ))
                                                                                }</div> :
                                                                                <div className="d-flex flex-wrap gap-3">
                                                                                    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>-</span>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    {item.toShow && (
                                                                        <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0 text-dark">{item.Location}</td>
                                                                    )}
                                                                    {item.toShow && (
                                                                        <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0 text-dark">
                                                                            {item.DocumentPath != '' &&
                                                                                <a
                                                                                    href={item.DocumentPath}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <span style={{ marginRight: '10px' }}
                                                                                    >{item.DocumentName}</span>
                                                                                </a>}
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {console.log(delegateUUID, this.state.AccountTypeID, 'delegateUUID')}
                                        {delegateUUID ? <>
                                        </> : (sessionStorage.getItem('AccountTypeID') == 10) && (

                                            <div className="d-flex justify-content-between align-items-end mb-3 mt-4 px-2 text-start">
                                                <div>
                                                    <h6 className="fw-semibold mb-0 mt-2" style={{ color: "#003b46", fontWeight: "bold", margin: 0 }}>Manage Delegates</h6>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua text-white rounded-3"
                                                    onClick={() => this.state.isFirst && !this.state.isCoordinatorAsDelegate ? this.toggleModel1() : this.toggleModel()}
                                                    style={{ padding: "8px 16px", fontWeight: "500", backgroundColor: "#006c5b", borderColor: "#006c5b" }}
                                                >
                                                    Add Delegate
                                                </button>
                                            </div>
                                        )
                                        }



                                        {sessionStorage.getItem('AccountTypeID') == 10 && this.renderGroupList()}

                                        {showFieldList.length != 0 &&
                                            <div className="main-container m-2">
                                                {!isLoading && this.showMandatoryFields(29, 0) && <div className="one-section mb-2">
                                                    <div className="pb-2">
                                                        <div className="form-row m-2">
                                                            <div >
                                                                {console.log("agreeTerms---->", agreeTerms)}
                                                                <label className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                    <input type="checkbox" style={{ height: 20, width: 20, marginTop: 0 }}
                                                                        value={agreeTerms}
                                                                        checked={agreeTerms}
                                                                        onChange={e => this.setState({ agreeTerms: !agreeTerms, agreeTermsErr: '' })}
                                                                    />
                                                                    <span>I agree all the rules & regulations of delegation process & Exhibition Guidelines of India ITME Society</span>
                                                                </label>
                                                                {/* Indented by the checkbox (20px) + gap (10px): starts under the text */}
                                                                {<span className='text-danger text-start text-left d-block' style={{ paddingLeft: 30 }}>{agreeTermsErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                                {/* Save / Next fixed to the bottom of the screen, on the right. Rendered
                                                    into <body> (portal) so no parent container can stop it staying fixed;
                                                    starts after the sidebar when the logged-in drawer is shown. */}
                                                {createPortal(
                                                <div className={`d-flex justify-content-end align-items-center gap-2 sticky-actions delegate-preview-actions${linkOpenStatus2 ? ' with-sidebar' : ''}`}>
                                                    {sessionStorage.getItem('AccountTypeID') == 10 && <button
                                                        className="btn btn-aqua text-white rounded-3 px-4"
                                                        type="button"
                                                        onClick={(e) => sessionStorage.getItem('AccountTypeID') == 10 ? this.handleSubmit(e, 1) : this.handleSubmitIndividual(e, 1)}
                                                    >
                                                        Save
                                                    </button>}
                                                    <button
                                                        className="btn btn-aqua text-white rounded-3 px-4"
                                                        type="button"
                                                        onClick={(e) => sessionStorage.getItem('AccountTypeID') == 10 ? this.handleSubmit(e) : this.handleSubmitIndividual(e)}
                                                    >
                                                        Next
                                                    </button>
                                                </div>, document.body)}
                                                {/* Room so the last section scrolls clear of the fixed bar */}
                                                <div style={{ height: 64 }}></div>
                                            </div>}
                                    </div>
                                </div>) : (
                                <div
                                    className="main-content app-content mt-0"
                                    style={{ backgroundColor: "#ececec" }}
                                >
                                    <div className="side-app">
                                        <div className="main-container container-fluid top-form-name">
                                            <div className="row ">
                                                <form className="needs-validation " noValidate="">
                                                    <div className="form-row mt-4">
                                                        <div className="form-group col-md-7 p-4 thank-box">
                                                            <div className="form-group mb-2">
                                                                <h4
                                                                    className="mb-0 pt-2 pb-4 thank-top-mes"
                                                                    style={{ color: "#318958" }}
                                                                >
                                                                    <strong>Exhibition Closed</strong>
                                                                </h4>
                                                                <p className="mb-1 mt-1 text-center com-font">
                                                                    Thank you for your interest but the
                                                                </p>
                                                                <p className="mt-1 mb-0 text-center com-font">
                                                                    ITME AFRICA &amp; M.E. 2023 from 30 November 2023 to 2
                                                                    December 2023
                                                                </p>
                                                                <p className="mb-3 text-center com-font">
                                                                    at Kenyatta International Convention Centre, Nairobi, Kenya is now closed.
                                                                </p>
                                                                <p className="mb-3 text-center com-font">
                                                                    This Event already completed. Please Visit Again once the next edition is announced.
                                                                </p>
                                                            </div>
                                                            <div classname="">
                                                                <div classname="mt-1 mb-4">

                                                                    <button
                                                                        classname="btn btn-next-bot m-1"
                                                                        style={{
                                                                            background: "#007bff",
                                                                            padding: "6px 20px",
                                                                            fontSize: 14,
                                                                            border: "1px solid #007bff",
                                                                            borderRadius: 2,
                                                                            color: "#fff",
                                                                            marginTop: 16
                                                                        }}
                                                                        onClick={e => this.onPreviousClick(e)}
                                                                    >
                                                                        {" "}
                                                                        BACK TO EVENT WEBSITE
                                                                    </button>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div >
                </div >

                < Modal
                    size="xl"
                    show={isOpen}
                    onHide={() => this.toggleModel()}
                    scrollable={true}
                >
                    <Modal.Header className="d-flex justify-content-between align-items-center">
                        <Modal.Title id="example-modal-sizes-title-lg">
                            <h5 class="modal-title modal_title_text text-white">{isModalEdit ? 'Update Delegate' : 'Add Delegate'}</h5>
                        </Modal.Title>
                        <i className="fa fa-times text-white" style={{ cursor: 'pointer', fontSize: '24px' }} onClick={() => this.toggleModel()}></i>
                    </Modal.Header>
                    <Modal.Body className="pop-scroll p-1 pt-0 delegate-form-page">
                        <div className="accordion" id="accordionExample">
                            <div className="accordion-item mb-2">
                                <h5 className="accordion-header delegate-section-title">
                                    <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse_l1_m1"
                                        aria-expanded="true"
                                        aria-controls="collapse_l1_m1"
                                    >{sessionStorage.getItem('AccountTypeID') == 10
                                        ? 'Delegate personal information'
                                        : 'Personal Information'}
                                    </button>
                                </h5>
                                <div className="accordion-collapse collapse show" id="collapse_l1_m1">
                                    <div className="accordion-body p-0 pb-3">
                                        <div className="one-section">

                                            <div className="col-md-12">
                                                <div className="row">
                                                    {this.showMandatoryFields(2, 0) && <div className="col-xl-3 mt-3">
                                                        <label style={{ border: 'none' }}>
                                                            First Name{this.showMandatoryFields(2, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <div className="name-input-group">
                                                            {this.showMandatoryFields(1, 0) && (
                                                                <select
                                                                    className="form-control name-prefix"
                                                                    value={prenameModal}
                                                                    onChange={(e) => this.setState({
                                                                        prenameModal: e.target.value,
                                                                        prename: e.target.value,
                                                                        isOtherPreNameModal: e.target.value === "Other",
                                                                        isOtherPreName: e.target.value === "Other"
                                                                    })}
                                                                >
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Ms">Ms</option>
                                                                    <option value="DR">DR</option>
                                                                    <option value="Prof">Prof</option>
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            )}
                                                            {isOtherPreNameModal && (
                                                                <input
                                                                    type="text"
                                                                    className="form-control name-other"
                                                                    maxLength={'40'}
                                                                    value={otherNameModal}
                                                                    onChange={e => this.setState({ otherNameModal: e.target.value, otherName: e.target.value })}
                                                                    placeholder={'Prefix'}
                                                                />
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="form-control name-no"
                                                                maxLength={'50'}
                                                                placeholder="Enter first name"
                                                                value={firstNameModal}
                                                                onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ firstNameModal: e.target.value, firstNameErrModal: '' })}
                                                            />
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block'>{firstNameErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(3, 0) && <div className="col-xl-3 mt-3">
                                                        <label style={{ border: 'none' }}>
                                                            Last Name{this.showMandatoryFields(3, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={lastNameModal} maxLength={'50'}
                                                            onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ lastNameModal: e.target.value, lastNameErrModal: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{lastNameErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(20, 0) && <div className="col-xl-3 mt-3">
                                                        <div className="d-flex">
                                                            <label className=" w-auto " style={{ border: 'none' }}>
                                                                Select Country
                                                                {this.showMandatoryFields(20, 2) && <span className="text-red">*</span>}
                                                            </label>
                                                        </div>
                                                        <select className="form-control" value={countryIdModal}
                                                            onChange={(e) => this.onCountrySelect(e, 1)}
                                                        >
                                                            <option value={''}>Select Your Country</option>
                                                            {
                                                                countryList.length > 0 && countryList.map((data) => (
                                                                    <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {<span className='text-danger text-start text-left d-block '>{countryIdErrModal}</span>}

                                                    </div>}

                                                    {this.showMandatoryFields(4, 0) && <div className="col-xl-3 mt-3">
                                                        <div className="d-flex">
                                                            <label className="w-auto" >
                                                                Gender
                                                                {this.showMandatoryFields(4, 2) && <span className="text-red">*</span>}
                                                            </label>
                                                        </div>
                                                        <select className="form-control" value={genderModal}
                                                            onChange={(e) => e.target.value != '' ? this.setState({ genderModal: e.target.value, genderErrModal: '' }) : null}
                                                        >
                                                            <option value={''}>Select Your Gender</option>
                                                            {
                                                                genderList.length > 0 && genderList.map((data) => (
                                                                    <option key={data.GenderID} value={data.GenderID} >{data.Name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {<span className='text-danger text-start text-left d-block '>{genderErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(5, 0) && <div className="col-sm-3 mt-3">
                                                        {/* <span class="text-danger text-start text-left d-block mt-1"></span> */}
                                                        <label>
                                                            Designation{this.showMandatoryFields(5, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={designationModal} maxLength={'50'}
                                                            onChange={(e) => this.setState({ designationModal: e.target.value, designationErrModal: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{designationErrModal}</span>}

                                                    </div>}
                                                    {this.showMandatoryFields(6, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Institute/Organisation{this.showMandatoryFields(6, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={instituteModal} maxLength={'500'}
                                                            onChange={(e) => this.setState({ instituteModal: e.target.value, instituteErrModal: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{instituteErrModal}</span>}

                                                    </div>}

                                                    {this.showMandatoryFields(10, 0) && <div className="col-xl-6 mt-3">
                                                        <label>
                                                            Address 1{this.showMandatoryFields(10, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={Address1Modal} maxLength={'1000'}
                                                            onChange={(e) => this.setState({ Address1Modal: e.target.value, Address1ErrModal: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{Address1ErrModal}</span>}

                                                    </div>}
                                                    {this.showMandatoryFields(11, 0) && <div className="col-xl-6 mt-3">
                                                        <label>
                                                            Address 2{this.showMandatoryFields(11, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={Address2Modal} maxLength={'1000'}
                                                            onChange={(e) => this.setState({ Address2Modal: e.target.value, Address2ErrModal: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{Address2ErrModal}</span>}

                                                        {/* {<span className='text-danger text-start text-left d-block '>{IECCodeErr}</span>} */}

                                                    </div>}

                                                    {this.showMandatoryFields(12, 0) && <div className="col-xl-6 mt-3">
                                                        <label>
                                                            Address 3{this.showMandatoryFields(12, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={Address3Modal} maxLength={'1000'}
                                                            onChange={(e) => this.setState({ Address3Modal: e.target.value, Address3ErrModal: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{Address3ErrModal}</span>}
                                                        {/* {<span className='text-danger text-start text-left d-block '>{Address1Err}</span>} */}

                                                    </div>}
                                                    {this.showMandatoryFields(9, 0) && <div className="col-xl-6 mt-3">
                                                        <label>
                                                            IEC Code (Importer-Exporter Code){this.showMandatoryFields(9, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={IECCodeModal} maxLength={'50'}
                                                            onChange={(e) => this.setState({ IECCodeModal: e.target.value, IECCodeErrModal: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{IECCodeErrModal}</span>}

                                                    </div>}

                                                    {this.showMandatoryFields(15, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Pincode/Zipcode{this.showMandatoryFields(15, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        {/* {
                                            countryIdModal == "91" &&
                                            <input type="text" className="form-control" value={pincodeModal}
                                                maxLength={6} onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.onPincodeSearch(e, 1) : null}
                                            />
                                        }

                                        {
                                            countryIdModal != "91" &&
                                            <input type="text" className="form-control" value={pincodeModal}
                                                maxLength={10} onChange={(e) => this.onPincodeSearch(e, 1)}
                                                onInput={toInputUppercase}
                                            />
                                        }
                                        {isDisplayPincodeListModal && this.renderGroupPincodeList()} */}
                                                        <Form.Control
                                                            type="text"
                                                            value={pincodeModal}
                                                            maxLength={countryId == "91" ? 6 : 10}
                                                            onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.handleSearchChange(e, 2, 1) : null}
                                                            onFocus={() => pincodeModal.length > 0 && this.setState({ isOpenDropDownPinModal: true })}
                                                            onBlur={() => setTimeout(() => {
                                                                this.setState({ isOpenDropDownPinModal: false })
                                                            }, 500)}
                                                            onKeyDown={(e) => this.handleKeyDown(e, 2, 1)}
                                                        />

                                                        {/* Dropdown options - shown only if there are results */}
                                                        {isOpenDropDownPinModal && tempPincodeListModal.length > 0 && (
                                                            <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 999, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                {tempPincodeListModal.map((item, index) => (
                                                                    <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 2, 1)}
                                                                        style={{
                                                                            whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none', fontSize: 'small',
                                                                            backgroundColor: this.state.focusedIndexPinModal === index ? '#a4c2df' : 'transparent',
                                                                        }}
                                                                        onMouseEnter={() => this.handleHover(index, 2, 1)}
                                                                    >
                                                                        {item.Pincode}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        )}

                                                        {<span className='text-danger text-start text-left d-block '>{pincodeErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(14, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            State/Province{countryId == "91" && this.showMandatoryFields(14, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        {/* <input type="text" className="form-control" value={regStateModal} maxLength={'50'}
                                            onChange={(e) => this.onStateSearch(e, 1)}
                                        />
                                        {isDisplayStateListModal && this.renderGroupStateList()} */}
                                                        <Form.Control
                                                            type="text"
                                                            value={regStateModal}
                                                            onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 0, 1)}
                                                            onFocus={() => regStateModal.length > 0 && this.setState({ isOpenDropDownStateModal: true })}
                                                            onBlur={() => setTimeout(() => {
                                                                this.setState({ isOpenDropDownStateModal: false })
                                                            }, 500)}
                                                            onKeyDown={(e) => this.handleKeyDown(e, 0, 1)}
                                                        />

                                                        {/* Dropdown options - shown only if there are results */}
                                                        {isOpenDropDownStateModal && tempStateListModal.length > 0 && (
                                                            <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 999, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                {tempStateListModal.map((item, index) => (
                                                                    <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 0, 1)}
                                                                        style={{
                                                                            whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none', fontSize: 'small',
                                                                            backgroundColor: this.state.focusedIndexStateModal === index ? '#a4c2df' : 'transparent',
                                                                        }}
                                                                        onMouseEnter={() => this.handleHover(index, 0, 1)}
                                                                    >
                                                                        {item.Description}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        )}
                                                        {<span className='text-danger text-start text-left d-block '>{regStateErrModal}</span>}
                                                    </div>}

                                                    {this.showMandatoryFields(13, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            City{this.showMandatoryFields(13, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        {/* <input type="text" className="form-control" value={cityModal} maxLength={'50'}
                                            onChange={(e) => this.onCitySearch(e, 1)} />
                                        {isDisplayCityListModal && this.renderGroupCityList()} */}
                                                        <Form.Control
                                                            type="text"
                                                            value={cityModal}
                                                            onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.handleSearchChange(e, 1, 1)}
                                                            onFocus={() => cityModal.length > 0 && this.setState({ isOpenDropDownCityModal: true })}
                                                            onBlur={() => setTimeout(() => {
                                                                this.setState({ isOpenDropDownCityModal: false })
                                                            }, 500)}
                                                            onKeyDown={(e) => this.handleKeyDown(e, 1, 1)}
                                                        />

                                                        {/* Dropdown options - shown only if there are results */}
                                                        {isOpenDropDownCityModal && tempCityListModal.length > 0 && (
                                                            <Dropdown.Menu show style={{ position: 'absolute', width: '95%', zIndex: 999, marginLeft: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                                                {tempCityListModal.map((item, index) => (
                                                                    <Dropdown.Item key={index} onClick={() => this.handleSelect(item, 1, 1)}
                                                                        style={{
                                                                            whiteSpace: 'normal', height: 'auto', minHeight: '38px', lineHeight: '1.3', wordWrap: 'break-word', overflowWrap: 'break-word', cursor: 'pointer', transition: 'none', fontSize: 'small',
                                                                            backgroundColor: this.state.focusedIndexCityModal === index ? '#a4c2df' : 'transparent',
                                                                        }}
                                                                        onMouseEnter={() => this.handleHover(index, 1, 1)}
                                                                    >
                                                                        {item.Description}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        )}
                                                        {<span className='text-danger text-start text-left d-block '>{cityErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(16, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Email{this.showMandatoryFields(16, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={emailModal} maxLength={'50'}
                                                            onChange={(e) => this.setState({ emailModal: e.target.value, emailErrModal: "" })}
                                                            onBlur={(e) => this.verifyEmail(e, 1)}
                                                            autoComplete="new-password"
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{emailErrModal}</span>}
                                                    </div>}

                                                    {this.showMandatoryFields(17, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Website{this.showMandatoryFields(17, 2) && <span className="text-red">*</span>}
                                                        </label>
                                                        <input type="text" className="form-control" value={websiteModal} maxLength={'50'}

                                                            onChange={(e) => this.setState({ websiteModal: e.target.value, websiteErrModal: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block '>{websiteErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(21, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Mobile No{this.showMandatoryFields(21, 2) && <span className="text-red">*</span>}
                                                        </label>

                                                        <div className="phone-input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control phone-code" autoComplete="off" readOnly
                                                                placeholder="ISD"
                                                                maxLength={'4'}
                                                                value={preMobNoModal}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control phone-no"
                                                                value={mobNoModal}
                                                                maxLength={countryIdModal == 91 ? '10' : '11'}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
    
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ mobNoModal: e.target.value, mobNoErrModal: '' }) : null}
                                                            />
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block '>{mobNoErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(22, 0) &&
                                                        <div className="col-xl-3 mt-3">
                                                            <label>
                                                                Whatsapp Mobile No{this.showMandatoryFields(22, 2) && <span className="text-red">*</span>}
                                                            </label>

                                                            <div className="phone-input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-code" autoComplete="off" readOnly
                                                                    value={preWhatsAppMobNoModal}
                                                                    placeholder="ISD"
                                                                    maxLength={'4'}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control phone-no"
                                                                    value={whatsAppMobNoModal}
                                                                    maxLength={countryIdModal == 91 ? '10' : '11'}
    
                                                                    onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                    onKeyDown={(e) => this.preventMinus(e)}
                                                                    onPaste={(e) => this.handlePaste(e)}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ whatsAppMobNoModal: e.target.value, whatsAppMobNoErrModal: '' }) : null}
                                                                />
                                                            </div>
                                                            {<span className='text-danger text-start text-left d-block '>{whatsAppMobNoErrModal}</span>}
                                                        </div>}
                                                    {this.showMandatoryFields(21, 0) && this.showMandatoryFields(22, 0) && <div className="col-sm-3 d-flex align-items-center" style={{ paddingTop: '38px' }}>
                                                        <label className="d-flex align-items-center mb-0" style={{ gap: '8px', cursor: 'pointer' }}>
                                                            <input type="checkbox" name="fav_language"
                                                                value={isSameAsMobNoModal} checked={isSameAsMobNoModal}
                                                                onClick={(e) => this.onSameAsMobNoClick(e, 1)}
                                                                style={{ width: 16, height: 16, marginTop: 0 }}
                                                            />
                                                            <span>Same As Mobile No</span>
                                                        </label>
                                                    </div>}

                                                    {this.showMandatoryFields(18, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Telephone No{this.showMandatoryFields(18, 2) && <span className="text-red">*</span>}
                                                        </label>

                                                        <div className="phone-input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control phone-code" autoComplete="off"
                                                                value={preTelNoModal} placeholder="STD" maxLength={'4'}
                                                                onChange={(e) => this.setState({ preTelNoModal: e.target.value })}
                                                            />
                                                            <input
                                                                type="number"
                                                                className="form-control phone-no"
                                                                value={telNoModal}
                                                                maxLength={'10'}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.preventMinus(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => e.target.value >= 0 && this.setState({ telNoModal: e.target.value, telephoneErrModal: '' })}
                                                            />
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block '>{telephoneErrModal}</span>}
                                                    </div>}
                                                    {this.showMandatoryFields(19, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            Telephone No 1{this.showMandatoryFields(19, 2) && <span className="text-red">*</span>}
                                                        </label>

                                                        <div className="phone-input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control phone-code" autoComplete="off"
                                                                value={preTel1NoModal} placeholder="STD" maxLength={'4'}
                                                                onChange={(e) => this.setState({ preTel1NoModal: e.target.value })}
                                                            />
                                                            <input
                                                                type="number"
                                                                className="form-control phone-no"
                                                                value={tel1NoModal}
                                                                maxLength={'10'}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => e.target.value >= 0 && this.setState({ tel1NoModal: e.target.value, telephone1ErrModal: '' })}
                                                            />
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block '>{telephone1ErrModal}</span>}

                                                    </div>}
                                                    {this.showMandatoryFields(7, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            GST No{this.showMandatoryFields(7, 2) && countryIdModal == 91 && <span className="text-red">*</span>}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            maxLength={15}
                                                            className="form-control"
                                                            value={compInfoGstNoModal}
                                                            onChange={(e) =>
                                                                this.onGSTchange(e.target.value, 1)
                                                            }
                                                            onInput={toInputUppercase}
                                                        />
                                                        {countryIdModal == 91 && (
                                                            <span className="text-danger text-start text-left d-block ">
                                                                {compInfoGstNoErrModal}
                                                            </span>
                                                        )}
                                                    </div>}
                                                    {this.showMandatoryFields(8, 0) && <div className="col-xl-3 mt-3">
                                                        <label>
                                                            PAN No{this.showMandatoryFields(8, 2) && countryIdModal == 91 && <span className="text-red">*</span>}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            maxLength={10}
                                                            className="form-control"
                                                            value={compInfoPanNoModal}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    compInfoPanNoModal: e.target.value,
                                                                    compInfoPanNoErrModal: "",
                                                                })
                                                            }
                                                            onInput={toInputUppercase}
                                                        />
                                                        {countryIdModal == 91 && (
                                                            <span className="text-danger text-start text-left d-block ">
                                                                {compInfoPanNoErrModal}
                                                            </span>
                                                        )}
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* {(this.showMandatoryFields(27, 0) || this.showMandatoryFields(28, 0)) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button" data-bs-toggle="collapse" data-bs-target="#collapse_l1_h11"
                                            aria-expanded="true" aria-controls="collapse_l1_h11">Arrival and Departure<span className="text-red">*</span>
                                        </button>
                                    </h5>
                                    {<span className='text-danger/ text-start text-left d-block mt-1 ml-2'>{this.state.SeminarErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_h11">
                                        <div className="accordion-body">
                                            < div className="one-section">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        {this.showMandatoryFields(27, 0) && <div className="col-sm-3">
                                                            <label>Arrival Date{this.showMandatoryFields(27, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                            <DatePicker
                                                                style={{ zIndex: '99999' }}
                                                                selected={arrivalDate}
                                                                dateFormat={"dd/MM/yyyy"}
                                                                className="form-control"
                                                                onChange={(date) => this.setState({ arrivalDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), arrivalDateErr: '' })}
                                                                peekNextMonth
                                                                minDate={new Date()}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Arrival Date"
                                                            />
                                                            {<span className='text-danger text-start text-left d-block '>{arrivalDateErr}</span>}
                                                        </div>}
                                                        {this.showMandatoryFields(28, 0) && <div className="col-sm-3">
                                                            <label >Departure Date{this.showMandatoryFields(28, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                            <DatePicker
                                                                style={{ zIndex: '99999' }}
                                                                selected={departureDate}
                                                                dateFormat={"dd/MM/yyyy"}
                                                                className="form-control"
                                                                onChange={(date) => this.setState({ departureDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), departureDateErr: '' })}
                                                                peekNextMonth
                                                                minDate={new Date()}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Departure Date"
                                                            />
                                                            {<span className='text-danger text-start text-left d-block '>{departureDateErr}</span>}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>} */}


                        {(this.showMandatoryFields(23, 0) || this.showMandatoryFields(24, 0) || this.showMandatoryFields(25, 0) || this.showMandatoryFields(26, 0)) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button
                                            className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_h7"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_h7"
                                        >
                                            Company Profile
                                        </button>
                                    </h5>
                                    {/* {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.turnOverErr}</span>} */}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_h7">
                                        <div className="accordion-body P-0">
                                            <div className="one-section">
                                                {/* <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="containerfluid">
                                                            <div className="row mt-2">
                                                              
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Company Profile<span className="text-red">*</span>
                                                                    </p>
                                                                   {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.turnOverErr}</span>} 
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div> */}
                                                {this.showMandatoryFields(23, 0) && <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-xl-12 mb-1">
                                                            <label className="mt-3">Company Profile{
                                                                // this.showMandatoryFields(23, 2) &&
                                                                <span className="text-red">*</span>}</label>
                                                            <textarea type="text" className="form-control" value={companyProfileModal}
                                                                maxLength={'500'}
                                                                onChange={(e) => this.setState({ companyProfileModal: e.target.value, companyProfileErrModal: '' })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block '>{companyProfileErrModal}</span>}
                                                        </div>
                                                    </div>
                                                </div>}
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-xl-12 mb-1">
                                                            <label className="mt-3">{delegateUUID ? <>Delegate's Photo</> : <>Person's Photo</>}{
                                                                // this.showMandatoryFields(23, 2) &&
                                                                <span className="text-red">*</span>}</label>
                                                            {
                                                                (PersonPhotoModal ? PersonPhotoModal : PersonPhotoPreviewModal) ? (
                                                                    <div style={{ position: "relative", display: "inline-block" }}>
                                                                        <img
                                                                            src={
                                                                                (PersonPhotoModal?.includes("base64,") ||
                                                                                    PersonPhotoPreviewModal?.includes("base64,"))
                                                                                    ? (PersonPhotoModal || PersonPhotoPreviewModal)
                                                                                    : BASE_URL?.split('/api')[0] +
                                                                                    (PersonPhotoModal || PersonPhotoPreviewModal)
                                                                            }
                                                                            alt="Preview"
                                                                            style={{ width: "250px", height: "250px", objectFit: "contain" }}
                                                                        />

                                                                        <button
                                                                            type="button"
                                                                            onClick={this.clearDelegateFileInputModal}
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "-8px",
                                                                                right: "-8px",
                                                                                background: "#dc3545",
                                                                                color: "#fff",
                                                                                border: "none",
                                                                                borderRadius: "50%",
                                                                                width: "26px",
                                                                                height: "26px",
                                                                                padding: 0,
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                lineHeight: 1,
                                                                                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)",
                                                                                cursor: "pointer",
                                                                                fontSize: "14px"
                                                                            }}
                                                                            title="Remove"
                                                                        >
                                                                            <i className="fa fa-times"></i>
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <input
                                                                            type="file"
                                                                            accept="image/jpeg, image/png, image/jpg"
                                                                            className="form-control"
                                                                            placeholder="Upload Logo"
                                                                            onChange={this.handleImageUploadModal}
                                                                            ref={(ref) => (this.fileInputRef = ref)}
                                                                        />
                                                                        {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{PersonPhotoModalErr || ''}</span>}
                                                                    </>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="row">
                                                        {/* {this.showMandatoryFields(24, 0) &&
                                                            <div className="col-xl-4 mb-1">
                                                                <label className="mt-3">Company Website{this.showMandatoryFields(24, 2) && <span className="text-red">*</span>}</label>
                                                                <input type="text" className="form-control" value={companywebsite}
                                                                    maxLength={'50'}
                                                                    onChange={(e) => this.setState({ companywebsite: e.target.value, companyWebsiteErr: '' })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{companyWebsiteErr}</span>}
                                                            </div>} */}
                                                        {
                                                            // this.showMandatoryFields(25, 0) && 
                                                            <div className="col-xl-4 mb-1">
                                                                <label className="mt-3">Total Years the Company Is Operational{
                                                                    // this.showMandatoryFields(25, 2) &&
                                                                    <span className="text-red">*</span>}</label>
                                                                <input type="text" className="form-control" value={totalYearsModal}
                                                                    maxLength={'50'}
                                                                    onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ totalYearsModal: e.target.value, totalYearsErrModal: '' }) : null}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{totalYearsErrModal}</span>}

                                                            </div>}

                                                        <div className="col-xl-8 mb-1">
                                                            <label className="mt-3">{delegateUUID ? <>Delegate's Profile</> : <>Person's Profile</>}{
                                                                // this.showMandatoryFields(23, 2) && 
                                                                <span className="text-red">*</span>}</label>
                                                            <textarea type="text" className="form-control" value={PersonProfileModal} maxLength={'500'}
                                                                onChange={(e) => this.setState({ PersonProfileModal: e.target.value, PersonProfileModalErr: '' })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block '>{PersonProfileModalErr}</span>}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        {this.showMandatoryFields(26, 0) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button
                                            className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_h8"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_h8"
                                        >
                                            Company Turn Over (in USD){
                                                // this.showMandatoryFields(26, 2) && 
                                                <span className="text-red">*</span>}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{this.state.turnOverErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_h8">
                                        <div className="accordion-body">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {/* <div className="containerfluid">
                                                            <div className="row mt-2">
                                                                <div className="p-1 title-bg d-flex">
                                                                    <p className="mb-0">
                                                                        Company Turn Over (in USD){this.showMandatoryFields(26, 2) && <span className="text-red">*</span>}</p>
                                                                    {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{this.state.turnOverErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    <div className="col-12 mb-1">
                                                        <div className="row mt-2">
                                                            {
                                                                this.state.turnOverListModal.length > 0 && this.state.turnOverListModal.map((data) => (
                                                                    <div className="col-12 col-sm-auto pe-sm-5" key={data.CompanyTurnOverID}>
                                                                        <label className="d-flex">
                                                                            <input type="radio" name="turnOver" value={data.CompanyTurnOverID}
                                                                                checked={data.CompanyTurnOverID == this.state.turnOverIdModal}
                                                                                onChange={() => this.setState({ turnOverIdModal: data.CompanyTurnOverID, turnOverErrModal: '' })}
                                                                            />
                                                                            {data.Description}
                                                                        </label>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        {/* {(this.showMandatoryFields(27, 0) || this.showMandatoryFields(28, 0)) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m11"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m11"
                                        >    Arrival and Departure<span className="text-red">*</span>
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.SeminarErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m11">
                                        <div className="accordion-body">
                                            <div className="one-section">
                                                <div className="col-md-12 mb-2">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            {this.showMandatoryFields(27, 0) && <div className="col-sm-3">
                                                                <label>Arrival Date{this.showMandatoryFields(27, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                                <DatePicker
                                                                    style={{ zIndex: '99999' }}
                                                                    selected={arrivalDateModal}
                                                                    dateFormat={"dd/MM/yyyy"}
                                                                    className="form-control"
                                                                    onChange={(date) => this.setState({ arrivalDateModal: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), arrivalDateErrModal: '' })}
                                                                    peekNextMonth
                                                                    minDate={new Date()}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Arrival Date"
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{arrivalDateErrModal}</span>}
                                                            </div>}
                                                            {this.showMandatoryFields(28, 0) && <div className="col-sm-3">
                                                                <label >Departure Date{this.showMandatoryFields(28, 2) && <span style={{ color: 'red' }}>*</span>}</label>
                                                                <DatePicker
                                                                    style={{ zIndex: '99999' }}
                                                                    selected={departureDateModal}
                                                                    dateFormat={"dd/MM/yyyy"}
                                                                    className="form-control"
                                                                    onChange={(date) => this.setState({ departureDateModal: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), departureDateErrModal: '' })}
                                                                    peekNextMonth
                                                                    minDate={new Date()}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    placeholderText="Departure Date"
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{departureDateErrModal}</span>}
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } */}

                        {this.showMandatoryFields(30, 0) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m2"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m2"
                                        >Industry Segment<span className="text-red">*</span>
                                            {/* {this.showMandatoryFields(30, 2) && <span className="text-red">*</span>} */}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.chapterErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m2">
                                        <div className="accordion-body">
                                            <div className="one-section mt-2">
                                                {/* <div className="containerfluid">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">Industry Segment{this.showMandatoryFields(30, 2) && <span className="text-red">*</span>}
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.chapterErrModal}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className=" mb-2">
                                                    <div className="row mt-1">
                                                        <div className="asc">
                                                            <div className="">
                                                                <form className="needs-validation pb-0" noValidate="">
                                                                    <div className="form-row mt-2">
                                                                        {
                                                                            chapterListModal.length > 0 && chapterListModal.map((data) => (
                                                                                <div className="col-12 col-sm-6 col-lg-3 mb-2">
                                                                                    <section className="" key={data.IndustrySegmentID}>
                                                                                        {/* <input type="checkbox" name="collapse"
                                                                                select={data.isSelect} checked={data.IndustrySegmentID}
                                                                                value={data.IndustrySegmentID}
                                                                            /> */}
                                                                                        <h2 className="handle-no-icon m-0" style={{ fontSize: '13px' }}>
                                                                                            <label style={{ color: '#212529' }}>
                                                                                                <input type="checkbox"
                                                                                                    select={data.isSelect} checked={data.isSelect}
                                                                                                    value={data.IndustrySegmentID}
                                                                                                    onChange={(e) => this.onSelectPrimaryChapter(e, 1)} />
                                                                                                {data['Industrial Segment']}
                                                                                            </label>
                                                                                        </h2>
                                                                                        {data.IndustrySegmentID == 16 && this.state.isOtherOpenModal && <input type="text" className="form-control" value={this.state.otherModal}
                                                                                            onChange={(e) =>
                                                                                                this.setState({ otherModal: e.target.value, })}
                                                                                        />}
                                                                                    </section>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        {this.showMandatoryFields(31, 0) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m3"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m3"
                                        > Purpose of Visit{
                                                // this.showMandatoryFields(31, 2) &&
                                                <span className="text-red">*</span>}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{visitPurposeErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m3">
                                        <div className="accordion-body">
                                            <div className="one-section mt-2">
                                                {/* <div className="containerfluid">
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <div className="p-1 title-bg d-flex">
                                            <p className="mb-0">
                                                Purpose of Visit{this.showMandatoryFields(31, 2) && <span className="text-red">*</span>}
                                            </p>
                                            {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{visitPurposeErrModal}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                                                <div className="col-xl-12 mb-0">
                                                    <div className="row mt-2">
                                                        {
                                                            visitPurposeListModal.length > 0 && visitPurposeListModal.map((data) => (
                                                                <div className="col-12 col-sm-6 col-lg-3 mb-2" key={data.PurposeofVisitID}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" name="fav_language"
                                                                            select={data.isSelect} checked={data.isSelect}
                                                                            value={data.PurposeofVisitID}
                                                                            onChange={(e) => this.onSelectPurpose(e, 1)}
                                                                        />
                                                                        {data.PurposeofVisitName}
                                                                    </label>
                                                                    {
                                                                        data.PurposeofVisitID == 10 && data.isSelect &&
                                                                        <input
                                                                            className="form-control"
                                                                            maxLength={'100'}
                                                                            value={data.otherDetail}
                                                                            onChange={(e) => this.otherDetailChange(e, 1)}
                                                                        >
                                                                        </input>
                                                                    }
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.showMandatoryFields(32, 0) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m4"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m4"
                                        >  Products<span className="text-red">*</span>
                                            {/* {this.showMandatoryFields(32, 2) && <span className="text-red">*</span>} */}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{this.state.ChapterHallErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m4">
                                        <div className="accordion-body p-0">
                                            <div className="one-section">
                                                {/* <div className="containerfluid">
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <div className="p-1 title-bg d-flex">
                                            <p className="mb-0">
                                                Products{this.showMandatoryFields(32, 2) && <span className="text-red">*</span>}
                                            </p>
                                            {<span className='text-danger text-start text-left d-block ml-2' style={{ marginTop: '2px' }}>{ChapterHallErrModal}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                                                <div className="col-xl-12 mb-1">
                                                    <div className="row">
                                                        <div class="accordion" id="accordionExample">
                                                            {level2Modal.length > 0 && level2Modal.map(level2Data => (
                                                                <>
                                                                    {
                                                                        <div class="accordion-item">
                                                                            <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                    type="button" data-bs-toggle="collapse" style={{ display: 'flex' }}
                                                                                    data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                    aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                    {/* // checkbox for level2 */}
                                                                                    {
                                                                                        level2Data.IsCheckbox &&
                                                                                        <input type="checkbox" className="from-left-sp" name=""
                                                                                            checked={level2Data.isSelect} id={'M' + level2Data.ChapterID}
                                                                                            onClick={e => this.onCheckLevel2Modal(e, level2Data.ChapterID)} />
                                                                                    }
                                                                                    <label for={'M' + level2Data.ChapterID} style={{ background: 'none', cursor: 'pointer', padding: 0 }}>
                                                                                        {formatChapterName(level2Data.ChapterName)}
                                                                                    </label></button>
                                                                            </h2>
                                                                            {this.recordTwoModal(level2Data, level3Modal, level4Modal)}
                                                                        </div>
                                                                    }

                                                                </>
                                                            ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="" style={{ marginLeft: "10px" }}>
                                                    <p className="mb-0" style={{ fontSize: 15 }}>
                                                        <strong>  Selected Products</strong>
                                                    </p>
                                                </div>
                                                <div style={{ padding: "0px 0px 0px 10px" }}>
                                                    {
                                                        filerArrayModal.length > 0 ? filerArrayModal.map((data) => (
                                                            <p>
                                                                {formatChapterName(data.ChapterName)}
                                                            </p>
                                                        )) :
                                                            <p>
                                                                {"No Results"}
                                                            </p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* {this.showMandatoryFields(33, 0) && <>
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m5"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m5"
                                        >   B2B meetings
                                            {isInterestTwoModal && this.showMandatoryFields(33, 2) && <span className="text-red">*</span>}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.b2bErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m5">
                                        <div className="accordion-body">
                                            <div className="one-section">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-sm-12 mt-2 mb-2">
                                                            <label className="d-flex">
                                                                <input type="checkbox" name="fav_language"
                                                                    select={isInterestTwoModal} checked={isInterestTwoModal}
                                                                    onChange={(e) => this.onSelectInterest(e, 1)}
                                                                />
                                                                Select your B2B meeting schedule
                                                            </label>
                                                            {isInterestTwoModal &&
                                                                <>
                                                                    <div className="col-md-12">
                                                                        <div className="table-responsive" >
                                                                            <table className="table border table-bordered mb-0 mt-1" >
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-center" style={{ width: '150px' }}>Date</th>
                                                                                        <th className="text-center" style={{ width: '200px' }}>Location</th>
                                                                                        <th className="text-center">TimeSlots</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        B2bMeetingListmodal.length > 0 && B2bMeetingListmodal.map((data) => (
                                                                                            <tr key={Math.random()}>
                                                                                                {data.rowSpan != 0 ? <td rowSpan={data.rowSpan} className="text-center" >
                                                                                                    {moment(data.B2BDate).format('DD MMM YYYY')}
                                                                                                    <br />
                                                                                                    <small>{moment(data.B2BDate).format('dddd')}</small>
                                                                                                </td> : <></>}
                                                                                                <td className="text-center" >{data.B2BLocation}</td>
                                                                                                <td>
                                                                                                    <div className="d-flex flex-wrap gap-2 m-2">
                                                                                                        {data.timeSlotList.length > 0 && data.timeSlotList.map((item) => (

                                                                                                            <div>
                                                                                                                <ToggleButton
                                                                                                                    style={{ whiteSpace: 'nowrap' }}
                                                                                                                    className={`p-2 rounded-5 ${item.IsBooked && 'text-white'} `}
                                                                                                                    id={item.B2BTimeSlotID}
                                                                                                                    type="checkbox"
                                                                                                                    variant={!item.IsBooked ? "outline-primary" : "outline-secondary"}
                                                                                                                    disabled={item.IsBooked}
                                                                                                                    checked={item.isSelect || item.IsBooked}
                                                                                                                    value={item.B2BTimeSlotID}
                                                                                                                    onClick={() => this.onSelect(item.B2BTimeSlotID, 1)}
                                                                                                                >
                                                                                                                    {item.timeslot}
                                                                                                                </ToggleButton>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </table>

                                                                            <div />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>} */}
                        {(!isInterestTwoModal && this.showMandatoryFields(34, 0) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 0))) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m6"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m6"
                                        >    Date of Visit Single Day Pass / All Day Pass{" "}
                                            {((!isInterestTwoModal && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2))) && <span className="text-red">*</span>}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{daysErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m6">
                                        <div className="accordion-body">
                                            <div className="one-section">
                                                {/* <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg d-flex">
                                                                <p className="mb-0">
                                                                    Date of Visit Single Day Pass / All Day Pass{" "}
                                                                    {((!isInterestTwoModal && this.showMandatoryFields(34, 2)) || (!this.showMandatoryFields(33, 0) && this.showMandatoryFields(34, 2))) && <span className="text-red">*</span>}
                                                                </p>
                                                                {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{daysErrModal}</span>}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-12 mb-1">
                                                    <div className="row mt-2" >
                                                        {
                                                            daysListModal.length > 0 && daysListModal.map((data) => (
                                                                <div className="col-6 col-sm-4 col-lg-2" key={data.Code}>
                                                                    <label className="d-flex">
                                                                        <input type="checkbox" select={data.isSelect}
                                                                            checked={data.isSelect} value={data.Code}
                                                                            onChange={(e) => this.onSelectDates(e, 1)}
                                                                        />
                                                                        {data.VisitDate}
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {!(parseInt(this.state.countryIdModal) == parseInt(sessionStorage.getItem('ExhibitionCountryID'))) && this.showMandatoryFields(35, 0) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m9"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m9"
                                        >   Visa Application
                                            {needVisaAssistanceModal && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.visaErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m9">
                                        <div className="accordion-body">
                                            <div className="one-section">
                                                {/* <div className="containerfluid">
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <div className="p-1 title-bg d-flex">
                                            <p className="mb-0">
                                                Visa Application
                                                {needVisaAssistanceModal && this.showMandatoryFields(35, 2) && <span className="text-red">*</span>}
                                            </p>
                                            {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.visaErrModal}</span>}
                                        </div>

                                    </div>
                                </div>
                            </div> */}

                                                <div className="col-sm-12 ">
                                                    <div className="row mt-2">
                                                        <label className="d-flex">
                                                            <input type="checkbox" name="fav_language"
                                                                select={needVisaAssistanceModal} checked={needVisaAssistanceModal}
                                                                onChange={() => this.setState({
                                                                    needVisaAssistanceModal: !needVisaAssistanceModal,
                                                                    applicantMobNoModal: applicantMobNoModal != '' && applicantMobNoModal != null ? applicantMobNoModal : this.state.mobNoModal,
                                                                    applicantEmailModal: applicantEmailModal != '' && applicantEmailModal != null ? applicantEmailModal : this.state.emailModal,
                                                                    preApplicantMobNoModal: preApplicantMobNoModal != '' && preApplicantMobNoModal != null ? preApplicantMobNoModal : this.state.preMobNoModal,
                                                                    visaErrModal: '',
                                                                })}
                                                            />
                                                            Do you need Visa Invitation Letter?
                                                        </label>
                                                    </div>
                                                </div>
                                                {
                                                    needVisaAssistanceModal &&
                                                    <div
                                                        className="col-md-12 mb-2"
                                                        id="divMsg"
                                                    >
                                                        <div className="row">
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Name as per Passport<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={passNameModal} maxLength={'50'}
                                                                    onChange={(e) => !/^[a-zA-Z\s]+$/.test(e.target.value) && e.target.value != '' ? null : this.setState({ passNameModal: e.target.value, passNameErrModal: '' })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{passNameErrModal}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Applicant mobile number<span className="text-red">*</span>
                                                                </label>

                                                                <div className="phone-input-group">
                                                                    <input placeholder="ISD"
                                                                        type="text"
                                                                        className="form-control phone-code" autoComplete="off" readOnly
                                                                        maxLength={'4'}
                                                                        value={preApplicantMobNoModal}
                                                                    />
                                                                    <input type="text" className="form-control phone-no" value={applicantMobNoModal}
                                                                        maxLength={countryId == 91 ? '10' : '11'}
                                                                        onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                        onPaste={(e) => this.handlePaste(e)}
                                                                        onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                                        onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ applicantMobNoModal: e.target.value, applicantMobNoErrModal: '' }) : null}
                                                                    />
                                                                </div>
                                                                {<span className='text-danger text-start text-left d-block '>{applicantMobNoErrModal}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">
                                                                    Applicant email id<span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={applicantEmailModal} maxLength={'50'}
                                                                    onChange={(e) => this.setState({ applicantEmailModal: e.target.value, applicantEmailErrModal: "" })}
                                                                    onBlur={(e) => this.verifyEmail(e, 3)}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{applicantEmailErrModal}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport No
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <input type="text" className="form-control" value={passNoModal} maxLength={'10'}
                                                                    onChange={(e) => this.setState({ passNoModal: e.target.value, passNoErrModal: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block '>{passNoErrModal}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport issue Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={passDateModal}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            passDateModal: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            passDateErrModal: ""
                                                                        })}
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    maxDate={passExipryDateModal}
                                                                    dropdownMode="select"
                                                                    placeholderText="Passport Issued Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block '>{passDateErrModal}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <label className="mt-3">Passport Expiry Date
                                                                    <span className="text-red">*</span>
                                                                </label>
                                                                <DatePicker selected={passExipryDateModal}
                                                                    onChange={(date) =>
                                                                        this.setState({
                                                                            passExipryDateModal: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                            passExipryDateErrModal: ""
                                                                        })}
                                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                    peekNextMonth
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    minDate={passDateModal}
                                                                    dropdownMode="select"
                                                                    placeholderText="Passport Expiry Date"
                                                                    dayClassName={() => "example-datepicker-day-class"}
                                                                    popperClassName="example-datepicker-class" />
                                                                {<span className='text-danger text-start text-left d-block '>{passExipryDateErrModal}</span>}
                                                            </div>
                                                            <div className="col-xl-3">
                                                                <div className="d-flex">
                                                                    <label className="mt-3 w-auto" >
                                                                        Passport issuing Country
                                                                        <span className="text-red">*</span>

                                                                    </label>
                                                                    {<span className='text-danger text-start text-left d-block '>{passCountryErrModal}</span>}
                                                                </div>
                                                                <select className="form-control" value={passCountryModal}
                                                                    onChange={(e) => this.onCountrySelect(e, 3)}
                                                                >
                                                                    <option>Select Your Country</option>
                                                                    {
                                                                        countryList.length > 0 && countryList.map((data) => (
                                                                            <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            {/* <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={passCountry}
                                                            onChange={(e) => this.onPassportCountrySearch(e)}
                                                        />
                                                        {isDisplayPassCountryList && this.renderPassCountryList()}
                                                        {<span className='text-danger text-start text-left d-block '>{ }</span>}
                                                    </div> */}
                                                            {!(isPassportFilePresentModal) && !isVisaAppliedModal &&
                                                                < div className="col-xl-12">
                                                                    <label className="mt-3">
                                                                        Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                        <span className="text-red">*</span>
                                                                        {<span className='text-danger text-start text-left ms-2' style={{ marginTop: '2px' }}>{passportFileErrModal}</span>}
                                                                    </label>
                                                                    <form action="/action_page.php" style={{ textAlign: 'left', position: 'relative' }}>
                                                                        <input type="file" id="passportFileModal" name="filename"
                                                                            accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                            onChange={e => this.onFilePickModal(e, e.target.files, 1)}
                                                                        />
                                                                        {
                                                                            passportFileModal != "" &&
                                                                            <i class="fa fa-times text-danger img-can" style={{ marginTop: '2px' }} onClick={() => this.onCrossClickModal(1)}></i>
                                                                        }
                                                                    </form>
                                                                </div>
                                                            }
                                                            {
                                                                isVisaAppliedModal && passportFileModal != "" && passportFileModal != null &&
                                                                <div className="col-xl-12">
                                                                    <label className="mt-3">
                                                                        Passport Front Page File
                                                                        <span className="text-red">*</span>
                                                                    </label>
                                                                    <div style={{
                                                                        border: '1px solid #ccc',
                                                                        padding: '10px',
                                                                        alignItems: 'center',
                                                                        marginTop: '10px',
                                                                        maxWidth: '300px'
                                                                    }}>
                                                                        <span style={{ marginRight: '10px' }}
                                                                        >{passPortFileNameModal}</span>
                                                                        <i className="fa fa-times text-danger img-can" style={{ marginTop: '2px' }} onClick={() => this.onCrossClickModal(1, 1)}></i>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.showMandatoryFields(36, 0) &&
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item mb-2">
                                    <h5 className="accordion-header delegate-section-title">
                                        <button className={`accordion-button ${sessionStorage.getItem('AccountTypeID') == 10 ? 'selected-chapter' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapse_l1_m10"
                                            aria-expanded="true"
                                            aria-controls="collapse_l1_m10"
                                        >   Seminar {this.showMandatoryFields(36, 2) && <span className="text-red">*</span>}
                                        </button>
                                    </h5>
                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.SeminarErrModal}</span>}
                                    <div className="accordion-collapse collapse show" id="collapse_l1_m10">
                                        <div className="accordion-body">
                                            <div className="one-section">
                                                <div className="col-md-12">
                                                    {/* <div className="row">
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                               
                                                <div className="p-1 title-bg d-flex">
                                                    <p className="mb-0">
                                                        Seminar
                                                        {this.showMandatoryFields(36, 2) && <span className="text-red">*</span>}
                                                    </p>
                                                    {<span className='text-danger text-start text-left d-block  ml-2' style={{ marginTop: '2px' }}>{this.state.SeminarErrModal}</span>}
                                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                                </div>
                                                <div className="col-md-12">
                                                    <div className="table-responsive" >
                                                        <table className="table border table-bordered mb-0 mt-1" >
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                                    <th style={{ width: '200px' }} className="text-center">Register</th>
                                                                    <th style={{ width: '350px' }}>Date & Time</th>
                                                                    <th >Session Name</th>
                                                                    {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                                    {/* <th style={{ width: '250px' }} className="text-center">Info</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    seminarInterestListModal.length > 0 && seminarInterestListModal.map((data) => (
                                                                        <>
                                                                            {/* {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                                            <td style={{ borderRight: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                        </tr>} */}
                                                                            {data.IsDelegate && <tr key={Math.random()}>
                                                                                {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                                    <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                                    : <></>}
                                                                                <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                                    {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                                        (data.SeminarTypeID == 2 ?
                                                                                            <a
                                                                                                style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                                className="btn btn-aqua me-2"
                                                                                                // type="submit"
                                                                                                onClick={(e) => this.onCheckedSeminar(e, data.SeminarID, 1)}
                                                                                            >
                                                                                                {data.isSelect ? "Withdraw Request" : "Request for Invite"}
                                                                                            </a>
                                                                                            : data.SeminarTypeID == 3 ?

                                                                                                <input
                                                                                                    // style={{ marginTop: '12px' }}
                                                                                                    type="checkbox"
                                                                                                    checked={data.isSelect}
                                                                                                    onChange={(e) =>
                                                                                                        this.setState({
                                                                                                            ChargesPop: !data.isSelect ? true : false,
                                                                                                            seminarCharges: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR - data.INRSGST - data.INRCGST) : (data.PriceINR - data.INRIGST) : data.PriceINR : data.IsGSTIncluded == 1 ? (data.PriceUSD - data.USDIGST) : data.PriceUSD,
                                                                                                            seminarCGST: sessionStorage.getItem("countryId") == 91 ? data.INRCGST : 0,
                                                                                                            seminarSGST: sessionStorage.getItem("countryId") == 91 ? data.INRSGST : 0,
                                                                                                            seminarIGST: sessionStorage.getItem("countryId") == 91 ? data.INRIGST : data.USDIGST,
                                                                                                            TotalPayable: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.PriceINR : data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR + data.INRSGST + data.INRCGST) : (data.PriceINR + data.INRIGST) : data.IsGSTIncluded == 1 ? data.PriceUSD : (data.PriceUSD + data.USDIGST),
                                                                                                        }, () => {
                                                                                                            this.onCheckedSeminar(e, data.SeminarID, 1)
                                                                                                        })
                                                                                                    }
                                                                                                />
                                                                                                :
                                                                                                <input type="checkbox"
                                                                                                    value={data.isSelect}
                                                                                                    checked={data.isSelect}
                                                                                                    onChange={(e) => this.onCheckedSeminar(e, data.SeminarID, 1)}
                                                                                                />)
                                                                                    }
                                                                                </td>
                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.DateTime}</td>
                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.SessionName}{data.SeminarDetailsHtmlRef ? <>&nbsp;<span style={{ cursor: 'pointer' }} className="text-primary" onClick={() => {
                                                                                    this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                }}>Click Here</span> to view more details.</> : ''}</td>
                                                                                {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                                {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                                {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                                {/* <td className="text-center">
                                                                                                                {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                                                    <span onClick={() => {
                                                                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                    }}>
                                                                                                                        <i class="bi bi-info-circle"></i>
                                                                                                                    </span> : <></>}
                                                                                                            </td> */}

                                                                            </tr>}
                                                                        </>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>

                                                        <div />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <div class="form-group text-right mod-fot">
                            <button type="button" class="btn btn-aqua text-white" onClick={() => this.handleAddGroupDetail()}>{this.state.isModalEdit ? 'Update' : 'Add'}</button>
                            <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '10px' }} onClick={() => this.handleCancelModel()}>Cancel</button>
                        </div>
                    </Modal.Footer>
                </Modal >
                <Modal
                    size="lg"
                    show={this.state.isOpen2}
                    aria-labelledby="example-modal-sizes-title-lg"
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-lg">
                            <h5 class="modal-title modal_title_text text-white">Coordinator visiting?</h5>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* <div class="row"> */}
                        <div className="col-md-12">
                            <p>Kindly make sure if the Coordinator will be visiting the Exhibition or the Coordinator will only fill the delegate registration form.</p>
                        </div>
                        {/* </div> */}
                    </Modal.Body>
                    <Modal.Footer>
                        <div class="form-group text-right mod-fot">
                            <button type="button" class="btn btn-aqua text-white" onClick={() => this.toggleModel1(1)}>will Visit the Exhibition</button>
                            <button type="button" class="btn btn-aqua text-white" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.toggleModel1(0)}>only Filling Form</button>
                        </div>
                    </Modal.Footer>
                </Modal>
                <Modal show={isOpen3} >
                    <div class=" modal-md" role="document">
                        <div class="modal-header p-2">
                            <h5 class="modal-title modal_title_text text-danger">Confirm Delete</h5>
                            <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen3: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <p class="pop_label">Do you really want to delete this Document?</p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer p-1">
                            <div class="form-group text-right mod-fot">
                                <button type="button" class="btn btn-aqua" onClick={(e) => this.handleDelete(e)}>Yes</button>
                                <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen3: false })}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.isOpen4} >
                    <div class=" modal-md" role="document">
                        <div class="modal-header p-2" >
                            <h5 class="modal-title modal_title_text text-white">Confirm Delete</h5>
                            {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen4: false, deleteID: '' })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <p class="pop_label">Do you really want to delete this Delagate?</p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer p-1">
                            <div class="form-group text-right mod-fot">
                                <button type="button" class="btn btn-aqua" onClick={(e) => this.handleDeleteDelegate(e)}>Yes</button>
                                <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen4: false, deleteID: '' })}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.HTMLEDITOR} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                {/* <h5 class="modal-title modal_title_text text-Primary">
                                                                </h5> */}
                            </div>
                            <div class="modal-body">
                                <ul className="p-0">
                                    <li dangerouslySetInnerHTML={{ __html: `${this.state.HtmlContent != null ? this.state.HtmlContent : ''}` }}></li>
                                </ul>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            // this.togglePGCharges(2)
                                            this.setState({
                                                HTMLEDITOR: false,
                                            })
                                        }
                                        }
                                    >Ok</button>
                                    {/* <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                                                    >Close</button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
                {console.log("sessionStorage.getItem('DelegateDataSS'))==>", this.state.GroupDetailsList, isPassportFilePresent, isVisaApplied, passportFile)}
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getDelegateDetails_action, getExhibitionProgramMaster_action, getDelegateDetailsUUID_action, deleteDelegate_action, deleteVisaDoc_action, delegateRegistrationNext_action, verifyVisitorEmail_action, delegateRegistrationGroupNext_action, getDelegateFirldList_action })(DelegateRegistration));



